// import React, { useEffect, useRef, useState } from 'react';
// import Header from '../../layouts/Header';
// import { Button, Col, Row, Form, Table, Spinner, Pagination, Dropdown } from 'react-bootstrap';
// import { Modal } from 'react-bootstrap';
// import makeAnimated from "react-select/animated";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { toast } from "react-toastify";
// import { useSelector } from 'react-redux';
// import axiosInstance from '../../api/axios';

// // ─── DatePicker input wrapper — make it inherit inputStyle width ──────────────
// const datepickerWrapStyle = { width: '100%', display: 'block' };

// // ─── Shared style tokens ───────────────────────────────────────────────────────
// const T = {
//     blue: '#185FA5',
//     blueDark: '#0C447C',
//     blueLight: '#E6F1FB',
//     green: '#3B6D11',
//     greenLight: '#EAF3DE',
//     red: '#A32D2D',
//     redLight: '#FCEBEB',
//     amber: '#BA7517',
//     purple: '#534AB7',
//     purpleLight: '#EEEDFE',
//     border: 'rgba(0,0,0,0.10)',
//     borderMid: 'rgba(0,0,0,0.16)',
//     bg: '#F7F7F8',
//     surface: '#FFFFFF',
//     textPrimary: '#1A1A1A',
//     textMuted: '#6B6B6B',
//     textFaint: '#9E9E9E',
// };

// const inputStyle = {
//     height: '34px',
//     border: `0.5px solid ${T.borderMid}`,
//     borderRadius: '4px',
//     fontSize: '13px',
//     padding: '0 10px',
//     fontFamily: 'inherit',
//     color: T.textPrimary,
//     background: T.surface,
//     outline: 'none',
//     width: '100%',
// };

// const labelStyle = {
//     fontSize: '11px',
//     fontWeight: '500',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     color: T.textFaint,
//     marginBottom: '4px',
//     display: 'block',
// };

// const primaryBtn = {
//     height: '34px',
//     padding: '0 16px',
//     borderRadius: '4px',
//     border: `1px solid ${T.blue}`,
//     background: T.blue,
//     color: '#fff',
//     fontSize: '13px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '6px',
//     fontFamily: 'inherit',
// };

// const ghostBtn = {
//     height: '34px',
//     padding: '0 16px',
//     borderRadius: '4px',
//     border: `0.5px solid ${T.borderMid}`,
//     background: T.surface,
//     color: T.textMuted,
//     fontSize: '13px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '6px',
//     fontFamily: 'inherit',
// };

// const dangerBtn = {
//     ...primaryBtn,
//     background: T.red,
//     border: `1px solid ${T.red}`,
// };

// const selectStyles = {
//     control: (p, s) => ({
//         ...p,
//         minHeight: '34px',
//         height: 'auto',
//         border: `0.5px solid ${s.isFocused ? T.blue : T.borderMid}`,
//         borderRadius: '4px',
//         boxShadow: s.isFocused ? `0 0 0 2px rgba(24,95,165,0.12)` : 'none',
//         fontSize: '13px',
//         '&:hover': { borderColor: T.borderMid },
//     }),
//     placeholder: (p) => ({ ...p, color: T.textFaint, fontSize: '13px' }),
//     option: (p, s) => ({
//         ...p,
//         fontSize: '13px',
//         background: s.isSelected ? T.blue : s.isFocused ? T.blueLight : '#fff',
//         color: s.isSelected ? '#fff' : T.textPrimary,
//     }),
// };

// const StatusDot = ({ status }) => {
//     const active = status === 'ACTIVE';
//     return (
//         <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: '500', color: active ? T.green : T.red }}>
//             <span style={{ width: 6, height: 6, borderRadius: '50%', background: active ? T.green : T.red, flexShrink: 0 }} />
//             {active ? 'Active' : 'Inactive'}
//         </span>
//     );
// };

// const orderColor = (type) => {
//     if (type === 'PICKUP') return T.purple;
//     if (type === 'DELIVERY') return T.green;
//     return T.amber;
// };

// const modalHeaderStyle = {
//     borderBottom: `0.5px solid ${T.border}`,
//     padding: '14px 20px',
//     background: T.surface,
// };
// const modalFooterStyle = {
//     borderTop: `0.5px solid ${T.border}`,
//     padding: '12px 20px',
//     display: 'flex',
//     gap: '8px',
//     justifyContent: 'flex-end',
// };

// // ─── Field wrapper — defined OUTSIDE Category so it never remounts on re-render ─
// const Field = ({ label, required, children }) => (
//     <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//         <label style={labelStyle}>
//             {label}{required && <span style={{ color: '#A32D2D', marginLeft: 2 }}>*</span>}
//         </label>
//         {children}
//     </div>
// );

// // ─── File input with a clear (X) button — defined OUTSIDE Category ────────────
// const FileInputField = ({ inputKey, file, onChange, onClear, id, accept = "image/*" }) => (
//     <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//         <input
//             key={inputKey}
//             style={{ ...inputStyle, height: 'auto', padding: '4px 8px', flex: 1 }}
//             type="file"
//             id={id}
//             accept={accept}
//             onChange={onChange}
//         />
//         {file && (
//             <button
//                 type="button"
//                 onClick={onClear}
//                 title="Remove file"
//                 style={{
//                     width: '28px', height: '28px', flexShrink: 0,
//                     border: `0.5px solid ${T.borderMid}`, borderRadius: '4px',
//                     background: T.surface, cursor: 'pointer', color: T.red,
//                     display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 }}
//             >
//                 <i className="ri-close-line" style={{ fontSize: '14px' }} />
//             </button>
//         )}
//     </div>
// );

// // ─── Local (timezone-safe) date formatting helper ──────────────────────────────
// // Using date.toISOString() shifts the date backwards for timezones ahead of UTC
// // (e.g. IST) because it converts local midnight to UTC. Format from local
// // components instead so the displayed date always matches what was picked.
// const formatDateLocal = (date) => {
//     if (!date) return "";
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
// };

// // ─── Display formatter for validity dates coming back from the API ────────────
// // The backend stores validityStartDate at 00:00:00Z and validityEndDate at
// // 23:59:59.999Z for the intended calendar day. Formatting with the browser's
// // LOCAL timezone (toLocaleDateString) shifts the end date into the next day
// // for any timezone ahead of UTC (e.g. IST), since 23:59:59.999Z + 5:30 rolls
// // past midnight. Read the UTC calendar date instead so the displayed date
// // always matches the date that was actually saved.
// const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// const formatDateDisplayUTC = (isoString) => {
//     if (!isoString) return '—';
//     const d = new Date(isoString);
//     if (isNaN(d.getTime())) return '—';
//     const day = String(d.getUTCDate()).padStart(2, '0');
//     const month = MONTHS_SHORT[d.getUTCMonth()];
//     const year = d.getUTCFullYear();
//     return `${day} ${month} ${year}`;
// };

// // ─── Main Component ────────────────────────────────────────────────────────────
// const Category = () => {
//     const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
//     const [skin, setSkin] = useState(currentSkin);
//     const { access } = useSelector((state) => state.login);
//     const { loginEmail } = useSelector((state) => state.login);
//     const email = loginEmail || localStorage.getItem("email");
//     const [menuAccess, setMenuAccess] = useState([]);

//     useEffect(() => {
//         console.log("All Access :", access);

//         if (Array.isArray(access)) {
//             const filteredAccess = access?.filter((perm) => perm?.startsWith("CategoryMgt:"));
//             setMenuAccess(filteredAccess);
//         }
//     }, [access]);

//     console.log("Category Access :", menuAccess);
//     console.log("Email of the admin user :", email);

//     const accessToken = localStorage.getItem("authToken");

//     // 'normal' | 'featured'
//     const [addCategoryType, setAddCategoryType] = useState('normal');

//     const [inputData, setInputData] = useState({ sequenceNumber: "", name: "", description: "", isEventCategory: "", orderType: "ALL" });

//     // Featured category state
//     const [featuredData, setFeaturedData] = useState({ name: "", description: "", sequenceNumber: "", validityStartDate: "", validityEndDate: "", orderType: "ALL" });
//     const [featuredProducts, setFeaturedProducts] = useState([
//         { product: "", sequenceNumber: 1, excludedOutlets: [], includedOutlets: [] }
//     ]);
//     const [isFeaturedLoading, setIsFeaturedLoading] = useState(false);
//     const [filteredProductList, setFilteredProductList] = useState([]);
//     const [activeTab, setActiveTab] = useState('normal');           // 'normal' | 'featured'
//     const [featuredCategoryList, setFeaturedCategoryList] = useState([]);
//     const [isFeaturedListLoading, setIsFeaturedListLoading] = useState(false);
//     // Featured categories tab pagination
//     const [featuredCurrentPage, setFeaturedCurrentPage] = useState(1);
//     const [featuredRowsPerPage] = useState(10);

//     // Featured edit / delete / image states
//     const [openFeaturedEditModal, setOpenFeaturedEditModal] = useState(false);
//     const [openFeaturedDeleteModal, setOpenFeaturedDeleteModal] = useState(false);
//     const [openFeaturedImgModal, setOpenFeaturedImgModal] = useState(false);
//     const [openFeaturedBannerModal, setOpenFeaturedBannerModal] = useState(false);
//     const [selectedFeatured, setSelectedFeatured] = useState(null);
//     const [featuredEditData, setFeaturedEditData] = useState({ id: "", name: "", description: "", sequenceNumber: "", validityStartDate: "", validityEndDate: "", status: "", orderType: "ALL" });
//     const [featuredEditProducts, setFeaturedEditProducts] = useState([]);
//     const [isFeaturedEditLoading, setIsFeaturedEditLoading] = useState(false);
//     const [isFeaturedDeleteLoading, setIsFeaturedDeleteLoading] = useState(false);
//     const [isFeaturedImgLoading, setIsFeaturedImgLoading] = useState(false);
//     const [featuredImage, setFeaturedImage] = useState(null);
//     const [featuredBannerImage, setFeaturedBannerImage] = useState(null);
//     const [searchText, setSearchText] = useState('');
//     const [image, setImage] = useState(null);
//     const [bannerImage, setBannerImage] = useState(null);
//     // Dedicated image state for the "Add Featured Category" form, kept separate
//     // from the normal-category `image`/`bannerImage` state above so that
//     // filling in one tab of the Add modal never leaks its selected files into
//     // the other tab (and vice versa).
//     const [featuredAddImage, setFeaturedAddImage] = useState(null);
//     const [featuredAddBannerImage, setFeaturedAddBannerImage] = useState(null);
//     // Keys used to force-remount the featured-category file inputs so the
//     // native "selected file" label clears when the user hits the X button.
//     const [featuredImgInputKey, setFeaturedImgInputKey] = useState(0);
//     const [featuredBannerInputKey, setFeaturedBannerInputKey] = useState(0);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isEditLoading, setIsEditLoading] = useState(false);
//     const [isDeleteLoading, setIsDeleteLoading] = useState(false);
//     const [isDownloadLoading, setIsDownloadLoading] = useState(false);
//     const [imageId, setImageId] = useState("");
//     const [categoryId, setCategoryId] = useState("");
//     const animatedComponents = makeAnimated();
//     const [outlets, setOutlets] = useState([]);
//     const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
//     const [editedSelectedExOutlets, setEditedSelectedExOutlets] = useState([]);
//     const [openAddModal, setOpenAddModal] = useState(false);
//     const [openEditModal, setOpenEditModal] = useState(false);
//     const [openDeleteModal, setOpenDeleteModal] = useState(false);
//     const [editedData, setEditedData] = useState({});
//     const [filteredData, setFilteredData] = useState([]);
//     const [categoryList, setCategoryList] = useState([]);
//     const [selectedStatus, setSelectedStatus] = useState('');
//     const [showImageModal, setShowImageModal] = useState(false);
//     const [selectedImage, setSelectedImage] = useState(null);
//     const [showBannerImageModal, setShowBannerImageModal] = useState(false);
//     const [openImageUploadModal, setOpenImageUploadModal] = useState(false);
//     const [openBannerImageUploadModal, setOpenBannerImageUploadModal] = useState(false);
//     const [isImageEditBtnLoading, setIsImageEditBtnLoading] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage] = useState(10);
//     const imageInputRef = useRef(null);
//     const isFirstSearchRender = useRef(true);

//     const outletData = outlets.map((outlet) => ({ value: outlet._id, label: `${outlet.name} (${outlet.city})` }));

//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     const paginatedData = filteredData.slice(startIndex, endIndex);
//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//     const handlePageChange = (p) => setCurrentPage(p);

//     // Featured categories tab pagination (derived)
//     const featuredStartIndex = (featuredCurrentPage - 1) * featuredRowsPerPage;
//     const featuredEndIndex = featuredStartIndex + featuredRowsPerPage;
//     const paginatedFeaturedData = featuredCategoryList.slice(featuredStartIndex, featuredEndIndex);
//     const featuredTotalPages = Math.ceil(featuredCategoryList.length / featuredRowsPerPage);
//     const handleFeaturedPageChange = (p) => setFeaturedCurrentPage(p);

//     // ── API calls (unchanged logic) ────────────────────────────────────────────
//     const getOutlets = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("outlet", { headers });
//             if (response?.data?.status === true) setOutlets(response?.data?.data?.outlets);
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false)
//                 toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
//         }
//     };

//     const getCategoryList = async (status = selectedStatus, search = searchText) => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const params = {};
//             if (status && status !== "all") params.status = status;
//             if (search) params.search = search;

//             const response = await axiosInstance.get("masters/category/get", { headers, params });
//             if (response?.data?.status === true) {
//                 response?.data?.data?.categories.forEach((item, index) => { item.serialNumber = index + 1; });
//                 setCategoryList(response?.data?.data?.categories);
//                 setFilteredData(response?.data?.data?.categories); // backend already filtered, no client filter needed
//                 setCurrentPage(1); // reset pagination when filters change
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false)
//                 toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
//         }
//     };

//     const downloadCategoryReport = async () => {
//         setIsDownloadLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("masters/category/get", { headers, params: { isDownload: true }, responseType: 'blob' });
//             const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `Category List.xlsx`);
//             document.body.appendChild(link);
//             link.click();
//             link.parentNode.removeChild(link);
//             window.URL.revokeObjectURL(url);
//             toast.success("Report downloaded.", { position: "top-right", autoClose: 3000, theme: "colored" });
//         } catch (error) {
//             const msg = error.response?.data?.error || "Failed to download report";
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//         } finally { setIsDownloadLoading(false); }
//     };

//     const handleStatusFilter = (e) => {
//         setSelectedStatus(e.target.value);
//         getCategoryList(e.target.value, searchText);
//     };
//     const handleSelectChange = (s) => setSelectedExcludedOutlets(s);
//     const handleEditSelectChange = (s) => setEditedSelectedExOutlets(s);

//     const handleOpenAddModal = () => setOpenAddModal(true);

//     // ── Fully resets everything owned by the Add modal (both the Normal and
//     // Featured forms) so leftover data from one tab never bleeds into the
//     // other, and so a successful submit of either form always leaves a
//     // completely clean slate behind. ─────────────────────────────────────────
//     const resetAddModalState = () => {
//         setBannerImage(null); setImage(null);
//         setInputData({ name: '', description: '', isEventCategory: '', sequenceNumber: '', orderType: 'ALL' });
//         setSelectedExcludedOutlets([]);
//         setAddCategoryType('normal');
//         setFeaturedData({ name: "", description: "", sequenceNumber: "", validityStartDate: "", validityEndDate: "", orderType: "ALL" });
//         setFeaturedProducts([{ product: "", sequenceNumber: 1, excludedOutlets: [], includedOutlets: [] }]);
//         setFeaturedAddImage(null);
//         setFeaturedAddBannerImage(null);
//         setFeaturedImgInputKey((k) => k + 1);
//         setFeaturedBannerInputKey((k) => k + 1);
//     };

//     const handleCloseAddModal = () => {
//         setOpenAddModal(false);
//         resetAddModalState();
//     };

//     const handleOpenEditModal = (data) => {
//         setEditedData({ id: data._id, name: data?.name, sequenceNumber: data?.sequenceNumber, description: data?.description, isEventCategory: data?.isEventCategory, status: data?.status, orderType: data?.orderType });
//         setEditedSelectedExOutlets(data?.excludedOutletDetails?.map((m) => ({ value: m?._id, label: m?.name })));
//         setOpenEditModal(true);
//     };
//     const handleCloseEditModal = () => setOpenEditModal(false);
//     const handleCloseImageModal = () => setShowImageModal(false);

//     const handleImageUploadModal = (data) => { setImage(data?.displayImage); setImageId(data?._id); setOpenImageUploadModal(true); setShowImageModal(false); };
//     const handleOpenDeleteModal = (data) => { setOpenDeleteModal(true); setCategoryId(data?._id); };
//     const handleBannerImageUpload = (data) => { setOpenBannerImageUploadModal(true); setBannerImage(data?.bannerImage); setImageId(data?._id); setShowBannerImageModal(false); };
//     const handleCloseDeleteModal = () => setOpenDeleteModal(false);

//     const handleChange = (e) => { const { name, value } = e.target; setInputData((p) => ({ ...p, [name]: value })); };

//     const handleImageChange = (e) => {
//         const allowed = ["png", "jpg", "jpeg"];
//         const file = e.target.files[0];
//         if (file) {
//             const ext = file.name.split(".").pop().toLowerCase();
//             if (!allowed.includes(ext)) {
//                 toast.error("Invalid file format. Upload only jpg or png.", { position: "top-right", autoClose: 3000, theme: "colored" });
//                 e.target.value = ""; // reset input so re-selecting the same invalid file still fires onChange
//                 return;
//             }
//             setImage(file);
//         }
//     };

//     // Featured-category image picker — also accepts webp and avif in addition
//     // to png/jpg/jpeg, and writes into the dedicated featuredAdd* state so it
//     // never collides with the Normal category form's image state.
//     const handleFeaturedImageChange = (e) => {
//         const allowed = ["png", "jpg", "jpeg", "webp", "avif"];
//         const file = e.target.files[0];
//         if (file) {
//             const ext = file.name.split(".").pop().toLowerCase();
//             if (!allowed.includes(ext)) {
//                 toast.error("Invalid file format. Upload only jpg, png, webp or avif.", { position: "top-right", autoClose: 3000, theme: "colored" });
//                 e.target.value = "";
//                 return;
//             }
//             setFeaturedAddImage(file);
//         }
//     };

//     const handleBannerImageChange = () => {
//         const input = document.getElementById("imageInput");
//         const file = input.files[0];
//         if (file) {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 const img = new Image();
//                 img.src = reader.result;
//                 img.onload = () => {
//                     // if (img.width === 1000 && img.height === 200) 
//                         setBannerImage(file);
//                     // else { alert("Image dimensions must be 1000×200 px"); input.value = ""; }
//                 };
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     // Featured-category banner picker — accepts png/jpg/jpeg/webp/avif, then
//     // still enforces the 1000×200 dimension requirement, and writes into the
//     // dedicated featuredAdd* state.
//     const handleFeaturedBannerImageChange = (e) => {
//         const allowed = ["png", "jpg", "jpeg", "webp", "avif"];
//         const input = e.target;
//         const file = input.files[0];
//         if (file) {
//             const ext = file.name.split(".").pop().toLowerCase();
//             if (!allowed.includes(ext)) {
//                 toast.error("Invalid file format. Upload only jpg, png, webp or avif.", { position: "top-right", autoClose: 3000, theme: "colored" });
//                 input.value = "";
//                 return;
//             }
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 const img = new Image();
//                 img.src = reader.result;
//                 img.onload = () => {
//                     if (img.width === 1000 && img.height === 200) setFeaturedAddBannerImage(file);
//                     else { alert("Image dimensions must be 1000×200 px"); input.value = ""; }
//                 };
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     const handleBannerImageClick = (row) => { setSelectedImage(row); setShowBannerImageModal(true); };
//     const handleImageClick = (row) => { setSelectedImage(row); setShowImageModal(true); };

//     const handleEditBannerImage = () => {
//         const file = imageInputRef?.current?.files[0];
//         if (file) { const reader = new FileReader(); setBannerImage(file); reader.readAsDataURL(file); }
//     };

//     const handleEditImage = async (e) => {
//         e.preventDefault(); setIsImageEditBtnLoading(true);
//         try {
//             const formData = new FormData();
//             formData.append("image", image); formData.append("id", imageId);
//             const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.put("masters/category/update-images", formData, { headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//                 getCategoryList(); setOpenImageUploadModal(false);
//             }
//         } catch (error) {
//             const msg = error.response?.data?.data?.message || error.response?.data?.error;
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//         } finally { setIsImageEditBtnLoading(false); }
//     };

//     const handleBannerEditImage = async (e) => {
//         e.preventDefault(); setIsImageEditBtnLoading(true);
//         try {
//             const formData = new FormData();
//             formData.append("bannerImage", bannerImage); formData.append("id", imageId);
//             const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.put("masters/category/update-images", formData, { headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//                 getCategoryList(); setOpenBannerImageUploadModal(false);
//             }
//         } catch (error) {
//             const msg = error.response?.data?.data?.message || error.response?.data?.error;
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//         } finally { setIsImageEditBtnLoading(false); }
//     };

//     const handleSearchChange = (e) => setSearchText(e.target.value);

//     const addCategory = async (e) => {
//         e.preventDefault(); setIsLoading(true);
//         try {
//             const selectOutlets = selectedExcludedOutlets?.map((v) => v?.value);
//             const formData = new FormData();
//             formData.append("sequenceNumber", inputData.sequenceNumber);
//             formData.append("name", inputData.name);
//             formData.append("isEventCategory", inputData.isEventCategory);
//             formData.append("description", inputData.description);
//             formData.append("orderType", inputData.orderType);
//             formData.append("image", image);
//             formData.append("bannerImage", bannerImage);
//             if (selectOutlets?.length > 0) selectOutlets.forEach((o, i) => formData.append(`excludedOutlets[${i}]`, o));
//             const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.post("masters/category/add", formData, { headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//                 getCategoryList();
//                 setOpenAddModal(false);
//                 resetAddModalState();
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let msg = '';
//                 if (error.response?.status === 406) msg = error?.response?.data?.error?.message || error?.response?.data?.error;
                
//                 else if (error.response?.status === 400) msg = error?.response?.data?.data?.message;
//                 else if (error.response?.status === 412) msg = error?.response?.data?.data?.message;
//                 else if (error.response?.status === 500) msg = error?.response?.data?.error;
//                 else if (error.response?.status === 404) msg = error?.response?.data?.error;
//                 toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//             }
//         } finally { setIsLoading(false); }
//     };

//     // ── Featured category handlers ─────────────────────────────────────────────
//     const handleFeaturedChange = (e) => {
//         const { name, value } = e.target;
//         setFeaturedData((p) => ({ ...p, [name]: value }));
//     };

//     const handleProductRowChange = (index, field, value) => {
//         setFeaturedProducts((prev) => {
//             const updated = [...prev];
//             updated[index] = { ...updated[index], [field]: value };
//             return updated;
//         });
//     };

//     console.log("Featured Products :", featuredProducts);
    

//     const handleProductOutletChange = (index, field, selected) => {
//         setFeaturedProducts((prev) => {
//             const updated = [...prev];
//             updated[index] = { ...updated[index], [field]: selected.map((s) => s.value) };
//             return updated;
//         });
//     };

//     const addProductRow = () => {
//         setFeaturedProducts((prev) => [...prev, { product: "", sequenceNumber: prev.length + 1, excludedOutlets: [], includedOutlets: [] }]);
//     };

//     const removeProductRow = (index) => {
//         setFeaturedProducts((prev) => prev.filter((_, i) => i !== index));
//     };

//     // At least one product row must have a product actually selected before
//     // the "Create Featured" button becomes usable.
//     const hasAtLeastOneSelectedProduct = featuredProducts?.some((p) => p.product && p.product.trim() !== "");

//     const isFeaturedFormInvalid =
//         !featuredAddImage ||
//         !featuredAddBannerImage ||
//         isFeaturedLoading ||
//         featuredData?.description?.trim() === "" ||
//         featuredData?.name?.trim() === "" ||
//         !featuredData?.validityStartDate ||
//         !featuredData?.validityEndDate ||
//         !hasAtLeastOneSelectedProduct;

//     const addFeaturedCategory = async (e) => {
//         e.preventDefault();
//         setIsFeaturedLoading(true);
//         try {
//             // Filter out products that don't have a product selected
//             const validProducts = featuredProducts
//                 .filter(product => product.product && product.product.trim() !== "")
//                 .map((product, index) => ({
//                     ...product,
//                     sequenceNumber: product.sequenceNumber || (index + 1)
//                 }));

//             const formData = new FormData();
//             formData.append("name", featuredData.name);
//             formData.append("description", featuredData.description);
//             formData.append("sequenceNumber", featuredData.sequenceNumber);
//             formData.append("validityStartDate", featuredData.validityStartDate);
//             formData.append("validityEndDate", featuredData.validityEndDate);
//             formData.append("orderType", featuredData.orderType);
//             formData.append("products", JSON.stringify(validProducts));
//             if (featuredAddImage) formData.append("image", featuredAddImage);
//             if (featuredAddBannerImage) formData.append("bannerImage", featuredAddBannerImage);

//             const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.post("featured-category", formData, { headers });

//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message || "Featured category created!", { position: "top-right", autoClose: 3000, theme: "colored" });
//                 setOpenAddModal(false);
//                 resetAddModalState();
//                 getFeaturedCategoryList();
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let msg = error?.response?.data?.error?.message || error?.response?.data?.error || "Failed to create featured category";
//                 toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//             }
//         } finally { setIsFeaturedLoading(false); }
//     };

//     // ── Open featured edit modal ───────────────────────────────────────────────
//     const handleOpenFeaturedEditModal = (fc) => {
//         console.log("Featured Category :", fc);
        
//         setFeaturedEditData({
//             id: fc?._id,
//             name: fc?.name,
//             status: fc?.status,
//             description: fc?.description,
//             sequenceNumber: fc?.sequenceNumber,
//             validityStartDate: fc?.validityStartDate ? fc?.validityStartDate.split('T')[0] : "",
//             validityEndDate: fc?.validityEndDate ? fc?.validityEndDate.split('T')[0] : "",
//             orderType: fc?.orderType || "ALL",
//         });
//         setFeaturedEditProducts(
//             fc.products?.map((p) => ({
//                 product: p.product,
//                 sequenceNumber: p.sequenceNumber,
//                 excludedOutlets: p.excludedOutlets || [],
//                 includedOutlets: p.includedOutlets || [],
//             })) || []
//         );
//         setOpenFeaturedEditModal(true);
//     };

//     const handleFeaturedEditChange = (e) => {
//         const { name, value } = e.target;
//         setFeaturedEditData((p) => ({ ...p, [name]: value }));
//     };

//     const handleEditProductRowChange = (index, field, value) => {
//         setFeaturedEditProducts((prev) => {
//             const updated = [...prev];
//             updated[index] = { ...updated[index], [field]: value };
//             return updated;
//         });
//     };

//     const handleEditProductOutletChange = (index, field, selected) => {
//         setFeaturedEditProducts((prev) => {
//             const updated = [...prev];
//             updated[index] = { ...updated[index], [field]: selected.map((s) => s.value) };
//             return updated;
//         });
//     };

//     const addEditProductRow = () => {
//         setFeaturedEditProducts((prev) => [...prev, { product: "", sequenceNumber: prev.length + 1, excludedOutlets: [], includedOutlets: [] }]);
//     };

//     const removeEditProductRow = (index) => {
//         setFeaturedEditProducts((prev) => prev.filter((_, i) => i !== index));
//     };

//     // PUT /featured-category  (update details)
//     const updateFeaturedCategory = async (e) => {
//         e.preventDefault();
//         setIsFeaturedEditLoading(true);
//         try {
//             // Filter out products that don't have a product selected
//             const validProducts = featuredEditProducts
//                 .filter(product => product.product && product.product.trim() !== "")
//                 .map((product, index) => ({
//                     ...product,
//                     sequenceNumber: product.sequenceNumber || (index + 1)
//                 }));

//             const payload = {
//                 id: featuredEditData.id,
//                 name: featuredEditData.name,
//                 status: featuredEditData.status,
//                 description: featuredEditData.description,
//                 sequenceNumber: Number(featuredEditData.sequenceNumber),
//                 validityStartDate: featuredEditData.validityStartDate,
//                 validityEndDate: featuredEditData.validityEndDate,
//                 orderType: featuredEditData.orderType,
//                 products: validProducts
//             }; 
            
//             const headers = {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${accessToken}`
//             };
//             const response = await axiosInstance.put("featured-category", payload, { headers });
//             console.log("Response of update category :", response);
            
//             if (response?.data?.success === true) {
//                 toast.success(response?.data?.data?.message || "Updated successfully!", {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "light"
//                 });
//                 setOpenFeaturedEditModal(false);
//                 getFeaturedCategoryList();
//             }
//         } catch (error) {
//             console.log("Error in update feature category:", error);
            
//             // const msg = error?.response?.data?.error?.message ||
//             //     error?.response?.data?.error ||
//             //     "Update failed";
//             // toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });

//              if (error?.response) {
//                 let msg = '';
//                 if (error.response?.status === 406) msg = error?.response?.data?.error?.message || error?.response?.data?.error;
//                 else if (error.response?.status === 403) msg = error?.response?.data?.data?.message;
//                 else if (error.response?.status === 412) msg = error?.response?.data?.data?.message;
//                 else if (error.response?.status === 500) msg = error?.response?.data?.error;
//                 toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//             }
//         } finally {
//             setIsFeaturedEditLoading(false);
//         }
//     };

//     // DELETE /featured-category  (body: { _id })
//     const deleteFeaturedCategory = async (e) => {
        
//         e.preventDefault();
//         setIsFeaturedDeleteLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
            
//             const response = await axiosInstance.delete("featured-category", { headers, data: { _id: selectedFeatured?._id } });
//             console.log("Respomse pf Delted Cat :", response);
            
//             // if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message || "Deleted successfully!", { position: "top-right", autoClose: 3000, theme: "colored" });
//                 setOpenFeaturedDeleteModal(false);
//                 setSelectedFeatured(null);
//                 getFeaturedCategoryList();
//             // }
//             // setOpenFeaturedDeleteModal(false);
//         } catch (error) {
//             const msg = error?.response?.data?.error?.message || error?.response?.data?.error || "Delete failed";
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//         } finally { setIsFeaturedDeleteLoading(false); }
//     };

//     // PUT /featured-category/update-images  (image only)
//     const updateFeaturedImage = async (e) => {
//         e.preventDefault();
//         setIsFeaturedImgLoading(true);
//         try {
//             const formData = new FormData();
//             formData.append("id", selectedFeatured?._id);
//             formData.append("image", featuredImage);
//             const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.put("featured-category/update-images", formData, { headers });
//             console.log("Response of Updating Image :", response);
            
//             if (response?.data?.success === true || response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message || "Image updated!", { position: "top-right", autoClose: 3000, theme: "colored" });
//                 setOpenFeaturedImgModal(false);
//                 setFeaturedImage(null);
//                 getFeaturedCategoryList();
//             }
//         } catch (error) {
//             const msg = error?.response?.data?.error?.message || error?.response?.data?.error || "Image update failed";
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//         } finally { setIsFeaturedImgLoading(false); }
//     };

//     // PUT /featured-category/update-images  (bannerImage only)
//     const updateFeaturedBannerImage = async (e) => {
//         e.preventDefault();
//         setIsFeaturedImgLoading(true);
//         try {
//             const formData = new FormData();
//             formData.append("id", selectedFeatured?._id);
//             formData.append("bannerImage", featuredBannerImage);
//             const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.put("featured-category/update-images", formData, { headers });
//             console.log("Response of Updating Banner Image :", response);

//             if (response?.data?.success === true || response?.data?.status === true) {
                
//                 toast.success(response?.data?.data?.message || "Banner Image Updated!", { position: "top-right", autoClose: 3000, theme: "light" });
//                 setOpenFeaturedBannerModal(false);
//                 setFeaturedBannerImage(null);
//                 getFeaturedCategoryList();
//             }
//         } catch (error) {
//             const msg = error?.response?.data?.error?.message || error?.response?.data?.error || "Banner update failed";
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//         } finally { setIsFeaturedImgLoading(false); }
//     };

//     const handleEditChange = (e) => {
//         const { name, value } = e.target;
//         const updated = name === "isComboCategory" ? value === "true" : value;
//         setEditedData((p) => ({ ...p, [name]: updated }));
//     };

//     const editCategory = async (e) => {
//         e.preventDefault(); setIsEditLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const newData = { ...editedData, excludedOutlets: editedSelectedExOutlets?.map((ex) => ex?.value) };
//             const response = await axiosInstance.put("masters/category/update", newData, { headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//                 getCategoryList(); setOpenEditModal(false);
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let msg = '';
//                 if (error.response?.status === 406) msg = error?.response?.data?.error?.message || error?.response?.data?.error;
//                 else if (error.response?.status === 403) msg = error?.response?.data?.data?.message;
//                 else if (error.response?.status === 412) msg = error?.response?.data?.data?.message;
//                 else if (error.response?.status === 500) msg = error?.response?.data?.error;
//                 toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//             }
//         } finally { setIsEditLoading(false); }
//     };

//     const deleteCategory = async (e) => {
//         e.preventDefault(); setIsDeleteLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.delete(`masters/category/delete?id=${categoryId}`, { headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//                 getCategoryList(); setOpenDeleteModal(false);
//             }
//         } catch (error) {
//             let msg = '';
//             if (error.response?.status === 406) msg = error?.response?.data?.error?.message || error?.response?.data?.error;
//             else if (error.response?.status === 403) msg = error?.response?.data?.message;
//             else if (error.response?.status === 412) msg = error?.response?.data?.message;
//             else if (error.response?.status === 500) msg = error?.response?.data?.error;
//             toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
//         } finally { setIsDeleteLoading(false); }
//     };

//     const getProductsList = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("product", { headers });
//             if (response?.data?.status === true) {
//                 setFilteredProductList(response?.data?.data?.products);
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
//             }
//         }
//     };

//     const getFeaturedCategoryList = async () => {
//         setIsFeaturedListLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("featured-category", { headers });
//             if (response?.data?.status === true) {
//                 setFeaturedCategoryList(response?.data?.data?.featuredCategories || []);
//                 setFeaturedCurrentPage(1); // reset pagination whenever the list is refreshed
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
//             }
//         } finally {
//             setIsFeaturedListLoading(false);
//         }
//     };

//     useEffect(() => { getOutlets(); getCategoryList(); getProductsList(); getFeaturedCategoryList(); }, []);
//     useEffect(() => {
//         if (isFirstSearchRender.current) {
//             isFirstSearchRender.current = false;
//             return; // skip firing on initial mount, mount effect already loads data
//         }
//         const timer = setTimeout(() => {
//             getCategoryList(selectedStatus, searchText);
//         }, 500); // 500ms debounce

//         return () => clearTimeout(timer);
//     }, [searchText]);

//     // ─── Render ────────────────────────────────────────────────────────────────
//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />

//             <div className="main main-app p-3 p-lg-4" style={{ background: T.bg, minHeight: '100vh' }}>
//                 <div style={{ background: T.surface, borderRadius: '6px', border: `0.5px solid ${T.border}`, padding: '20px 24px' }}>

//                     {/* ── Page title + Tab switcher ── */}
//                     <div style={{ marginBottom: '20px', paddingBottom: '0', borderBottom: `0.5px solid ${T.border}`, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', background: T.blue, margin: '-20px -24px 20px', padding: '16px 24px 0', borderRadius: '6px 6px 0 0' }}>
//                         <div style={{ paddingBottom: '0' }}>
//                             <p style={{ margin: 0, fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px', color: 'rgba(255,255,255,0.6)' }}>Menu</p>
//                             <h5 style={{ margin: '2px 0 14px', fontSize: '16px', fontWeight: '500', color: '#ffffff' }}>Category Management</h5>
//                         </div>
//                         {/* Tab strip */}
//                         <div style={{ display: 'flex', gap: '0', marginBottom: '-1px' }}>
//                             {[
//                                 { key: 'normal', label: 'Normal Categories' },
//                                 { key: 'featured', label: 'Featured Categories' },
//                             ].map(({ key, label }) => (
//                                 <button
//                                     key={key}
//                                     onClick={() => setActiveTab(key)}
//                                     style={{
//                                         height: '34px', padding: '0 18px',
//                                         border: 'none',
//                                         borderBottom: activeTab === key ? `2px solid #ffffff` : '2px solid transparent',
//                                         background: 'transparent',
//                                         color: activeTab === key ? '#ffffff' : 'rgba(255,255,255,0.55)',
//                                         fontSize: '13px', fontWeight: activeTab === key ? '600' : '400',
//                                         cursor: 'pointer', fontFamily: 'inherit',
//                                         transition: 'color 0.15s, border-color 0.15s',
//                                     }}
//                                 >
//                                     {label}
//                                 </button>
//                             ))}
//                         </div>
//                     </div>

//                     {/* ══════════════════════════════════════════════
//                         TAB: NORMAL CATEGORIES
//                     ══════════════════════════════════════════════ */}
//                     {activeTab === 'normal' && (
//                         <>
//                             {/* Controls bar */}
//                             <div style={{ display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                                     <label style={labelStyle}>Status</label>
//                                     <select style={{ ...inputStyle, width: '140px' }} value={selectedStatus} onChange={handleStatusFilter}>
//                                         <option value="all">All</option>
//                                         <option value="ACTIVE">Active</option>
//                                         <option value="INACTIVE">Inactive</option>
//                                     </select>
//                                 </div>

//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: '200px' }}>
//                                     <label style={labelStyle}>Search</label>
//                                     <div style={{ position: 'relative' }}>
//                                         <i className="ri-search-line" style={{ position: 'absolute', left: '9px', top: '50%', transform: 'translateY(-50%)', color: T.textFaint, fontSize: '14px' }} />
//                                         <input type="text" style={{ ...inputStyle, paddingLeft: '30px' }} value={searchText} onChange={handleSearchChange} placeholder="Search categories…" />
//                                     </div>
//                                 </div>

//                                 <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
//                                     <button style={ghostBtn} onClick={downloadCategoryReport} disabled={isDownloadLoading}>
//                                         {isDownloadLoading
//                                             ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Downloading…</>
//                                             : <><i className="ri-download-line" /> Export</>
//                                         }
//                                     </button>
//                                     {(menuAccess.includes("CategoryMgt:add") || email === "contact@xpansecafe.com") && (
//                                         <button style={primaryBtn} onClick={handleOpenAddModal}>
//                                             <i className="ri-add-line" /> Add Category
//                                         </button>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Normal categories table */}
//                             {(menuAccess.includes("CategoryMgt:get") || email === "contact@xpansecafe.com") && (
//                                 <div style={{ overflowX: 'auto' }}>
//                                     <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
//                                         <thead>
//                                             <tr style={{ borderBottom: `0.5px solid ${T.borderMid}` }}>
//                                                 {['#', 'Banner', 'Image', 'Seq', 'Name', 'Status', 'Description',
//                                                     (menuAccess.includes("CategoryMgt:update") || menuAccess.includes("CategoryMgt:delete") || email === "contact@xpansecafe.com") ? 'Actions' : null
//                                                 ].filter(Boolean).map((h) => (
//                                                     <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontSize: '11px', fontWeight: '500', color: T.textFaint, textTransform: 'uppercase', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
//                                                         {h}
//                                                     </th>
//                                                 ))}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {paginatedData?.map((cat) => (
//                                                 <tr
//                                                     key={cat._id}
//                                                     style={{ borderBottom: `0.5px solid ${T.border}`, verticalAlign: 'middle' }}
//                                                     onMouseEnter={(e) => Array.from(e.currentTarget.cells).forEach(td => td.style.background = T.bg)}
//                                                     onMouseLeave={(e) => Array.from(e.currentTarget.cells).forEach(td => td.style.background = 'transparent')}
//                                                 >
//                                                     <td style={{ padding: '12px 14px', color: T.textFaint, fontSize: '12px' }}>{cat?.serialNumber ?? '—'}</td>
//                                                     <td style={{ padding: '12px 14px' }}>
//                                                         <img src={cat?.bannerImage} alt="Banner" onClick={() => handleBannerImageClick(cat)} style={{ width: '120px', height: '36px', objectFit: 'cover', borderRadius: '3px', border: `0.5px solid ${T.border}`, cursor: 'pointer', display: 'block' }} />
//                                                     </td>
//                                                     <td style={{ padding: '12px 14px' }}>
//                                                         <img src={cat?.displayImage} alt="Category" onClick={() => handleImageClick(cat)} style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: `0.5px solid ${T.border}`, cursor: 'pointer', display: 'block' }} />
//                                                     </td>
//                                                     <td style={{ padding: '12px 14px', color: T.textFaint, fontVariantNumeric: 'tabular-nums', fontSize: '12px' }}>{cat?.sequenceNumber}</td>
//                                                     <td style={{ padding: '12px 14px', minWidth: '140px' }}>
//                                                         <div style={{ fontWeight: '500', color: T.textPrimary }}>{cat?.name}</div>
//                                                         <div style={{ fontSize: '11px', color: cat.isEventCategory ? T.amber : T.textFaint, marginTop: '2px' }}>{cat?.isEventCategory === true ? 'Event outlet' : 'Regular outlet'}</div>
//                                                     </td>
//                                                     <td style={{ padding: '12px 14px', minWidth: '100px' }}>
//                                                         {cat?.status && <StatusDot status={cat.status} />}
//                                                         <div style={{ fontSize: '11px', marginTop: '4px', fontWeight: '500', color: orderColor(cat?.orderType) }}>{cat?.orderType || 'ALL'}</div>
//                                                     </td>
//                                                     <td style={{ padding: '12px 14px', maxWidth: '220px' }}>
//                                                         {cat?.excludedOutletDetails?.length > 0 ? (
//                                                             <div style={{ fontSize: '11px', fontWeight: '500', color: T.purple, marginBottom: '3px' }}>
//                                                                 {cat.excludedOutletDetails.map(o => o?.name?.toLowerCase().trim()).join(', ')}
//                                                             </div>
//                                                         ) : (
//                                                             <div style={{ fontSize: '11px', color: T.textFaint, marginBottom: '3px' }}>No outlets excluded</div>
//                                                         )}
//                                                         <div style={{ fontSize: '12px', color: T.textMuted, lineHeight: '1.5', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{cat?.description}</div>
//                                                     </td>
//                                                     {((menuAccess.includes("CategoryMgt:update") || menuAccess.includes("CategoryMgt:delete")) || email === "contact@xpansecafe.com") && (
//                                                         <td style={{ padding: '12px 14px' }}>
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle size="sm" id={`dd-${cat._id}`} style={{ ...ghostBtn, height: '28px', padding: '0 10px', fontSize: '12px' }} bsPrefix="no-caret">
//                                                                     <i className="ri-more-2-fill" /> Actions
//                                                                 </Dropdown.Toggle>
//                                                                 <Dropdown.Menu style={{ border: `0.5px solid ${T.border}`, borderRadius: '4px', fontSize: '13px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', padding: '4px 0', minWidth: '120px' }}>
//                                                                     {(menuAccess.includes("CategoryMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                         <Dropdown.Item onClick={() => handleOpenEditModal(cat)} style={{ padding: '7px 14px', color: T.blue, fontSize: '13px' }}>
//                                                                             <i className="ri-edit-line" style={{ marginRight: '6px' }} />Edit
//                                                                         </Dropdown.Item>
//                                                                     )}
//                                                                     {(menuAccess.includes("CategoryMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                         <Dropdown.Item onClick={() => handleOpenDeleteModal(cat)} style={{ padding: '7px 14px', color: T.red, fontSize: '13px' }}>
//                                                                             <i className="ri-delete-bin-line" style={{ marginRight: '6px' }} />Delete
//                                                                         </Dropdown.Item>
//                                                                     )}
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </td>
//                                                     )}
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}

//                             {/* Normal pagination */}
//                             {totalPages > 1 && (
//                                 <div style={{ display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '20px' }}>
//                                     {[...Array(totalPages).keys()].map((i) => (
//                                         <button key={i + 1} onClick={() => handlePageChange(i + 1)}
//                                             style={{ width: '30px', height: '30px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', border: `0.5px solid ${i + 1 === currentPage ? T.blue : T.border}`, background: i + 1 === currentPage ? T.blue : T.surface, color: i + 1 === currentPage ? '#fff' : T.textMuted, fontFamily: 'inherit' }}>
//                                             {i + 1}
//                                         </button>
//                                     ))}
//                                 </div>
//                             )}
//                         </>
//                     )}

//                     {/* ══════════════════════════════════════════════
//                         TAB: FEATURED CATEGORIES
//                     ══════════════════════════════════════════════ */}
//                     {activeTab === 'featured' && (
//                         <>
//                             {/* Featured controls bar */}
//                             <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', gap: '8px', marginBottom: '20px' }}>
//                                 <button style={ghostBtn} onClick={getFeaturedCategoryList} disabled={isFeaturedListLoading}>
//                                     {isFeaturedListLoading
//                                         ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Refreshing…</>
//                                         : <><i className="ri-refresh-line" /> Refresh</>
//                                     }
//                                 </button>
//                                 {(menuAccess.includes("CategoryMgt:add") || email === "contact@xpansecafe.com") && (
//                                     <button style={{ ...primaryBtn, background: T.amber, borderColor: T.amber }} onClick={() => { setAddCategoryType('featured'); setOpenAddModal(true); }}>
//                                         <i className="ri-star-line" /> Add Featured
//                                     </button>
//                                 )}
//                             </div>

//                             {/* Featured categories table */}
//                             {isFeaturedListLoading ? (
//                                 <div style={{ display: 'flex', justifyContent: 'center', padding: '40px', color: T.textFaint }}>
//                                     <Spinner animation="border" size="sm" /> <span style={{ marginLeft: '8px', fontSize: '13px' }}>Loading…</span>
//                                 </div>
//                             ) : featuredCategoryList.length === 0 ? (
//                                 <div style={{ textAlign: 'center', padding: '48px 0', color: T.textFaint, fontSize: '13px' }}>
//                                     <i className="ri-star-line" style={{ fontSize: '28px', display: 'block', marginBottom: '8px', opacity: 0.4 }} />
//                                     No featured categories yet
//                                 </div>
//                             ) : (
//                                 <>
//                                 <div style={{ overflowX: 'auto' }}>
//                                     <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
//                                         <thead>
//                                             <tr style={{ borderBottom: `0.5px solid ${T.borderMid}` }}>
//                                                 {['Banner', 'Image', 'Seq', 'Name', 'Validity', 'Status', 'Products', 'Actions'].map((h) => (
//                                                     <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontSize: '11px', fontWeight: '500', color: T.textFaint, textTransform: 'uppercase', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
//                                                         {h}
//                                                     </th>
//                                                 ))}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {paginatedFeaturedData.map((fc) => {
//                                                 const startDate = formatDateDisplayUTC(fc.validityStartDate);
//                                                 const endDate = formatDateDisplayUTC(fc.validityEndDate);
//                                                 const now = new Date();
//                                                 const isLive = fc.status === 'ACTIVE' && new Date(fc.validityStartDate) <= now && new Date(fc.validityEndDate) >= now;
//                                                 return (
//                                                     <tr key={fc._id}
//                                                         style={{ borderBottom: `0.5px solid ${T.border}`, verticalAlign: 'middle' }}
//                                                         onMouseEnter={(e) => Array.from(e.currentTarget.cells).forEach(td => td.style.background = T.bg)}
//                                                         onMouseLeave={(e) => Array.from(e.currentTarget.cells).forEach(td => td.style.background = 'transparent')}
//                                                     >
//                                                         {/* Banner */}
//                                                         <td style={{ padding: '12px 14px' }}>
//                                                             <img src={fc.bannerImage} alt="Banner" onClick={() => { setSelectedFeatured(fc); setOpenFeaturedBannerModal(true); }} style={{ width: '120px', height: '36px', objectFit: 'cover', borderRadius: '3px', border: `0.5px solid ${T.border}`, display: 'block', cursor: 'pointer' }} />
//                                                         </td>
//                                                         {/* Image */}
//                                                         <td style={{ padding: '12px 14px' }}>
//                                                             <img src={fc.displayImage} alt={fc.name} onClick={() => { setSelectedFeatured(fc); setOpenFeaturedImgModal(true); }} style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: `0.5px solid ${T.border}`, display: 'block', cursor: 'pointer' }} />
//                                                         </td>
//                                                         {/* Seq */}
//                                                         <td style={{ padding: '12px 14px', color: T.textFaint, fontSize: '12px', fontVariantNumeric: 'tabular-nums' }}>
//                                                             {fc.sequenceNumber}
//                                                         </td>
//                                                         {/* Name + description */}
//                                                         <td style={{ padding: '12px 14px', minWidth: '160px' }}>
//                                                             <div style={{ fontWeight: '500', color: T.textPrimary }}>{fc.name}</div>
//                                                             <div style={{ fontSize: '11px', color: T.textFaint, marginTop: '2px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{fc.description}</div>
//                                                         </td>
//                                                         {/* Validity */}
//                                                         <td style={{ padding: '12px 14px', minWidth: '160px' }}>
//                                                             <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: T.textMuted }}>
//                                                                 <i className="ri-calendar-line" style={{ color: T.textFaint }} />
//                                                                 {startDate}
//                                                             </div>
//                                                             <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: T.textMuted, marginTop: '3px' }}>
//                                                                 <i className="ri-calendar-check-line" style={{ color: T.textFaint }} />
//                                                                 {endDate}
//                                                             </div>
//                                                             {isLive && (
//                                                                 <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '4px', fontSize: '10px', fontWeight: '600', color: T.green, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                                                                     <span style={{ width: 5, height: 5, borderRadius: '50%', background: T.green }} />Live
//                                                                 </span>
//                                                             )}
//                                                         </td>
//                                                         {/* Status */}
//                                                         <td style={{ padding: '12px 14px' }}>
//                                                             <StatusDot status={fc.status} />
//                                                             <div style={{ fontSize: '11px', marginTop: '4px', fontWeight: '500', color: orderColor(fc?.orderType) }}>{fc?.orderType || 'ALL'}</div>
//                                                         </td>
//                                                         {/* Products */}
//                                                         <td style={{ padding: '12px 14px', minWidth: '200px' }}>
//                                                             {fc.products?.length > 0 ? (
//                                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                                                                     {fc.products.map((p, pi) => (
//                                                                         <div key={p._id} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', padding: '6px 8px', border: `0.5px solid ${T.border}`, borderRadius: '4px', background: T.bg }}>
//                                                                             <span style={{ fontSize: '10px', fontWeight: '600', color: T.textFaint, minWidth: '14px', marginTop: '1px' }}>#{p.sequenceNumber}</span>
//                                                                             <div style={{ flex: 1, minWidth: 0 }}>
//                                                                                 <div style={{ fontSize: '12px', fontWeight: '500', color: T.textPrimary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//                                                                                     {p.productDetail?.name || '—'}
//                                                                                 </div>
//                                                                                 {p.excludedOutletDetails?.length > 0 && (
//                                                                                     <div style={{ fontSize: '10px', color: T.red, marginTop: '2px' }}>
//                                                                                         excl: {p.excludedOutletDetails.map(o => o.name).join(', ')}
//                                                                                     </div>
//                                                                                 )}
//                                                                                 {p.includedOutletDetails?.length > 0 && (
//                                                                                     <div style={{ fontSize: '10px', color: T.green, marginTop: '2px' }}>
//                                                                                         incl: {p.includedOutletDetails.map(o => o.name).join(', ')}
//                                                                                     </div>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             ) : (
//                                                                 <span style={{ fontSize: '12px', color: T.textFaint }}>No products</span>
//                                                             )}
//                                                         </td>
//                                                         {/* Actions */}
//                                                         <td style={{ padding: '12px 14px' }}>
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle size="sm" id={`fdd-${fc._id}`} style={{ ...ghostBtn, height: '28px', padding: '0 10px', fontSize: '12px' }} bsPrefix="no-caret">
//                                                                     <i className="ri-more-2-fill" /> Actions
//                                                                 </Dropdown.Toggle>
//                                                                 <Dropdown.Menu style={{ border: `0.5px solid ${T.border}`, borderRadius: '4px', fontSize: '13px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', padding: '4px 0', minWidth: '140px' }}>
//                                                                     <Dropdown.Item onClick={() => handleOpenFeaturedEditModal(fc)} style={{ padding: '7px 14px', color: T.blue, fontSize: '13px' }}>
//                                                                         <i className="ri-edit-line" style={{ marginRight: '6px' }} />Edit Details
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item onClick={() => { setSelectedFeatured(fc); setOpenFeaturedImgModal(true); }} style={{ padding: '7px 14px', color: T.textMuted, fontSize: '13px' }}>
//                                                                         <i className="ri-image-edit-line" style={{ marginRight: '6px' }} />Update Image
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item onClick={() => { setSelectedFeatured(fc); setOpenFeaturedBannerModal(true); }} style={{ padding: '7px 14px', color: T.textMuted, fontSize: '13px' }}>
//                                                                         <i className="ri-landscape-line" style={{ marginRight: '6px' }} />Update Banner
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Divider style={{ margin: '4px 0', borderColor: T.border }} />
//                                                                     <Dropdown.Item onClick={() => { setSelectedFeatured(fc); setOpenFeaturedDeleteModal(true); }} style={{ padding: '7px 14px', color: T.red, fontSize: '13px' }}>
//                                                                         <i className="ri-delete-bin-line" style={{ marginRight: '6px' }} />Delete
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Featured pagination */}
//                                 {featuredTotalPages > 1 && (
//                                     <div style={{ display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '20px' }}>
//                                         {[...Array(featuredTotalPages).keys()].map((i) => (
//                                             <button key={i + 1} onClick={() => handleFeaturedPageChange(i + 1)}
//                                                 style={{ width: '30px', height: '30px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', border: `0.5px solid ${i + 1 === featuredCurrentPage ? T.amber : T.border}`, background: i + 1 === featuredCurrentPage ? T.amber : T.surface, color: i + 1 === featuredCurrentPage ? '#fff' : T.textMuted, fontFamily: 'inherit' }}>
//                                                 {i + 1}
//                                             </button>
//                                         ))}
//                                     </div>
//                                 )}
//                                 </>
//                             )}
//                         </>
//                     )}
//                 </div>

//                 {/* ── ADD MODAL ── */}
//                 <Modal show={openAddModal} onHide={handleCloseAddModal} size="lg" centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
//                             <span style={{ fontSize: '15px', fontWeight: '500', color: T.textPrimary }}>Add New Category</span>
//                             {/* ── Type switcher ── */}
//                             <div style={{ display: 'inline-flex', border: `0.5px solid ${T.borderMid}`, borderRadius: '4px', overflow: 'hidden', width: 'fit-content' }}>
//                                 {[
//                                     { key: 'normal', label: 'Normal Category' },
//                                     { key: 'featured', label: 'Featured Category' },
//                                 ].map(({ key, label }) => (
//                                     <button
//                                         key={key}
//                                         onClick={() => setAddCategoryType(key)}
//                                         style={{
//                                             height: '30px', padding: '0 16px', border: 'none',
//                                             background: addCategoryType === key ? T.blue : T.surface,
//                                             color: addCategoryType === key ? '#fff' : T.textMuted,
//                                             fontSize: '12px', fontWeight: '500', cursor: 'pointer',
//                                             fontFamily: 'inherit', transition: 'background 0.15s',
//                                             borderRight: key === 'normal' ? `0.5px solid ${T.borderMid}` : 'none',
//                                         }}
//                                     >
//                                         {label}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>
//                     </Modal.Header>

//                     {/* ── NORMAL CATEGORY FORM ── */}
//                     {addCategoryType === 'normal' && (
//                         <>
//                             <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px' }}>
//                                     <Field label="Category Name" required>
//                                         <input style={inputStyle} name="name" value={inputData.name} type="text" placeholder="e.g. Hot Classics" onChange={handleChange} />
//                                     </Field>
//                                     <Field label="Sequence No." required>
//                                         <input style={inputStyle} name="sequenceNumber" value={inputData.sequenceNumber} type="number" placeholder="e.g. 100" onChange={handleChange} />
//                                     </Field>
//                                     <Field label="Outlet Type" required>
//                                         <select style={inputStyle} name="isEventCategory" value={inputData.isEventCategory} onChange={handleChange}>
//                                             <option value="">Select type</option>
//                                             <option value="false">Regular outlet</option>
//                                             <option value="true">Event outlet</option>
//                                         </select>
//                                     </Field>
//                                 </div>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '14px' }}>
//                                     <Field label="Order Type" required>
//                                         <select style={inputStyle} name="orderType" value={inputData.orderType} onChange={handleChange}>
//                                             <option value="ALL">All</option>
//                                             <option value="DELIVERY">Delivery</option>
//                                             <option value="PICKUP">Pick-up</option>
//                                         </select>
//                                     </Field>
//                                     <Field label="Excluded Outlets">
//                                         <Select isMulti components={animatedComponents} value={selectedExcludedOutlets} onChange={handleSelectChange} options={outletData} styles={selectStyles} placeholder="Select outlets to exclude…" closeMenuOnSelect={false} />
//                                     </Field>
//                                 </div>
//                                 <Field label="Description" required>
//                                     <textarea style={{ ...inputStyle, height: '72px', padding: '8px 10px', resize: 'vertical' }} name="description" value={inputData.description} placeholder="Brief description of this category" onChange={handleChange} />
//                                 </Field>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
//                                     <Field label="Banner Image (1000×200 px)" required>
//                                         <input style={{ ...inputStyle, height: 'auto', padding: '4px 8px' }} type="file" id="imageInput" accept="image/*" onChange={handleBannerImageChange} />
//                                         <span style={{ fontSize: '11px', color: T.red, marginTop: '2px' }}>Dimensions must be exactly 1000×200 px</span>
//                                     </Field>
//                                     <Field label="Category Image" required>
//                                         <input style={{ ...inputStyle, height: 'auto', padding: '4px 8px' }} type="file" accept="image/*" onChange={handleImageChange} />
//                                     </Field>
//                                 </div>
//                             </Modal.Body>
//                             <Modal.Footer style={modalFooterStyle}>
//                                 <button style={ghostBtn} onClick={handleCloseAddModal}>Cancel</button>
//                                 <button style={primaryBtn} onClick={addCategory}>
//                                     {isLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Add Category'}
//                                 </button>
//                             </Modal.Footer>
//                         </>
//                     )}

//                     {/* ── FEATURED CATEGORY FORM ── */}
//                     {addCategoryType === 'featured' && (
//                         <>
//                             <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

//                                 {/* Basic info */}
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px' }}>
//                                     <Field label="Collection Name" required>
//                                         <input style={inputStyle} name="name" value={featuredData.name} type="text" placeholder="e.g. Summer Collection" onChange={handleFeaturedChange} />
//                                     </Field>
//                                     <Field label="Sequence No." required>
//                                         <input style={inputStyle} name="sequenceNumber" value={featuredData.sequenceNumber} type="number" placeholder="e.g. 1" onChange={handleFeaturedChange} />
//                                     </Field>
//                                     <Field label="Order Type" required>
//                                         <select style={inputStyle} name="orderType" value={featuredData.orderType} onChange={handleFeaturedChange}>
//                                             <option value="ALL">All</option>
//                                             <option value="DELIVERY">Delivery</option>
//                                             <option value="PICKUP">Pick-up</option>
//                                         </select>
//                                     </Field>
//                                 </div>

//                                 {/* Validity dates */}
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
//                                     <Field label="Validity Start Date" required>
//                                         <DatePicker
//                                             selected={featuredData.validityStartDate ? new Date(`${featuredData.validityStartDate}T00:00:00`) : null}
//                                             onChange={(date) => setFeaturedData((p) => ({ ...p, validityStartDate: date ? formatDateLocal(date) : "" }))}
//                                             dateFormat="yyyy-MM-dd"
//                                             placeholderText="Select start date"
//                                             minDate={new Date()}
//                                             isClearable
//                                             customInput={<input style={inputStyle} readOnly />}
//                                             wrapperStyle={{ width: '100%' }}
//                                             popperPlacement="bottom-start"
//                                         />
//                                     </Field>
//                                     <Field label="Validity End Date" required>
//                                         <DatePicker
//                                             selected={featuredData.validityEndDate ? new Date(`${featuredData.validityEndDate}T00:00:00`) : null}
//                                             onChange={(date) => setFeaturedData((p) => ({ ...p, validityEndDate: date ? formatDateLocal(date) : "" }))}
//                                             dateFormat="yyyy-MM-dd"
//                                             placeholderText="Select end date"
//                                             minDate={featuredData.validityStartDate ? new Date(`${featuredData.validityStartDate}T00:00:00`) : new Date()}
//                                             isClearable
//                                             customInput={<input style={inputStyle} readOnly />}
//                                             wrapperStyle={{ width: '100%' }}
//                                             popperPlacement="bottom-start"
//                                         />
//                                     </Field>
//                                 </div>

//                                 <Field label="Description" required>
//                                     <textarea style={{ ...inputStyle, height: '66px', padding: '8px 10px', resize: 'vertical' }} name="description" value={featuredData.description} placeholder="e.g. Featured products for summer season" onChange={handleFeaturedChange} />
//                                 </Field>

//                                 {/* Images */}
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
//                                     <Field label="Banner Image (1000×200 px)" required>
//                                         <FileInputField
//                                             inputKey={featuredBannerInputKey}
//                                             file={featuredAddBannerImage}
//                                             id="featuredBannerImageInput"
//                                             accept="image/png,image/jpeg,image/webp,image/avif"
//                                             onChange={handleFeaturedBannerImageChange}
//                                             onClear={() => { setFeaturedAddBannerImage(null); setFeaturedBannerInputKey((k) => k + 1); }}
//                                         />
//                                         <span style={{ fontSize: '11px', color: T.red, marginTop: '2px' }}>Dimensions must be exactly 1000×200 px. jpg, png, webp or avif.</span>
//                                     </Field>
//                                     <Field label="Category Image" required>
//                                         <FileInputField
//                                             inputKey={featuredImgInputKey}
//                                             file={featuredAddImage}
//                                             id="featuredCategoryImageInput"
//                                             accept="image/png,image/jpeg,image/webp,image/avif"
//                                             onChange={handleFeaturedImageChange}
//                                             onClear={() => { setFeaturedAddImage(null); setFeaturedImgInputKey((k) => k + 1); }}
//                                         />
//                                         <span style={{ fontSize: '11px', color: T.textFaint, marginTop: '2px' }}>jpg, png, webp or avif.</span>
//                                     </Field>
//                                 </div>

//                                 {/* Products section */}
//                                 <div>
//                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
//                                         <label style={{ ...labelStyle, marginBottom: 0 }}>
//                                             Products <span style={{ color: T.red }}>*</span>
//                                         </label>
//                                         <button style={{ ...ghostBtn, height: '26px', padding: '0 10px', fontSize: '12px' }} onClick={addProductRow}>
//                                             <i className="ri-add-line" /> Add Products
//                                         </button>
//                                     </div>
//                                     {!hasAtLeastOneSelectedProduct && (
//                                         <div style={{ fontSize: '11px', color: T.red, marginBottom: '8px' }}>
//                                             Select at least one product to create this featured category.
//                                         </div>
//                                     )}

//                                     {/* Column headers */}
//                                     <div style={{ display: 'grid', gridTemplateColumns: '2fr 80px 1fr 1fr 36px', gap: '8px', marginBottom: '6px', padding: '0 2px' }}>
//                                         {['Product', 'Seq', 'Excluded Outlets', 'Included Outlets', ''].map((h) => (
//                                             <span key={h} style={{ ...labelStyle, marginBottom: 0 }}>{h}</span>
//                                         ))}
//                                     </div>

//                                     {/* Product rows */}
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                         {featuredProducts?.map((row, idx) => (
//                                             <div key={idx} style={{ display: 'grid', gridTemplateColumns: '2fr 80px 1fr 1fr 36px', gap: '8px', alignItems: 'center' }}>
//                                                 <Select
//                                                     options={filteredProductList?.map((rm) => ({
//                                                         value: rm?._id,
//                                                         label: rm?.name,
//                                                     }))}
//                                                     value={
//                                                         row.product
//                                                             ? {
//                                                                 value: row.product,
//                                                                 label: filteredProductList?.find((rm) => rm._id === row.product)?.name || row.product,
//                                                             }
//                                                             : null
//                                                     }
//                                                     onChange={(sel) => handleProductRowChange(idx, 'product', sel ? sel.value : "")}
//                                                     components={animatedComponents}
//                                                     styles={{ ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '34px' }) }}
//                                                     placeholder="Select product…"
//                                                     isClearable
//                                                 />
//                                                 <input
//                                                     style={{ ...inputStyle, fontSize: '12px' }}
//                                                     type="number"
//                                                     value={row.sequenceNumber}
//                                                     min={1}
//                                                     onChange={(e) => handleProductRowChange(idx, 'sequenceNumber', Number(e.target.value))}
//                                                 />
//                                                 <Select
//                                                     isMulti
//                                                     components={animatedComponents}
//                                                     value={outletData.filter(o => row.excludedOutlets.includes(o.value))}
//                                                     onChange={(sel) => handleProductOutletChange(idx, 'excludedOutlets', sel)}
//                                                     options={outletData}
//                                                     styles={{ ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '34px' }) }}
//                                                     placeholder="Excluded…"
//                                                     closeMenuOnSelect={false}
//                                                 />
//                                                 <Select
//                                                     isMulti
//                                                     components={animatedComponents}
//                                                     value={outletData.filter(o => row.includedOutlets.includes(o.value))}
//                                                     onChange={(sel) => handleProductOutletChange(idx, 'includedOutlets', sel)}
//                                                     options={outletData}
//                                                     styles={{ ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '34px' }) }}
//                                                     placeholder="Included…"
//                                                     closeMenuOnSelect={false}
//                                                 />
//                                                 <button
//                                                     onClick={() => removeProductRow(idx)}
//                                                     disabled={featuredProducts.length === 1}
//                                                     style={{ width: '36px', height: '34px', border: `0.5px solid ${T.borderMid}`, borderRadius: '4px', background: T.surface, cursor: featuredProducts.length === 1 ? 'not-allowed' : 'pointer', color: T.red, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: featuredProducts.length === 1 ? 0.4 : 1 }}
//                                                 >
//                                                     <i className="ri-delete-bin-line" style={{ fontSize: '14px' }} />
//                                                 </button>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </Modal.Body>

//                             <Modal.Footer style={modalFooterStyle}>
//                                 <button style={ghostBtn} onClick={handleCloseAddModal}>Cancel</button>
//                                 <button
//                                     style={{
//                                         ...primaryBtn,
//                                         background: T.amber,
//                                         borderColor: T.amber,
//                                         opacity: isFeaturedFormInvalid ? 0.5 : 1,
//                                         cursor: isFeaturedFormInvalid ? 'not-allowed' : 'pointer',
//                                     }}
//                                     onClick={addFeaturedCategory}
//                                     disabled={isFeaturedFormInvalid}
//                                 >
//                                     {isFeaturedLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <><i className="ri-star-line" /> Create Featured</>}
//                                 </button>
//                             </Modal.Footer>
//                         </>
//                     )}
//                 </Modal>

//                 {/* ── EDIT MODAL ── */}
//                 <Modal show={openEditModal} onHide={handleCloseEditModal} size="lg" centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Update Category</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '14px' }}>
//                             <Field label="Category Name" required>
//                                 <input style={inputStyle} name="name" value={editedData?.name} type="text" placeholder="Category name" onChange={handleEditChange} />
//                             </Field>
//                             <Field label="Seq No." required>
//                                 <input style={inputStyle} name="sequenceNumber" value={editedData?.sequenceNumber} type="number" onChange={handleEditChange} />
//                             </Field>
//                             <Field label="Outlet Type" required>
//                                 <select style={inputStyle} name="isEventCategory" value={editedData?.isEventCategory} onChange={handleEditChange}>
//                                     <option value="">Select</option>
//                                     <option value="false">Regular outlet</option>
//                                     <option value="true">Event outlet</option>
//                                 </select>
//                             </Field>
//                             <Field label="Status" required>
//                                 <select style={inputStyle} name="status" value={editedData?.status} onChange={handleEditChange}>
//                                     <option value="">Select status</option>
//                                     <option value="ACTIVE">Active</option>
//                                     <option value="INACTIVE">Inactive</option>
//                                 </select>
//                             </Field>
//                         </div>
//                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: '14px' }}>
//                             <Field label="Order Type" required>
//                                 <select style={inputStyle} name="orderType" value={editedData.orderType || ""} onChange={handleEditChange}>
//                                     <option value="" disabled>Select</option>
//                                     <option value="ALL">All</option>
//                                     <option value="DELIVERY">Delivery</option>
//                                     <option value="PICKUP">Pick-up</option>
//                                 </select>
//                             </Field>
//                             <Field label="Combo Category" required>
//                                 <select style={inputStyle} name="isComboCategory" value={editedData?.isComboCategory} onChange={handleEditChange}>
//                                     <option value="">Select</option>
//                                     <option value="true">Yes</option>
//                                     <option value="false">No</option>
//                                 </select>
//                             </Field>
//                             <Field label="Excluded Outlets">
//                                 <Select isMulti components={animatedComponents} value={editedSelectedExOutlets} onChange={handleEditSelectChange} options={outletData} styles={selectStyles} placeholder="Select outlets to exclude…" closeMenuOnSelect={false} />
//                             </Field>
//                         </div>
//                         <Field label="Description" required>
//                             <textarea style={{ ...inputStyle, height: '72px', padding: '8px 10px', resize: 'vertical' }} name="description" value={editedData.description} placeholder="Brief description" onChange={handleEditChange} />
//                         </Field>
//                     </Modal.Body>
//                     <Modal.Footer style={modalFooterStyle}>
//                         <button style={ghostBtn} onClick={handleCloseEditModal}>Cancel</button>
//                         <button style={primaryBtn} onClick={editCategory}>
//                             {isEditLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save Changes'}
//                         </button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* ── DELETE MODAL ── */}
//                 <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Delete Category</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', fontSize: '14px', color: T.textMuted }}>
//                         This will permanently delete the category. This action cannot be undone.
//                     </Modal.Body>
//                     <Modal.Footer style={modalFooterStyle}>
//                         <button style={ghostBtn} onClick={handleCloseDeleteModal}>Cancel</button>
//                         <button style={dangerBtn} onClick={deleteCategory}>
//                             {isDeleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Delete'}
//                         </button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* ── IMAGE PREVIEW MODAL ── */}
//                 <Modal show={showImageModal} onHide={handleCloseImageModal} centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Category Image</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', textAlign: 'center' }}>
//                         {selectedImage ? (
//                             <>
//                                 <img src={selectedImage?.displayImage} alt="preview" style={{ width: '50%', height: 'auto', borderRadius: '50%', border: `0.5px solid ${T.border}` }} />
//                                 <div style={{ marginTop: '16px' }}>
//                                     <button style={ghostBtn} onClick={() => handleImageUploadModal({ displayImage: selectedImage?.displayImage, _id: selectedImage?._id })}>
//                                         <i className="ri-image-edit-line" /> Change Image
//                                     </button>
//                                 </div>
//                             </>
//                         ) : (
//                             <p style={{ color: T.textFaint }}>No image uploaded.</p>
//                         )}
//                     </Modal.Body>
//                 </Modal>

//                 {/* ── BANNER PREVIEW MODAL ── */}
//                 <Modal show={showBannerImageModal} onHide={() => setShowBannerImageModal(false)} centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Banner Image</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px' }}>
//                         {selectedImage ? (
//                             <>
//                                 <img src={selectedImage?.bannerImage} alt="banner preview" style={{ width: '100%', height: 'auto', borderRadius: '3px', border: `0.5px solid ${T.border}` }} />
//                                 <div style={{ marginTop: '14px' }}>
//                                     <button style={ghostBtn} onClick={() => handleBannerImageUpload({ bannerImage: selectedImage?.bannerImage, _id: selectedImage?._id })}>
//                                         <i className="ri-image-edit-line" /> Change Banner
//                                     </button>
//                                 </div>
//                             </>
//                         ) : (
//                             <p style={{ color: T.textFaint }}>No banner image uploaded.</p>
//                         )}
//                     </Modal.Body>
//                 </Modal>

//                 {/* ── UPDATE BANNER IMAGE MODAL ── */}
//                 {openBannerImageUploadModal && (
//                     <Modal show={openBannerImageUploadModal} onHide={() => setOpenBannerImageUploadModal(false)} centered backdrop="static">
//                         <Modal.Header closeButton style={modalHeaderStyle}>
//                             <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Update Banner Image</Modal.Title>
//                         </Modal.Header>
//                         <Modal.Body style={{ padding: '20px' }}>
//                             <Field label="Choose File">
//                                 <input style={{ ...inputStyle, height: 'auto', padding: '4px 8px' }} type="file" id="imageInput" accept="image/*" onChange={handleEditBannerImage} ref={imageInputRef} />
//                                 <span style={{ fontSize: '11px', color: T.red, marginTop: '4px' }}>Dimensions must be exactly 1000×200 px</span>
//                             </Field>
//                         </Modal.Body>
//                         <Modal.Footer style={modalFooterStyle}>
//                             <button style={{ ...primaryBtn, opacity: !(bannerImage instanceof File) ? 0.5 : 1, cursor: !(bannerImage instanceof File) ? 'not-allowed' : 'pointer' }} onClick={handleBannerEditImage} disabled={!(bannerImage instanceof File)}>
//                                 {isImageEditBtnLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save Changes'}
//                             </button>
//                         </Modal.Footer>
//                     </Modal>
//                 )}

//                 {/* ── UPDATE IMAGE MODAL ── */}
//                 {openImageUploadModal && (
//                     <Modal show={openImageUploadModal} onHide={() => setOpenImageUploadModal(false)} centered backdrop="static">
//                         <Modal.Header closeButton style={modalHeaderStyle}>
//                             <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Update Category Image</Modal.Title>
//                         </Modal.Header>
//                         <Modal.Body style={{ padding: '20px' }}>
//                             <Field label="Choose File">
//                                 <input style={{ ...inputStyle, height: 'auto', padding: '4px 8px' }} type="file" accept="image/*" onChange={handleImageChange} />
//                             </Field>
//                         </Modal.Body>
//                         <Modal.Footer style={modalFooterStyle}>
//                             <button style={{ ...primaryBtn, opacity: !(image instanceof File) ? 0.5 : 1, cursor: !(image instanceof File) ? 'not-allowed' : 'pointer' }} onClick={handleEditImage} disabled={!(image instanceof File)}>
//                                 {isImageEditBtnLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save Changes'}
//                             </button>
//                         </Modal.Footer>
//                     </Modal>
//                 )}

//                 {/* ════════════════════════════════════════════════════════════
//                     FEATURED — EDIT DETAILS MODAL
//                 ════════════════════════════════════════════════════════════ */}
//                 <Modal show={openFeaturedEditModal} onHide={() => setOpenFeaturedEditModal(false)} size="lg" centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Update Featured Category</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '14px' }}>
//                             <Field label="Collection Name" required>
//                                 <input style={inputStyle} name="name" value={featuredEditData.name} type="text" placeholder="e.g. Summer Collection" onChange={handleFeaturedEditChange} />
//                             </Field>
//                             <Field label="Sequence No." required>
//                                 <input style={inputStyle} name="sequenceNumber" value={featuredEditData.sequenceNumber} type="number" onChange={handleFeaturedEditChange} />
//                             </Field>
//                             <Field label="Status" required>
//                                 <select style={inputStyle} name="status" value={featuredEditData.status} onChange={handleFeaturedEditChange}>
//                                     <option value="">Select Status</option>
//                                     <option value="ACTIVE">Active</option>
//                                     <option value="INACTIVE">Inactive</option>
//                                 </select>
//                             </Field>
//                             <Field label="Order Type" required>
//                                 <select style={inputStyle} name="orderType" value={featuredEditData.orderType || "ALL"} onChange={handleFeaturedEditChange}>
//                                     <option value="ALL">All</option>
//                                     <option value="DELIVERY">Delivery</option>
//                                     <option value="PICKUP">Pick-up</option>
//                                 </select>
//                             </Field>
//                         </div>
//                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
//                             <Field label="Validity Start Date" required>
//                                 <DatePicker
//                                     selected={featuredEditData.validityStartDate ? new Date(`${featuredEditData.validityStartDate}T00:00:00`) : null}
//                                     onChange={(date) => setFeaturedEditData((p) => ({ ...p, validityStartDate: date ? formatDateLocal(date) : "" }))}
//                                     dateFormat="yyyy-MM-dd" placeholderText="Select start date"
//                                     isClearable customInput={<input style={inputStyle} readOnly />}
//                                     wrapperStyle={{ width: '100%' }} popperPlacement="bottom-start"
//                                 />
//                             </Field>
//                             <Field label="Validity End Date" required>
//                                 <DatePicker
//                                     selected={featuredEditData.validityEndDate ? new Date(`${featuredEditData.validityEndDate}T00:00:00`) : null}
//                                     onChange={(date) => setFeaturedEditData((p) => ({ ...p, validityEndDate: date ? formatDateLocal(date) : "" }))}
//                                     dateFormat="yyyy-MM-dd" placeholderText="Select end date"
//                                     minDate={featuredEditData.validityStartDate ? new Date(`${featuredEditData.validityStartDate}T00:00:00`) : new Date()}
//                                     isClearable customInput={<input style={inputStyle} readOnly />}
//                                     wrapperStyle={{ width: '100%' }} popperPlacement="bottom-start"
//                                 />
//                             </Field>
//                         </div>
//                         <Field label="Description" required>
//                             <textarea style={{ ...inputStyle, height: '66px', padding: '8px 10px', resize: 'vertical' }} name="description" value={featuredEditData.description} placeholder="Brief description" onChange={handleFeaturedEditChange} />
//                         </Field>

//                         {/* Products */}
//                         <div>
//                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
//                                 <label style={{ ...labelStyle, marginBottom: 0 }}>Products <span style={{ color: T.red }}>*</span></label>
//                                 <button style={{ ...ghostBtn, height: '26px', padding: '0 10px', fontSize: '12px' }} onClick={addEditProductRow}>
//                                     <i className="ri-add-line" /> Add Product
//                                 </button>
//                             </div>
//                             <div style={{ display: 'grid', gridTemplateColumns: '2fr 80px 1fr 1fr 36px', gap: '8px', marginBottom: '6px', padding: '0 2px' }}>
//                                 {['Product', 'Seq', 'Excluded Outlets', 'Included Outlets', ''].map((h) => (
//                                     <span key={h} style={{ ...labelStyle, marginBottom: 0 }}>{h}</span>
//                                 ))}
//                             </div>
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                 {featuredEditProducts.map((row, idx) => (
//                                     <div key={idx} style={{ display: 'grid', gridTemplateColumns: '2fr 80px 1fr 1fr 36px', gap: '8px', alignItems: 'center' }}>
//                                         <Select
//                                             options={filteredProductList?.map((rm) => ({ value: rm?._id, label: rm?.name }))}
//                                             value={row.product ? { value: row.product, label: filteredProductList?.find((rm) => rm._id === row.product)?.name || row.product } : null}
//                                             onChange={(sel) => handleEditProductRowChange(idx, 'product', sel ? sel.value : "")}
//                                             components={animatedComponents}
//                                             styles={{ ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '34px' }) }}
//                                             placeholder="Select product…" isClearable
//                                         />
//                                         <input style={{ ...inputStyle, fontSize: '12px' }} type="number" value={row.sequenceNumber} min={1} onChange={(e) => handleEditProductRowChange(idx, 'sequenceNumber', Number(e.target.value))} />
//                                         <Select
//                                             isMulti components={animatedComponents}
//                                             value={outletData.filter(o => row.excludedOutlets.includes(o.value))}
//                                             onChange={(sel) => handleEditProductOutletChange(idx, 'excludedOutlets', sel)}
//                                             options={outletData}
//                                             styles={{ ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '34px' }) }}
//                                             placeholder="Excluded…" closeMenuOnSelect={false}
//                                         />
//                                         <Select
//                                             isMulti components={animatedComponents}
//                                             value={outletData.filter(o => row.includedOutlets.includes(o.value))}
//                                             onChange={(sel) => handleEditProductOutletChange(idx, 'includedOutlets', sel)}
//                                             options={outletData}
//                                             styles={{ ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '34px' }) }}
//                                             placeholder="Included…" closeMenuOnSelect={false}
//                                         />
//                                         <button onClick={() => removeEditProductRow(idx)} disabled={featuredEditProducts.length === 1}
//                                             style={{ width: '36px', height: '34px', border: `0.5px solid ${T.borderMid}`, borderRadius: '4px', background: T.surface, cursor: featuredEditProducts.length === 1 ? 'not-allowed' : 'pointer', color: T.red, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: featuredEditProducts.length === 1 ? 0.4 : 1 }}>
//                                             <i className="ri-delete-bin-line" style={{ fontSize: '14px' }} />
//                                         </button>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </Modal.Body>
//                     <Modal.Footer style={modalFooterStyle}>
//                         <button style={ghostBtn} onClick={() => setOpenFeaturedEditModal(false)}>Cancel</button>
//                         <button style={primaryBtn} onClick={updateFeaturedCategory}>
//                             {isFeaturedEditLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save Changes'}
//                         </button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* ════════════════════════════════════════════════════════════
//                     FEATURED — DELETE MODAL
//                 ════════════════════════════════════════════════════════════ */}
//                 <Modal show={openFeaturedDeleteModal} onHide={() => setOpenFeaturedDeleteModal(false)} centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Delete Featured Category</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', fontSize: '14px', color: T.textMuted }}>
//                         Are you sure you want to delete <strong style={{ color: T.textPrimary }}>{selectedFeatured?.name}</strong>? This action cannot be undone.
//                     </Modal.Body>
//                     <Modal.Footer style={modalFooterStyle}>
//                         <button style={ghostBtn} onClick={() => setOpenFeaturedDeleteModal(false)}>Cancel</button>
//                         <button style={dangerBtn} onClick={deleteFeaturedCategory}>
//                             {isFeaturedDeleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Delete'}
//                         </button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* ════════════════════════════════════════════════════════════
//                     FEATURED — UPDATE IMAGE MODAL
//                 ════════════════════════════════════════════════════════════ */}
//                 <Modal show={openFeaturedImgModal} onHide={() => { setOpenFeaturedImgModal(false); setFeaturedImage(null); }} centered backdrop="static">
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Update Category Image</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
//                         {selectedFeatured?.displayImage && (
//                             <img src={selectedFeatured.displayImage} alt="current" style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', border: `0.5px solid ${T.border}`, alignSelf: 'center' }} />
//                         )}
//                         <Field label="Choose New Image">
//                             <input style={{ ...inputStyle, height: 'auto', padding: '4px 8px' }} type="file" accept="image/png,image/jpeg,image/webp,image/avif" onChange={(e) => setFeaturedImage(e.target.files[0])} />
//                             <span style={{ fontSize: '11px', color: T.textFaint, marginTop: '4px' }}>jpg, png, webp or avif.</span>
//                         </Field>
//                     </Modal.Body>
//                     <Modal.Footer style={modalFooterStyle}>
//                         <button style={ghostBtn} onClick={() => { setOpenFeaturedImgModal(false); setFeaturedImage(null); }}>Cancel</button>
//                         <button style={{ ...primaryBtn, opacity: !featuredImage ? 0.5 : 1, cursor: !featuredImage ? 'not-allowed' : 'pointer' }} onClick={updateFeaturedImage} disabled={!featuredImage}>
//                             {isFeaturedImgLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save Changes'}
//                         </button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* ════════════════════════════════════════════════════════════
//                     FEATURED — UPDATE BANNER IMAGE MODAL
//                 ════════════════════════════════════════════════════════════ */}
//                 <Modal show={openFeaturedBannerModal} onHide={() => { setOpenFeaturedBannerModal(false); setFeaturedBannerImage(null); }} centered backdrop="static" >
//                     <Modal.Header closeButton style={modalHeaderStyle}>
//                         <Modal.Title style={{ fontSize: '15px', fontWeight: '500' }}>Update Banner Image</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
//                         {selectedFeatured?.bannerImage && (
//                             <img src={selectedFeatured.bannerImage} alt="current banner" style={{ width: '100%', height: '60px', objectFit: 'cover', borderRadius: '3px', border: `0.5px solid ${T.border}` }} />
//                         )}
//                         <Field label="Choose New Banner (1000×200 px)">
//                             <input style={{ ...inputStyle, height: 'auto', padding: '4px 8px' }} type="file" accept="image/png,image/jpeg,image/webp,image/avif" onChange={(e) => setFeaturedBannerImage(e.target.files[0])} />
//                             <span style={{ fontSize: '11px', color: T.red, marginTop: '2px' }}>Dimensions must be exactly 1000×200 px. jpg, png, webp or avif.</span>
//                         </Field>
//                     </Modal.Body>
//                     <Modal.Footer style={modalFooterStyle}>
//                         <button style={ghostBtn} onClick={() => { setOpenFeaturedBannerModal(false); setFeaturedBannerImage(null); }}>Cancel</button>
//                         <button style={{ ...primaryBtn, opacity: !featuredBannerImage ? 0.5 : 1, cursor: !featuredBannerImage ? 'not-allowed' : 'pointer' }} onClick={updateFeaturedBannerImage} disabled={!featuredBannerImage}>
//                             {isFeaturedImgLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save Changes'}
//                         </button>
//                     </Modal.Footer>
//                 </Modal>
//             </div>
//         </React.Fragment>
//     );
// };

// export default Category;


// New Code And New Flow
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Header from '../../layouts/Header';
import { Spinner, Modal, Form } from 'react-bootstrap';
import makeAnimated from "react-select/animated";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import axiosInstance from '../../api/axios';

// ═════════════════════════════════════════════════════════════════════════════
// Constants & design tokens
// ═════════════════════════════════════════════════════════════════════════════
const animatedComponents = makeAnimated(); // module-level so react-select never remounts
const ADMIN_EMAIL = "contact@xpansecafe.com";
const TOAST = { position: "top-right", autoClose: 3000, theme: "colored" };

const T = {
    navy: '#0F1D45',
    navy2: '#1A2B63',
    blue: '#2563EB',
    blueDark: '#1D4ED8',
    blueLight: '#EAF1FF',
    green: '#15803D',
    greenLight: '#E7F6EC',
    red: '#DC2626',
    redLight: '#FEECEC',
    amber: '#B45309',
    amberLight: '#FEF3E2',
    purple: '#534AB7',
    border: '#E8EAF0',
    borderMid: '#D5D9E3',
    bg: '#F6F7FB',
    surface: '#FFFFFF',
    textPrimary: '#111827',
    textMuted: '#5B6475',
    textFaint: '#8A93A6',
};

// Food types are dynamic (API driven). Known names keep their classic colours,
// anything new gets a stable colour derived from its name.
const KNOWN_FOOD_COLORS = { 'VEG': '#16A34A', 'NON-VEG': '#DC2626', 'VEGAN': '#0F766E', 'VEG/VEGAN': '#65A30D' };
const FOOD_PALETTE = ['#2563EB', '#9333EA', '#EA580C', '#0891B2', '#CA8A04', '#DB2777', '#4F46E5', '#059669'];
const foodColor = (name) => {
    const key = String(name || '').toUpperCase();
    if (KNOWN_FOOD_COLORS[key]) return KNOWN_FOOD_COLORS[key];
    let h = 0;
    for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
    return FOOD_PALETTE[h % FOOD_PALETTE.length];
};
const foodLabel = (name) => String(name || '')
    .toLowerCase()
    .replace(/(^|[\s\-/])([a-z])/g, (m, a, b) => a + b.toUpperCase())
    .replace(/\//g, ' / ');

const inputStyle = {
    height: '36px',
    border: `1px solid ${T.borderMid}`,
    borderRadius: '6px',
    fontSize: '13px',
    padding: '0 10px',
    fontFamily: 'inherit',
    color: T.textPrimary,
    background: T.surface,
    outline: 'none',
    width: '100%',
};

const labelStyle = {
    fontSize: '11px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: T.textFaint,
    marginBottom: '4px',
    display: 'block',
};

const baseBtn = {
    height: '36px',
    padding: '0 16px',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap',
};
const primaryBtn = { ...baseBtn, border: `1px solid ${T.blue}`, background: T.blue, color: '#fff' };
const ghostBtn = { ...baseBtn, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.textMuted };
const dangerBtn = { ...baseBtn, border: `1px solid ${T.red}`, background: T.red, color: '#fff' };
const iconBtn = {
    width: '32px', height: '32px', borderRadius: '6px', border: 'none', background: 'transparent',
    color: T.textMuted, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0,
};

const selectStyles = {
    control: (p, s) => ({
        ...p,
        minHeight: '36px',
        height: 'auto',
        border: `1px solid ${s.isFocused ? T.blue : T.borderMid}`,
        borderRadius: '6px',
        boxShadow: s.isFocused ? `0 0 0 3px rgba(37,99,235,0.12)` : 'none',
        fontSize: '13px',
        background: s.isDisabled ? '#F3F4F6' : '#fff',
        '&:hover': { borderColor: s.isFocused ? T.blue : T.borderMid },
    }),
    placeholder: (p) => ({ ...p, color: T.textFaint, fontSize: '13px' }),
    option: (p, s) => ({
        ...p,
        fontSize: '13px',
        background: s.isSelected ? T.blue : s.isFocused ? T.blueLight : '#fff',
        color: s.isSelected ? '#fff' : T.textPrimary,
    }),
    menuPortal: (p) => ({ ...p, zIndex: 2000 }),
};
const filterSelectStyles = {
    ...selectStyles,
    control: (p, s) => ({ ...selectStyles.control(p, s), minHeight: '40px', background: T.bg }),
};

const modalHeaderStyle = { borderBottom: `1px solid ${T.border}`, padding: '14px 20px', background: T.surface };
const modalFooterStyle = { borderTop: `1px solid ${T.border}`, padding: '12px 20px', display: 'flex', gap: '8px', justifyContent: 'flex-end', alignItems: 'center' };
const modalBodyStyle = { padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' };
const modalTitleStyle = { fontSize: '15px', fontWeight: '600' };

// ═════════════════════════════════════════════════════════════════════════════
// Pure helpers
// ═════════════════════════════════════════════════════════════════════════════
// Legacy records have no isParentCategory flag → treat them as parents so they
// never disappear from the UI.
const isParentCat = (c) => c?.isParentCategory !== false;
// parentCategory may come back as an id string or as a populated object.
const getParentId = (c) => (c?.parentCategory && typeof c.parentCategory === 'object' ? c.parentCategory._id : c?.parentCategory) || '';

// foodType may be: ["VEG","VEG/VEGAN"] | "VEG" | [{name}] | undefined → always string[]
const toFoodArr = (v) => {
    if (Array.isArray(v)) return v.map((x) => (x && typeof x === 'object' ? x.name : x)).filter(Boolean);
    if (v && typeof v === 'object') return v.name ? [v.name] : [];
    return v ? [v] : [];
};
const mapFood = (obj, fn) => (obj && Array.isArray(obj.foodType) ? { ...obj, foodType: fn(obj.foodType) } : obj);

// Tolerant reader for GET /foodtype responses.
const pickFoodTypes = (res) => {
    const d = res?.data?.data;
    const arr = Array.isArray(d) ? d : (d?.foodTypes || d?.foodtypes || d?.foodType || d?.data || []);
    return (Array.isArray(arr) ? arr : [])
        .map((x) => ({ _id: x?._id || x?.id, name: String(x?.name || '').trim() }))
        .filter((x) => x._id && x.name);
};
const isOk = (res) => res?.data?.status !== false && res?.data?.success !== false;

const getErrMsg = (error, fallback = 'Something went wrong') => {
    const d = error?.response?.data;
    return d?.error?.message || (typeof d?.error === 'string' ? d.error : null) || d?.data?.message || d?.message || fallback;
};

const nextSeq = (list) => String(Math.max(0, ...list.map((c) => Number(c?.sequenceNumber) || 0)) + 1);
const round4 = (n) => Math.round(n * 10000) / 10000;
const fmtSeq = (n) => String(round4(n));

const formatDateLocal = (date) => {
    if (!date) return "";
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// Backend stores 00:00:00Z / 23:59:59.999Z — read the UTC calendar day so IST doesn't shift it.
const formatDateDisplayUTC = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '—';
    return `${String(d.getUTCDate()).padStart(2, '0')} ${MONTHS_SHORT[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
const subLabel = (n) => (n === 0 ? 'no sub categories' : plural(n, 'sub category', 'sub categories'));

// Sub categories have no food type of their own — they inherit the parent's.
const makeMatchers = (f) => {
    const q = (f.search || '').trim().toLowerCase();
    const picked = f.foodType || [];
    return {
        q,
        searchOk: (c) => !q || (c?.name || '').toLowerCase().includes(q),
        attrOk: (c, inherited = []) => {
            const own = toFoodArr(c?.foodType);
            const eff = own.length ? own : inherited;
            return (f.status === 'all' || c?.status === f.status) && (!picked.length || eff.some((n) => picked.includes(n)));
        },
    };
};
const buildTree = (list, f) => {
    const { q, searchOk, attrOk } = makeMatchers(f);
    const byParent = {};
    list.filter((c) => !isParentCat(c)).forEach((c) => {
        const pid = getParentId(c);
        if (!pid) return;
        if (!byParent[pid]) byParent[pid] = [];
        byParent[pid].push(c);
    });
    return list
        .filter(isParentCat)
        .map((p) => {
            const all = byParent[p._id] || [];
            const pSearch = searchOk(p);
            const inherited = toFoodArr(p.foodType);
            const shownSubs = all.filter((s) => attrOk(s, inherited) && (pSearch || searchOk(s)));
            return {
                parent: p,
                total: all.length,
                subs: shownSubs,
                selfOk: attrOk(p) && pSearch,
                autoOpen: !!q && !pSearch && shownSubs.length > 0,
            };
        })
        .filter((r) => r.selfOk || r.subs.length > 0);
};

// ═════════════════════════════════════════════════════════════════════════════
// Small presentational components (all defined OUTSIDE Category)
// ═════════════════════════════════════════════════════════════════════════════
const Field = ({ label, required, hint, error, children }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0 }}>
        <label style={labelStyle}>
            {label}{required && <span style={{ color: T.red, marginLeft: 2 }}>*</span>}
        </label>
        {children}
        {error ? <span style={{ fontSize: '11px', color: T.red }}>{error}</span>
            : hint ? <span style={{ fontSize: '11px', color: T.textFaint }}>{hint}</span> : null}
    </div>
);

const FileInputField = ({ inputKey, file, onChange, onClear, id, accept = "image/*" }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <input key={inputKey} style={{ ...inputStyle, height: 'auto', padding: '5px 8px', flex: 1 }} type="file" id={id} accept={accept} onChange={onChange} />
        {file && (
            <button type="button" onClick={onClear} title="Remove file"
                style={{ width: '30px', height: '30px', flexShrink: 0, border: `1px solid ${T.borderMid}`, borderRadius: '6px', background: T.surface, cursor: 'pointer', color: T.red, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="ri-close-line" style={{ fontSize: '14px' }} />
            </button>
        )}
    </div>
);

const StatusPill = ({ status }) => {
    const active = status === 'ACTIVE';
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '3px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: '600', background: active ? T.greenLight : T.amberLight, color: active ? T.green : T.amber }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: active ? '#22C55E' : '#F59E0B' }} />
            {active ? 'Active' : 'Inactive'}
        </span>
    );
};

// Indian-style veg / non-veg mark: bordered square with a dot.
const FoodMark = ({ color, size = 14 }) => (
    <span style={{ width: size, height: size, border: `1.5px solid ${color}`, borderRadius: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#fff' }}>
        <span style={{ width: size / 2, height: size / 2, borderRadius: '50%', background: color }} />
    </span>
);
const FoodTag = ({ name }) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: '500', color: T.textMuted, whiteSpace: 'nowrap' }}>
        <FoodMark color={foodColor(name)} size={12} />{foodLabel(name)}
    </span>
);
const FoodTags = ({ types, max = 2 }) => {
    const arr = toFoodArr(types);
    if (!arr.length) return null;
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            {arr.slice(0, max).map((n) => <FoodTag key={n} name={n} />)}
            {arr.length > max && (
                <span title={arr.slice(max).map(foodLabel).join(', ')} style={{ fontSize: '11px', fontWeight: '600', color: T.textFaint }}>+{arr.length - max}</span>
            )}
        </span>
    );
};

const Thumb = ({ src, alt, onClick, size = 44 }) => (
    src ? (
        <img src={src} alt={alt || ''} onClick={onClick}
            style={{ width: size, height: Math.round(size * 0.78), objectFit: 'cover', borderRadius: '6px', border: `1px solid ${T.border}`, cursor: onClick ? 'pointer' : 'default', flexShrink: 0, display: 'block' }} />
    ) : (
        <div style={{ width: size, height: Math.round(size * 0.78), borderRadius: '6px', background: T.bg, border: `1px dashed ${T.borderMid}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textFaint, flexShrink: 0 }}>
            <i className="ri-image-line" />
        </div>
    )
);

// Row action menu. Rendered in a portal with fixed coordinates measured at
// click time, so it always opens right under its own button — on the very
// first click too — and is never clipped by the row cards' overflow:hidden.
// (react-bootstrap's Dropdown + Popper placed the menu at the top of the page
// on the first open.)
const KebabMenu = ({ id, items }) => {
    const visible = items.filter(Boolean);
    const btnRef = useRef(null);
    const menuRef = useRef(null);
    const [pos, setPos] = useState(null); // { top, left } or null when closed
    const MENU_W = 190;

    const close = useCallback(() => setPos(null), []);

    const open = () => {
        const r = btnRef.current?.getBoundingClientRect();
        if (!r) return;
        const estH = visible.reduce((h, it) => h + (it.divider ? 9 : 36), 8);
        const flipUp = window.innerHeight - r.bottom < estH + 12 && r.top > estH + 12;
        setPos({
            top: flipUp ? r.top - estH - 4 : r.bottom + 4,
            left: Math.max(8, Math.min(r.right - MENU_W, window.innerWidth - MENU_W - 8)),
        });
    };

    // Once the real menu height is known, make sure it fits on screen.
    useLayoutEffect(() => {
        if (!pos || !menuRef.current || !btnRef.current) return;
        const m = menuRef.current.getBoundingClientRect();
        const r = btnRef.current.getBoundingClientRect();
        if (m.bottom > window.innerHeight - 8) {
            const top = Math.max(8, r.top - m.height - 4);
            if (top !== pos.top) setPos((p) => (p ? { ...p, top } : p));
        }
    }, [pos]);

    useEffect(() => {
        if (!pos) return undefined;
        const onDown = (e) => {
            if (menuRef.current?.contains(e.target) || btnRef.current?.contains(e.target)) return;
            close();
        };
        const onKey = (e) => { if (e.key === 'Escape') close(); };
        window.addEventListener('mousedown', onDown);
        window.addEventListener('keydown', onKey);
        window.addEventListener('resize', close);
        window.addEventListener('scroll', close, true);
        return () => {
            window.removeEventListener('mousedown', onDown);
            window.removeEventListener('keydown', onKey);
            window.removeEventListener('resize', close);
            window.removeEventListener('scroll', close, true);
        };
    }, [pos, close]);

    if (!visible.length) return null;

    return (
        <>
            <button
                type="button" id={id} ref={btnRef} style={iconBtn} aria-label="Actions"
                aria-haspopup="menu" aria-expanded={!!pos}
                onClick={() => (pos ? close() : open())}
            >
                <i className="ri-more-2-fill" style={{ fontSize: '18px' }} />
            </button>
            {pos && createPortal(
                <div
                    ref={menuRef} role="menu"
                    style={{
                        position: 'fixed', top: pos.top, left: pos.left, width: MENU_W, zIndex: 2000,
                        background: T.surface, border: `1px solid ${T.border}`, borderRadius: '8px',
                        fontSize: '13px', boxShadow: '0 8px 24px rgba(15,29,69,0.12)', padding: '4px 0',
                    }}
                >
                    <style>{'.kb-item{display:flex;align-items:center;width:100%;border:0;background:transparent;text-align:left;font-family:inherit;cursor:pointer}.kb-item:hover,.kb-item:focus{background:#f3f5fa;outline:none}'}</style>
                    {visible.map((it, i) => (it.divider
                        ? <div key={`d${i}`} role="separator" style={{ margin: '4px 0', borderTop: `1px solid ${T.border}` }} />
                        : (
                            <button
                                key={it.label} type="button" role="menuitem" className="kb-item"
                                style={{ padding: '8px 14px', color: it.color || T.textPrimary, fontSize: '13px' }}
                                onClick={() => { close(); it.onClick?.(); }}
                            >
                                <i className={it.icon} style={{ marginRight: '8px', color: it.color || T.textFaint }} />{it.label}
                            </button>
                        )))}
                </div>,
                document.body
            )}
        </>
    );
};

const Pager = ({ page, totalPages, onChange }) => {
    if (totalPages <= 1) return null;
    const btn = (active, disabled) => ({
        minWidth: '32px', height: '32px', padding: '0 8px', borderRadius: '6px', fontSize: '12px', fontFamily: 'inherit',
        cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.45 : 1,
        border: `1px solid ${active ? T.blue : T.border}`, background: active ? T.blue : T.surface, color: active ? '#fff' : T.textMuted,
    });
    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '18px' }}>
            <button type="button" style={btn(false, page === 1)} disabled={page === 1} onClick={() => onChange(page - 1)}><i className="ri-arrow-left-s-line" /></button>
            {[...Array(totalPages).keys()].map((i) => (
                <button type="button" key={i + 1} style={btn(i + 1 === page, false)} onClick={() => onChange(i + 1)}>{i + 1}</button>
            ))}
            <button type="button" style={btn(false, page === totalPages)} disabled={page === totalPages} onClick={() => onChange(page + 1)}><i className="ri-arrow-right-s-line" /></button>
        </div>
    );
};

const EmptyState = ({ icon, text, action }) => (
    <div style={{ textAlign: 'center', padding: '48px 0', color: T.textFaint, fontSize: '13px' }}>
        <i className={icon} style={{ fontSize: '30px', display: 'block', marginBottom: '8px', opacity: 0.5 }} />
        {text}
        {action && <div style={{ marginTop: '12px' }}>{action}</div>}
    </div>
);

// Grid header + row shells so every list shares the same card-row look.
const GridHeader = ({ cols, labels }) => (
    <div style={{ display: 'grid', gridTemplateColumns: cols, alignItems: 'center', padding: '10px 14px', background: T.bg, borderRadius: '8px', marginBottom: '8px' }}>
        {labels.map((h, i) => (
            <span key={`${h}-${i}`} style={{ fontSize: '11px', fontWeight: '600', color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</span>
        ))}
    </div>
);
const rowCard = { border: `1px solid ${T.border}`, borderRadius: '8px', marginBottom: '8px', background: T.surface, overflow: 'hidden' };
const rowGrid = (cols) => ({ display: 'grid', gridTemplateColumns: cols, alignItems: 'center', padding: '10px 14px' });

const ExpandToggle = ({ open, onClick, disabled }) => (
    <button type="button" onClick={onClick} disabled={disabled} aria-label={open ? 'Collapse' : 'Expand'}
        style={{ ...iconBtn, width: 24, height: 24, opacity: disabled ? 0.3 : 1, cursor: disabled ? 'default' : 'pointer' }}>
        <i className={open ? 'ri-subtract-line' : 'ri-arrow-down-s-line'} style={{ fontSize: '16px' }} />
    </button>
);

// ─── Sequence picker: shows every taken sequence number in order, with a live
// marker where the typed number lands + one-click "Place after" slots. ────────
const SequencePicker = ({ list, value, onChange, excludeId }) => {
    const boxRef = useRef(null);
    const markRef = useRef(null);

    const items = useMemo(() => (list || [])
        .filter((c) => c?._id !== excludeId && c?.sequenceNumber !== null && c?.sequenceNumber !== undefined && c?.sequenceNumber !== '' && Number.isFinite(Number(c.sequenceNumber)))
        .map((c) => ({ id: c._id, seq: Number(c.sequenceNumber), name: c.name, parent: isParentCat(c), active: c.status === 'ACTIVE' }))
        .sort((a, b) => a.seq - b.seq), [list, excludeId]);

    const raw = String(value ?? '').trim();
    const v = raw === '' ? null : Number(raw);
    const valid = v !== null && Number.isFinite(v);
    const found = valid ? items.findIndex((x) => x.seq > v) : -1;
    const at = valid ? (found === -1 ? items.length : found) : -1; // marker index
    const prev = valid && at > 0 ? items[at - 1] : null;
    const next = valid ? items[at] || null : null;
    const dups = valid ? items.filter((x) => x.seq === v) : [];
    const first = items[0];
    const last = items[items.length - 1];

    // First free number right after items[i] — integer if there is room, otherwise the midpoint.
    const slotAfter = (i) => {
        const cur = items[i].seq;
        const nxt = items.slice(i + 1).find((x) => x.seq > cur)?.seq;
        const base = Math.floor(cur) + 1;
        if (nxt === undefined || base < nxt) return base;
        return round4((cur + nxt) / 2);
    };
    const goStart = () => onChange(String(!first ? 1 : first.seq > 1 ? 1 : round4(first.seq / 2)));
    const goEnd = () => onChange(String(!last ? 1 : Math.floor(last.seq) + 1));

    // Keep the marker in view when its position changes.
    useEffect(() => {
        const box = boxRef.current;
        const m = markRef.current;
        if (!box || !m) return;
        box.scrollTo({ top: Math.max(0, m.offsetTop - box.clientHeight / 2 + m.offsetHeight / 2), behavior: 'smooth' });
    }, [at, valid, items.length]);

    const ref = (it) => <b style={{ color: T.textPrimary }}>{fmtSeq(it.seq)} · {it.name}</b>;
    let where;
    if (!items.length) where = <>First entry — nothing to order against yet.</>;
    else if (!valid) where = <>Type a number, or use <b>Place after</b> on any row.</>;
    else if (!prev) where = <>Goes <b style={{ color: T.blueDark }}>before everything</b>, ahead of {ref(next)}.</>;
    else if (!next) where = <>Goes <b style={{ color: T.blueDark }}>at the end</b>, after {ref(prev)}.</>;
    else where = <>Goes between {ref(prev)} and {ref(next)}.</>;

    const marker = valid && (
        <div key="mark" ref={markRef}
            style={{ display: 'grid', gridTemplateColumns: '64px minmax(0,1fr)', alignItems: 'center', gap: '10px', padding: '7px 12px', margin: '4px 6px', background: T.blueLight, border: `1.5px dashed ${T.blue}`, borderRadius: '6px', fontSize: '12px', fontWeight: '700', color: T.blueDark }}>
            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{fmtSeq(v)}</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}><i className="ri-arrow-right-line" /> Your category goes here</span>
        </div>
    );

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(150px,190px) minmax(0,1fr)', gap: '14px', padding: '14px', background: T.bg, border: `1px solid ${T.border}`, borderRadius: '8px' }}>
            <style>{'.sq-act{opacity:.45;transition:opacity .15s}.sq-row:hover .sq-act,.sq-act:focus{opacity:1;outline:none}.sq-row:hover{background:#F6F7FB}'}</style>

            {/* left: input + quick slots */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Field label="Sequence No." required
                    error={dups.length ? `Already used by ${dups[0].name}${dups.length > 1 ? ` +${dups.length - 1}` : ''}` : undefined}>
                    <input style={{ ...inputStyle, borderColor: dups.length ? T.amber : T.borderMid }} type="number" min={0} step="any"
                        value={value ?? ''} placeholder="e.g. 100" onChange={(e) => onChange(e.target.value)} />
                </Field>
                <div style={{ display: 'flex', gap: '6px' }}>
                    <button type="button" onClick={goStart} style={{ ...ghostBtn, height: '30px', padding: '0 10px', fontSize: '12px', flex: 1 }}><i className="ri-skip-up-line" /> Start</button>
                    <button type="button" onClick={goEnd} style={{ ...ghostBtn, height: '30px', padding: '0 10px', fontSize: '12px', flex: 1 }}><i className="ri-skip-down-line" /> End</button>
                </div>
                {valid && items.length > 0 && (
                    <span style={{ fontSize: '11px', color: T.textFaint }}>Position {at + 1} of {items.length + 1}</span>
                )}
            </div>

            {/* right: ordered list */}
            <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: '12px', color: T.textMuted, marginBottom: '8px', lineHeight: 1.5 }}>{where}</div>
                <div ref={boxRef} style={{ position: 'relative', maxHeight: '176px', overflowY: 'auto', background: T.surface, border: `1px solid ${T.border}`, borderRadius: '8px', padding: '2px 0' }}>
                    {items.length === 0 ? (
                        <div style={{ padding: '18px', textAlign: 'center', fontSize: '12px', color: T.textFaint }}>No sequence numbers in use yet — any number works.</div>
                    ) : (
                        <>
                            {items.map((it, i) => (
                                <React.Fragment key={it.id}>
                                    {valid && at === i && marker}
                                    <div className="sq-row"
                                        style={{ display: 'grid', gridTemplateColumns: '64px minmax(0,1fr) auto auto', alignItems: 'center', gap: '10px', padding: '6px 12px', borderBottom: `1px solid ${T.border}`, opacity: it.active ? 1 : 0.6, background: dups.some((d) => d.id === it.id) ? T.amberLight : 'transparent' }}>
                                        <span style={{ fontSize: '12px', fontWeight: '700', color: T.textPrimary, fontVariantNumeric: 'tabular-nums' }}>{fmtSeq(it.seq)}</span>
                                        <span style={{ fontSize: '12px', color: T.textMuted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: it.parent ? 0 : '8px' }}>
                                            {!it.parent && <i className="ri-corner-down-right-line" style={{ color: T.textFaint, marginRight: 4 }} />}{it.name}
                                        </span>
                                        <span style={{ fontSize: '10px', fontWeight: '600', padding: '1px 7px', borderRadius: '999px', background: it.parent ? T.blueLight : T.bg, color: it.parent ? T.blueDark : T.textFaint }}>{it.parent ? 'Parent' : 'Sub'}</span>
                                        <button type="button" className="sq-act" onClick={() => onChange(String(slotAfter(i)))}
                                            style={{ border: 'none', background: 'transparent', color: T.blue, fontSize: '11px', fontWeight: '600', cursor: 'pointer', padding: '2px 4px', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
                                            Place after
                                        </button>
                                    </div>
                                </React.Fragment>
                            ))}
                            {valid && at === items.length && marker}
                        </>
                    )}
                </div>
                <span style={{ fontSize: '11px', color: T.textFaint, marginTop: '6px', display: 'block' }}>
                    {plural(items.length, 'number', 'numbers')} in use. Lower numbers appear first.
                </span>
            </div>
        </div>
    );
};

// ─── Food type manager (add / rename / delete via /foodtype APIs) ────────────
const FoodTypeManager = ({ show, onHide, items, onAdd, onUpdate, onDelete, canAdd, canEdit, canDelete }) => {
    const [newName, setNewName] = useState('');
    const [editId, setEditId] = useState(null);
    const [editName, setEditName] = useState('');
    const [confirmId, setConfirmId] = useState(null);
    const [busy, setBusy] = useState('');

    useEffect(() => {
        if (!show) { setNewName(''); setEditId(null); setEditName(''); setConfirmId(null); setBusy(''); }
    }, [show]);

    const exists = (name, exceptId) => items.some((i) => i._id !== exceptId && i.name.toLowerCase() === name.toLowerCase());
    const newClean = newName.trim().toUpperCase();
    const newDup = !!newClean && exists(newClean);
    const editClean = editName.trim().toUpperCase();
    const editDup = !!editClean && exists(editClean, editId);

    const submitNew = async (e) => {
        e.preventDefault();
        if (!newClean || newDup || busy) return;
        setBusy('add');
        const ok = await onAdd(newClean);
        setBusy('');
        if (ok) setNewName('');
    };
    const saveEdit = async () => {
        if (!editClean || editDup || busy) return;
        const current = items.find((i) => i._id === editId);
        if (current && current.name === editClean) { setEditId(null); return; }
        setBusy(editId);
        const ok = await onUpdate(editId, editClean);
        setBusy('');
        if (ok) setEditId(null);
    };
    const remove = async (id) => {
        setBusy(id);
        const ok = await onDelete(id);
        setBusy('');
        if (ok) setConfirmId(null);
    };

    return (
        <Modal show={show} onHide={onHide} centered style={{ zIndex: 1100 }} backdropClassName="fx-backdrop">
            <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Manage Food Types</Modal.Title></Modal.Header>
            <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <style>{'.fx-backdrop{z-index:1090 !important}'}</style>
                {canAdd && (
                    <form onSubmit={submitNew} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                            <input style={inputStyle} value={newName} placeholder="New food type, e.g. EGGETARIAN" onChange={(e) => setNewName(e.target.value)} autoFocus />
                            {newDup && <span style={{ fontSize: '11px', color: T.red }}>This food type already exists.</span>}
                        </div>
                        <button type="submit" style={{ ...primaryBtn, opacity: !newClean || newDup || busy ? 0.5 : 1, cursor: !newClean || newDup || busy ? 'not-allowed' : 'pointer' }} disabled={!newClean || newDup || !!busy}>
                            {busy === 'add' ? <Spinner as="span" animation="border" size="sm" /> : <><i className="ri-add-line" /> Add</>}
                        </button>
                    </form>
                )}
                <div style={{ border: `1px solid ${T.border}`, borderRadius: '8px', overflow: 'hidden' }}>
                    {items.length === 0 ? (
                        <div style={{ padding: '24px', textAlign: 'center', fontSize: '13px', color: T.textFaint }}>No food types yet.</div>
                    ) : items.map((it, i) => {
                        const editing = editId === it._id;
                        const confirming = confirmId === it._id;
                        const rowBusy = busy === it._id;
                        return (
                            <div key={it._id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px', borderTop: i ? `1px solid ${T.border}` : 'none', minHeight: 48 }}>
                                {editing ? (
                                    <div style={{ flex: 1 }}>
                                        <input style={{ ...inputStyle, height: '32px' }} value={editName} autoFocus
                                            onChange={(e) => setEditName(e.target.value)}
                                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); saveEdit(); } if (e.key === 'Escape') setEditId(null); }} />
                                        {editDup && <span style={{ fontSize: '11px', color: T.red }}>This food type already exists.</span>}
                                    </div>
                                ) : (
                                    <span style={{ flex: 1, display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500', color: T.textPrimary }}>
                                        <FoodMark color={foodColor(it.name)} />{foodLabel(it.name)}
                                    </span>
                                )}
                                {rowBusy ? <Spinner as="span" animation="border" size="sm" /> : editing ? (
                                    <>
                                        <button type="button" style={{ ...iconBtn, color: T.green }} title="Save" onClick={saveEdit} disabled={!editClean || editDup}><i className="ri-check-line" style={{ fontSize: '18px' }} /></button>
                                        <button type="button" style={iconBtn} title="Cancel" onClick={() => setEditId(null)}><i className="ri-close-line" style={{ fontSize: '18px' }} /></button>
                                    </>
                                ) : confirming ? (
                                    <>
                                        <span style={{ fontSize: '12px', color: T.red }}>Delete?</span>
                                        <button type="button" style={{ ...dangerBtn, height: '28px', padding: '0 10px', fontSize: '12px' }} onClick={() => remove(it._id)}>Yes</button>
                                        <button type="button" style={{ ...ghostBtn, height: '28px', padding: '0 10px', fontSize: '12px' }} onClick={() => setConfirmId(null)}>No</button>
                                    </>
                                ) : (
                                    <>
                                        {canEdit && <button type="button" style={{ ...iconBtn, color: T.blue }} title="Rename" onClick={() => { setEditId(it._id); setEditName(it.name); setConfirmId(null); }}><i className="ri-edit-line" /></button>}
                                        {canDelete && <button type="button" style={{ ...iconBtn, color: T.red }} title="Delete" onClick={() => { setConfirmId(it._id); setEditId(null); }}><i className="ri-delete-bin-line" /></button>}
                                    </>
                                )}
                            </div>
                        );
                    })}
                </div>
                <span style={{ fontSize: '11px', color: T.textFaint }}>Renaming or deleting a food type affects every category that uses it.</span>
            </Modal.Body>
        </Modal>
    );
};

// ─── Hierarchy field group: Food Type (parents only) + Level + Parent dropdown ─
const FoodTypeChips = ({ options, value, onChange, onManage }) => (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
        {options.map((f) => {
            const on = value.includes(f.name);
            const color = foodColor(f.name);
            return (
                <button type="button" key={f._id || f.name}
                    onClick={() => {
                        const next = on ? value.filter((n) => n !== f.name) : [...value, f.name];
                        onChange(options.map((o) => o.name).filter((n) => next.includes(n))); // stable order
                    }}
                    style={{ ...baseBtn, height: '34px', padding: '0 12px', borderColor: on ? color : T.borderMid, background: on ? `${color}14` : T.surface, color: on ? T.textPrimary : T.textMuted, fontWeight: on ? '600' : '500', borderWidth: '1px', borderStyle: 'solid' }}>
                    <FoodMark color={color} />{foodLabel(f.name)}
                    {on && <i className="ri-check-line" style={{ color, fontSize: '14px' }} />}
                </button>
            );
        })}
        {options.length === 0 && <span style={{ fontSize: '12px', color: T.textFaint }}>No food types yet.</span>}
        {onManage && (
            <button type="button" onClick={onManage}
                style={{ ...baseBtn, height: '34px', padding: '0 12px', border: `1px dashed ${T.blue}`, background: 'transparent', color: T.blue }}>
                <i className="ri-settings-3-line" /> Manage
            </button>
        )}
    </div>
);

const LevelToggle = ({ isParent, onChange, lockSub, lockHint }) => (
    <div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
            {[
                { v: true, label: 'Parent', icon: 'ri-folder-3-line' },
                { v: false, label: 'Sub category', icon: 'ri-node-tree' },
            ].map((o) => {
                const on = isParent === o.v;
                const disabled = lockSub && o.v === false;
                return (
                    <button type="button" key={String(o.v)} disabled={disabled} onClick={() => onChange(o.v)} title={disabled ? lockHint : ''}
                        style={{ ...baseBtn, height: '36px', padding: '0 10px', border: `1px solid ${on ? T.blue : T.borderMid}`, background: on ? T.blueLight : T.surface, color: on ? T.blueDark : T.textMuted, fontWeight: on ? '600' : '500', opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}>
                        <i className={o.icon} />{o.label}
                    </button>
                );
            })}
        </div>
        {lockSub && lockHint && <span style={{ fontSize: '11px', color: T.amber, marginTop: '4px', display: 'block' }}>{lockHint}</span>}
    </div>
);

const HierarchyFields = ({ data, onPatch, parentOptions, lockSub, lockHint, kind = 'category', foodTypes, onManageFood }) => {
    const isParent = data.isParentCategory === true;
    const parentInvalid = !isParent && !data.parentCategory;
    const parentStyles = {
        ...selectStyles,
        control: (p, s) => ({ ...selectStyles.control(p, s), borderColor: parentInvalid && !s.isFocused ? T.red : (s.isFocused ? T.blue : T.borderMid) }),
    };
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', padding: '14px', background: T.bg, border: `1px solid ${T.border}`, borderRadius: '8px' }}>
            {isParent ? (
                <Field label="Food Type" required hint="Select one or more. Sub categories inherit these from their parent.">
                    <FoodTypeChips options={foodTypes} value={data.foodType || []} onChange={(v) => onPatch({ foodType: v })} onManage={onManageFood} />
                </Field>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: T.textMuted }}>
                    <i className="ri-information-line" /> Food type is inherited from the parent {kind}.
                </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: '14px' }}>
                <Field label="Level" required>
                    <LevelToggle isParent={isParent} lockSub={lockSub} lockHint={lockHint}
                        onChange={(v) => onPatch({ isParentCategory: v, ...(v ? { parentCategory: '' } : {}) })} />
                </Field>
                <Field label="Parent Category" required={!isParent}
                    hint={isParent ? `Not needed — this is a parent ${kind}.` : (parentOptions.length === 0 ? `No parent ${kind} exists yet. Create a parent first.` : undefined)}
                    error={parentInvalid && parentOptions.length > 0 ? `Select the parent this ${kind} belongs to.` : undefined}>
                    <Select
                        isDisabled={isParent}
                        isClearable
                        components={animatedComponents}
                        options={parentOptions}
                        value={parentOptions.find((o) => o.value === data.parentCategory) || null}
                        onChange={(opt) => onPatch({ parentCategory: opt ? opt.value : '' })}
                        styles={parentStyles}
                        placeholder={isParent ? 'Not applicable' : 'Select parent…'}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    />
                </Field>
            </div>
        </div>
    );
};

// ─── Product rows (featured sub-categories only) ─────────────────────────────
const ProductRowsEditor = ({ rows, setRows, productOptions, outletData, disabled }) => {
    const update = (i, patch) => setRows((prev) => prev.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
    const add = () => setRows((prev) => [...prev, { product: "", sequenceNumber: prev.length + 1, excludedOutlets: [], includedOutlets: [] }]);
    const remove = (i) => setRows((prev) => prev.filter((_, idx) => idx !== i));
    const taken = rows.map((r) => r.product).filter(Boolean);
    const compact = { ...selectStyles, control: (p, s) => ({ ...selectStyles.control(p, s), fontSize: '12px', minHeight: '36px' }) };
    const portal = typeof document !== 'undefined' ? document.body : null;
    const cols = '2fr 80px 1.2fr 1.2fr 36px';

    return (
        <div style={{ opacity: disabled ? 0.55 : 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <label style={{ ...labelStyle, marginBottom: 0 }}>Products {!disabled && <span style={{ color: T.red }}>*</span>}</label>
                <button type="button" style={{ ...ghostBtn, height: '28px', padding: '0 10px', fontSize: '12px', opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }} onClick={add} disabled={disabled}>
                    <i className="ri-add-line" /> Add Product
                </button>
            </div>
            {disabled && (
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '12px', color: T.textMuted, background: T.bg, border: `1px dashed ${T.borderMid}`, borderRadius: '6px', padding: '8px 10px', marginBottom: '10px' }}>
                    <i className="ri-information-line" />
                    Parent featured categories only group sub categories. Switch Level to “Sub category” to add products.
                </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: cols, gap: '8px', marginBottom: '6px', padding: '0 2px' }}>
                {['Product', 'Seq', 'Excluded Outlets', 'Included Outlets', ''].map((h, i) => <span key={i} style={{ ...labelStyle, marginBottom: 0 }}>{h}</span>)}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {rows.map((row, idx) => (
                    <div key={idx} style={{ display: 'grid', gridTemplateColumns: cols, gap: '8px', alignItems: 'center' }}>
                        <Select
                            isDisabled={disabled} isClearable components={animatedComponents} styles={compact} menuPortalTarget={portal}
                            options={productOptions.filter((o) => o.value === row.product || !taken.includes(o.value))}
                            value={row.product ? (productOptions.find((o) => o.value === row.product) || { value: row.product, label: row.product }) : null}
                            onChange={(sel) => update(idx, { product: sel ? sel.value : "" })}
                            placeholder="Select product…"
                        />
                        <input style={{ ...inputStyle, fontSize: '12px' }} type="number" min={1} disabled={disabled} value={row.sequenceNumber}
                            onChange={(e) => update(idx, { sequenceNumber: Number(e.target.value) })} />
                        <Select
                            isMulti isDisabled={disabled} components={animatedComponents} styles={compact} menuPortalTarget={portal} closeMenuOnSelect={false}
                            options={outletData.filter((o) => !row.includedOutlets.includes(o.value))}
                            value={outletData.filter((o) => row.excludedOutlets.includes(o.value))}
                            onChange={(sel) => update(idx, { excludedOutlets: (sel || []).map((s) => s.value) })}
                            placeholder="Excluded…"
                        />
                        <Select
                            isMulti isDisabled={disabled} components={animatedComponents} styles={compact} menuPortalTarget={portal} closeMenuOnSelect={false}
                            options={outletData.filter((o) => !row.excludedOutlets.includes(o.value))}
                            value={outletData.filter((o) => row.includedOutlets.includes(o.value))}
                            onChange={(sel) => update(idx, { includedOutlets: (sel || []).map((s) => s.value) })}
                            placeholder="Included…"
                        />
                        <button type="button" onClick={() => remove(idx)} disabled={disabled || rows.length === 1}
                            style={{ width: '36px', height: '36px', border: `1px solid ${T.borderMid}`, borderRadius: '6px', background: T.surface, color: T.red, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: disabled || rows.length === 1 ? 'not-allowed' : 'pointer', opacity: disabled || rows.length === 1 ? 0.4 : 1 }}>
                            <i className="ri-delete-bin-line" style={{ fontSize: '14px' }} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

const MissingNote = ({ items }) => (
    items.length > 0 ? (
        <span style={{ marginRight: 'auto', fontSize: '12px', color: T.textFaint }}>
            Still needed: <span style={{ color: T.red }}>{items.join(', ')}</span>
        </span>
    ) : null
);

// "excl: Outlet A, Outlet B" line shown under a featured category name in lists.
const ExclNote = ({ list }) => (
    list?.length > 0 ? (
        <div title={list.map((o) => o.name).join(', ')}
            style={{ fontSize: '10px', color: T.red, marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            excl: {list.map((o) => o.name).join(', ')}
        </div>
    ) : null
);

// Category-level excluded outlets picker for featured add / edit forms.
const ExcludedOutletsField = ({ value, onChange, outletData }) => (
    <Field label="Excluded Outlets" hint="Featured category is hidden at these outlets.">
        <Select
            isMulti components={animatedComponents} styles={selectStyles} closeMenuOnSelect={false}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            options={outletData}
            value={outletData.filter((o) => (value || []).includes(o.value))}
            onChange={(sel) => onChange((sel || []).map((s) => s.value))}
            placeholder="Select outlets to exclude…"
        />
    </Field>
);

const BLANK_ROW = () => ({ product: "", sequenceNumber: 1, excludedOutlets: [], includedOutlets: [] });
const EMPTY_NORMAL = { name: '', description: '', isEventCategory: '', sequenceNumber: '', orderType: 'ALL', foodType: [], isParentCategory: true, parentCategory: '' };
const EMPTY_FEATURED = { name: '', description: '', sequenceNumber: '', validityStartDate: '', validityEndDate: '', orderType: 'ALL', foodType: [], isParentCategory: true, parentCategory: '', excludedOutlets: [] };
const EMPTY_FILTERS = { search: '', status: 'all', foodType: [] };

// ═════════════════════════════════════════════════════════════════════════════
// Main component
// ═════════════════════════════════════════════════════════════════════════════
const Category = () => {
    const [skin, setSkin] = useState(localStorage.getItem('skin-mode') ? 'dark' : '');
    const { access, loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const accessToken = localStorage.getItem("authToken");
    const [menuAccess, setMenuAccess] = useState([]);

    useEffect(() => {
        if (Array.isArray(access)) setMenuAccess(access.filter((perm) => perm?.startsWith("CategoryMgt:")));
    }, [access]);
    const can = (p) => menuAccess.includes(`CategoryMgt:${p}`) || email === ADMIN_EMAIL;

    // ── Navigation / filters / paging ──────────────────────────────────────────
    const [activeTab, setActiveTab] = useState('parent'); // 'parent' | 'sub' | 'featured'
    const [filters, setFilters] = useState(EMPTY_FILTERS);
    const [parentPage, setParentPage] = useState(1);
    const [subPage, setSubPage] = useState(1);
    const [subKind, setSubKind] = useState('all'); // Sub Categories tab: 'all' | 'normal' | 'featured'
    const [featuredPage, setFeaturedPage] = useState(1);
    const [expanded, setExpanded] = useState({});
    const rowsPerPage = 10;

    // ── Data ───────────────────────────────────────────────────────────────────
    const [categoryList, setCategoryList] = useState([]);
    const [featuredCategoryList, setFeaturedCategoryList] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [productList, setProductList] = useState([]);
    const [foodTypes, setFoodTypes] = useState([]); // [{ _id, name }]
    const [openFoodManager, setOpenFoodManager] = useState(false);
    const [isListLoading, setIsListLoading] = useState(false);
    const [isFeaturedListLoading, setIsFeaturedListLoading] = useState(false);
    const [isDownloadLoading, setIsDownloadLoading] = useState(false);

    // ── Add modal ──────────────────────────────────────────────────────────────
    const [openAddModal, setOpenAddModal] = useState(false);
    const [addCategoryType, setAddCategoryType] = useState('normal');
    const [inputData, setInputData] = useState(EMPTY_NORMAL);
    const [image, setImage] = useState(null);
    const [bannerImage, setBannerImage] = useState(null);
    const [normalImgKey, setNormalImgKey] = useState(0);
    const [normalBannerKey, setNormalBannerKey] = useState(0);
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [featuredData, setFeaturedData] = useState(EMPTY_FEATURED);
    const [featuredProducts, setFeaturedProducts] = useState([BLANK_ROW()]);
    const [featuredAddImage, setFeaturedAddImage] = useState(null);
    const [featuredAddBannerImage, setFeaturedAddBannerImage] = useState(null);
    const [featuredImgInputKey, setFeaturedImgInputKey] = useState(0);
    const [featuredBannerInputKey, setFeaturedBannerInputKey] = useState(0);
    const [isFeaturedLoading, setIsFeaturedLoading] = useState(false);

    // ── Normal edit / delete / image modals ────────────────────────────────────
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [editedSelectedExOutlets, setEditedSelectedExOutlets] = useState([]);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBannerImageModal, setShowBannerImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [openImageUploadModal, setOpenImageUploadModal] = useState(false);
    const [openBannerImageUploadModal, setOpenBannerImageUploadModal] = useState(false);
    const [imageId, setImageId] = useState("");
    const [isImageEditBtnLoading, setIsImageEditBtnLoading] = useState(false);
    const imageInputRef = useRef(null);

    // ── Featured edit / delete / image modals ──────────────────────────────────
    const [openFeaturedEditModal, setOpenFeaturedEditModal] = useState(false);
    const [openFeaturedDeleteModal, setOpenFeaturedDeleteModal] = useState(false);
    const [openFeaturedImgModal, setOpenFeaturedImgModal] = useState(false);
    const [openFeaturedBannerModal, setOpenFeaturedBannerModal] = useState(false);
    const [selectedFeatured, setSelectedFeatured] = useState(null);
    const [featuredEditData, setFeaturedEditData] = useState({ id: "", name: "", description: "", sequenceNumber: "", validityStartDate: "", validityEndDate: "", status: "", orderType: "ALL", foodType: [], isParentCategory: true, parentCategory: "", excludedOutlets: [] });
    const [featuredEditProducts, setFeaturedEditProducts] = useState([BLANK_ROW()]);
    const [isFeaturedEditLoading, setIsFeaturedEditLoading] = useState(false);
    const [isFeaturedDeleteLoading, setIsFeaturedDeleteLoading] = useState(false);
    const [isFeaturedImgLoading, setIsFeaturedImgLoading] = useState(false);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [featuredBannerImage, setFeaturedBannerImage] = useState(null);

    // ═══════════════════════════ Derived data ════════════════════════════════
    const outletData = useMemo(() => outlets.map((o) => ({ value: o._id, label: `${o.name} (${o.city})` })), [outlets]);
    const productOptions = useMemo(() => productList.map((p) => ({ value: p._id, label: p.name })), [productList]);
    const foodTypeOptions = useMemo(() => foodTypes.map((f) => ({ value: f.name, label: foodLabel(f.name) })), [foodTypes]);

    const canManageFood = can('add') || can('update') || can('delete');

    const subCountByParent = useMemo(() => {
        const m = {};
        categoryList.filter((c) => !isParentCat(c)).forEach((c) => { const id = getParentId(c); if (id) m[id] = (m[id] || 0) + 1; });
        return m;
    }, [categoryList]);
    const featuredSubCountByParent = useMemo(() => {
        const m = {};
        featuredCategoryList.filter((c) => !isParentCat(c)).forEach((c) => { const id = getParentId(c); if (id) m[id] = (m[id] || 0) + 1; });
        return m;
    }, [featuredCategoryList]);

    const parentOptionsFor = (list, excludeId) => list
        .filter((c) => isParentCat(c) && c._id !== excludeId)
        .map((c) => ({ value: c._id, label: c.name }));
    const categoryParentOptions = useMemo(() => parentOptionsFor(categoryList), [categoryList]);
    const featuredParentOptions = useMemo(() => parentOptionsFor(featuredCategoryList), [featuredCategoryList]);

    const parentById = useMemo(() => {
        const m = {};
        categoryList.forEach((c) => { m[c._id] = c; });
        return m;
    }, [categoryList]);

    const parentTree = useMemo(() => buildTree(categoryList, filters), [categoryList, filters]);
    const featuredTree = useMemo(() => buildTree(featuredCategoryList, filters), [featuredCategoryList, filters]);
    const featuredParentById = useMemo(() => {
        const m = {};
        featuredCategoryList.forEach((c) => { m[c._id] = c; });
        return m;
    }, [featuredCategoryList]);
    // Sub categories of BOTH normal and featured categories, tagged with their kind.
    const allSubs = useMemo(() => {
        const { searchOk, attrOk } = makeMatchers(filters);
        const pick = (list, kind, parents) => list
            .filter((c) => !isParentCat(c))
            .map((c) => ({ sub: c, kind, parent: parents[getParentId(c)] }))
            .filter((r) => attrOk(r.sub, toFoodArr(r.parent?.foodType)) && (searchOk(r.sub) || searchOk({ name: r.parent?.name })));
        return [...pick(categoryList, 'normal', parentById), ...pick(featuredCategoryList, 'featured', featuredParentById)];
    }, [categoryList, featuredCategoryList, filters, parentById, featuredParentById]);
    const flatSubs = useMemo(() => (subKind === 'all' ? allSubs : allSubs.filter((r) => r.kind === subKind)), [allSubs, subKind]);

    const paged = (arr, page) => arr.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    const pagesOf = (arr) => Math.max(1, Math.ceil(arr.length / rowsPerPage));
    const showingText = (total, page, noun) => (total === 0 ? `No ${noun} found` : `Showing ${(page - 1) * rowsPerPage + 1} to ${Math.min(page * rowsPerPage, total)} of ${total} ${noun}`);

    const activeFilterCount = (filters.search.trim() ? 1 : 0) + (filters.status !== 'all' ? 1 : 0) + (filters.foodType.length ? 1 : 0);
    useEffect(() => { setParentPage(1); setSubPage(1); setFeaturedPage(1); }, [filters]);
    useEffect(() => { setSubPage(1); }, [subKind]);

    const isOpen = (id, autoOpen) => (expanded[id] !== undefined ? expanded[id] : !!autoOpen);
    const toggleRow = (id, autoOpen) => setExpanded((p) => ({ ...p, [id]: !isOpen(id, autoOpen) }));

    // ═══════════════════════════ API calls ═══════════════════════════════════
    const authHeaders = () => ({ Authorization: `Bearer ${accessToken}` });

    const getOutlets = async () => {
        try {
            const response = await axiosInstance.get("outlet", { headers: authHeaders() });
            if (response?.data?.status === true) setOutlets(response?.data?.data?.outlets);
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
    };

    const getProductsList = async () => {
        try {
            const response = await axiosInstance.get("product", { headers: authHeaders() });
            if (response?.data?.status === true) setProductList(response?.data?.data?.products);
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
    };

    // Fetch everything once; search / status / food-type filtering happens client-side
    // so parents and their sub categories stay consistent while filtering.
    const getCategoryList = async () => {
        setIsListLoading(true);
        try {
            const response = await axiosInstance.get("masters/category/get", { headers: authHeaders() });
            if (response?.data?.status === true) setCategoryList(response?.data?.data?.categories || []);
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
        finally { setIsListLoading(false); }
    };

    const getFeaturedCategoryList = async () => {
        setIsFeaturedListLoading(true);
        try {
            const response = await axiosInstance.get("featured-category", { headers: authHeaders() });
            if (response?.data?.status === true) setFeaturedCategoryList(response?.data?.data?.featuredCategories || []);
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
        finally { setIsFeaturedListLoading(false); }
    };

    useEffect(() => { getOutlets(); getCategoryList(); getProductsList(); getFeaturedCategoryList(); getFoodTypes(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Food types ─────────────────────────────────────────────────────────────
    const getFoodTypes = async () => {
        try {
            const response = await axiosInstance.get("foodtype", { headers: authHeaders() });
            setFoodTypes(pickFoodTypes(response));
        } catch (error) { toast.error(getErrMsg(error, "Failed to load food types"), TOAST); }
    };

    // Keep every open form / filter consistent after a rename or delete.
    const remapFoodEverywhere = (fn) => {
        setFilters((f) => mapFood(f, fn));
        setInputData((p) => mapFood(p, fn));
        setFeaturedData((p) => mapFood(p, fn));
        setEditedData((p) => mapFood(p, fn));
        setFeaturedEditData((p) => mapFood(p, fn));
    };
    const refreshAfterFoodChange = () => { getFoodTypes(); getCategoryList(); getFeaturedCategoryList(); };

    const addFoodType = async (name) => {
        try {
            const response = await axiosInstance.post("foodtype", { name }, { headers: authHeaders() });
            if (!isOk(response)) return false;
            toast.success(response?.data?.data?.message || "Food type added", TOAST);
            await getFoodTypes();
            return true;
        } catch (error) { toast.error(getErrMsg(error, "Failed to add food type"), TOAST); return false; }
    };

    const updateFoodType = async (_id, name) => {
        const old = foodTypes.find((f) => f._id === _id)?.name;
        try {
            const response = await axiosInstance.put("foodtype", { _id, name }, { headers: authHeaders() });
            if (!isOk(response)) return false;
            toast.success(response?.data?.data?.message || "Food type updated", TOAST);
            if (old) remapFoodEverywhere((arr) => arr.map((n) => (n === old ? name : n)));
            refreshAfterFoodChange();
            return true;
        } catch (error) { toast.error(getErrMsg(error, "Failed to update food type"), TOAST); return false; }
    };

    const deleteFoodType = async (_id) => {
        const old = foodTypes.find((f) => f._id === _id)?.name;
        try {
            const response = await axiosInstance.delete("foodtype", { headers: authHeaders(), data: { _id } });
            if (!isOk(response)) return false;
            toast.success(response?.data?.data?.message || "Food type deleted", TOAST);
            if (old) remapFoodEverywhere((arr) => arr.filter((n) => n !== old));
            refreshAfterFoodChange();
            return true;
        } catch (error) { toast.error(getErrMsg(error, "Failed to delete food type"), TOAST); return false; }
    };

    const downloadCategoryReport = async () => {
        setIsDownloadLoading(true);
        try {
            const response = await axiosInstance.get("masters/category/get", { headers: authHeaders(), params: { isDownload: true }, responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Category List.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success("Report downloaded.", TOAST);
        } catch (error) { toast.error(getErrMsg(error, "Failed to download report"), TOAST); }
        finally { setIsDownloadLoading(false); }
    };

    // ═══════════════════════════ Add modal ═══════════════════════════════════
    const resetAddModalState = () => {
        setInputData(EMPTY_NORMAL);
        setImage(null); setBannerImage(null);
        setNormalImgKey((k) => k + 1); setNormalBannerKey((k) => k + 1);
        setSelectedExcludedOutlets([]);
        setAddCategoryType('normal');
        setFeaturedData(EMPTY_FEATURED);
        setFeaturedProducts([BLANK_ROW()]);
        setFeaturedAddImage(null); setFeaturedAddBannerImage(null);
        setFeaturedImgInputKey((k) => k + 1); setFeaturedBannerInputKey((k) => k + 1);
    };

    // One entry point for every "Add …" button. Pre-fills level, parent and next sequence number.
    const openAdd = ({ type = 'normal', isParent = true, parentId = '' } = {}) => {
        resetAddModalState();
        setAddCategoryType(type);
        if (type === 'normal') {
            setInputData({ ...EMPTY_NORMAL, sequenceNumber: nextSeq(categoryList), isParentCategory: isParent, parentCategory: isParent ? '' : parentId });
        } else {
            setFeaturedData({ ...EMPTY_FEATURED, sequenceNumber: nextSeq(featuredCategoryList), isParentCategory: isParent, parentCategory: isParent ? '' : parentId });
        }
        setOpenAddModal(true);
    };
    const handleCloseAddModal = () => { setOpenAddModal(false); resetAddModalState(); };

    const patchInput = (patch) => setInputData((p) => ({ ...p, ...patch }));
    const patchFeatured = (patch) => setFeaturedData((p) => ({ ...p, ...patch }));
    const handleChange = (e) => { const { name, value } = e.target; patchInput({ [name]: value }); };
    const handleFeaturedChange = (e) => { const { name, value } = e.target; patchFeatured({ [name]: value }); };

    const handleImageChange = (e) => {
        const allowed = ["png", "jpg", "jpeg"];
        const file = e.target.files[0];
        if (file) {
            const ext = file.name.split(".").pop().toLowerCase();
            if (!allowed.includes(ext)) {
                toast.error("Invalid file format. Upload only jpg or png.", TOAST);
                e.target.value = "";
                return;
            }
            setImage(file);
        }
    };
    const handleBannerImageChange = (e) => {
        // Dimension check (1000×200) intentionally left disabled, as in the previous version.
        const file = e.target.files[0];
        if (file) setBannerImage(file);
    };

    const handleFeaturedImageChange = (e) => {
        const allowed = ["png", "jpg", "jpeg", "webp", "avif"];
        const file = e.target.files[0];
        if (file) {
            const ext = file.name.split(".").pop().toLowerCase();
            if (!allowed.includes(ext)) {
                toast.error("Invalid file format. Upload only jpg, png, webp or avif.", TOAST);
                e.target.value = "";
                return;
            }
            setFeaturedAddImage(file);
        }
    };
    const handleFeaturedBannerImageChange = (e) => {
        const allowed = ["png", "jpg", "jpeg", "webp", "avif"];
        const input = e.target;
        const file = input.files[0];
        if (file) {
            const ext = file.name.split(".").pop().toLowerCase();
            if (!allowed.includes(ext)) {
                toast.error("Invalid file format. Upload only jpg, png, webp or avif.", TOAST);
                input.value = "";
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    if (img.width === 1000 && img.height === 200) setFeaturedAddBannerImage(file);
                    else { toast.error("Banner dimensions must be exactly 1000×200 px", TOAST); input.value = ""; }
                };
            };
            reader.readAsDataURL(file);
        }
    };

    // ── Validation (normal add) ────────────────────────────────────────────────
    const normalMissing = [];
    if (!inputData.name.trim()) normalMissing.push('Name');
    if (!String(inputData.sequenceNumber).trim()) normalMissing.push('Sequence');
    if (inputData.isParentCategory && !inputData.foodType.length) normalMissing.push('Food type');
    if (!inputData.isParentCategory && !inputData.parentCategory) normalMissing.push('Parent category');
    if (inputData.isEventCategory === '') normalMissing.push('Outlet type');
    if (!inputData.description.trim()) normalMissing.push('Description');
    if (!bannerImage) normalMissing.push('Banner');
    if (!image) normalMissing.push('Image');
    const normalInvalid = normalMissing.length > 0 || isLoading;

    const addCategory = async (e) => {
        e.preventDefault();
        if (normalInvalid) return;
        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append("sequenceNumber", inputData.sequenceNumber);
            formData.append("name", inputData.name.trim());
            formData.append("isEventCategory", inputData.isEventCategory);
            formData.append("description", inputData.description.trim());
            formData.append("orderType", inputData.orderType);
            formData.append("isParentCategory", String(inputData.isParentCategory));
            if (inputData.isParentCategory) inputData.foodType.forEach((n, i) => formData.append(`foodType[${i}]`, n)); // sub categories send no foodType
            else formData.append("parentCategory", inputData.parentCategory);
            formData.append("image", image);
            formData.append("bannerImage", bannerImage);
            selectedExcludedOutlets.forEach((o, i) => formData.append(`excludedOutlets[${i}]`, o.value));
            const headers = { "Content-Type": "multipart/form-data", ...authHeaders() };
            const response = await axiosInstance.post("masters/category/add", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                getCategoryList();
                setOpenAddModal(false);
                resetAddModalState();
            }
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
        finally { setIsLoading(false); }
    };

    // ── Validation (featured add) ──────────────────────────────────────────────
    const hasAtLeastOneSelectedProduct = featuredProducts.some((p) => p.product && p.product.trim() !== "");
    const featuredMissing = [];
    if (!featuredData.name.trim()) featuredMissing.push('Name');
    if (!String(featuredData.sequenceNumber).trim()) featuredMissing.push('Sequence');
    if (featuredData.isParentCategory && !featuredData.foodType.length) featuredMissing.push('Food type');
    if (!featuredData.isParentCategory && !featuredData.parentCategory) featuredMissing.push('Parent category');
    if (!featuredData.validityStartDate) featuredMissing.push('Start date');
    if (!featuredData.validityEndDate) featuredMissing.push('End date');
    if (!featuredData.description.trim()) featuredMissing.push('Description');
    if (!featuredAddBannerImage) featuredMissing.push('Banner');
    if (!featuredAddImage) featuredMissing.push('Image');
    if (!featuredData.isParentCategory && !hasAtLeastOneSelectedProduct) featuredMissing.push('Products');
    const isFeaturedFormInvalid = featuredMissing.length > 0 || isFeaturedLoading;

    const addFeaturedCategory = async (e) => {
        e.preventDefault();
        if (isFeaturedFormInvalid) return;
        setIsFeaturedLoading(true);
        try {
            const isParent = featuredData.isParentCategory;
            const validProducts = isParent ? [] : featuredProducts
                .filter((p) => p.product && p.product.trim() !== "")
                .map((p, i) => ({ ...p, sequenceNumber: p.sequenceNumber || (i + 1) }));

            const formData = new FormData();
            formData.append("name", featuredData.name.trim());
            formData.append("description", featuredData.description.trim());
            formData.append("sequenceNumber", featuredData.sequenceNumber);
            formData.append("validityStartDate", featuredData.validityStartDate);
            formData.append("validityEndDate", featuredData.validityEndDate);
            formData.append("orderType", featuredData.orderType);
            formData.append("isParentCategory", String(isParent));
            if (isParent) featuredData.foodType.forEach((n, i) => formData.append(`foodType[${i}]`, n));
            else formData.append("parentCategory", featuredData.parentCategory);
            formData.append("products", JSON.stringify(validProducts));
            (featuredData.excludedOutlets || []).forEach((id, i) => formData.append(`excludedOutlets[${i}]`, id));
            formData.append("image", featuredAddImage);
            formData.append("bannerImage", featuredAddBannerImage);

            const headers = { "Content-Type": "multipart/form-data", ...authHeaders() };
            const response = await axiosInstance.post("featured-category", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message || "Featured category created!", TOAST);
                setOpenAddModal(false);
                resetAddModalState();
                getFeaturedCategoryList();
            }
        } catch (error) { toast.error(getErrMsg(error, "Failed to create featured category"), TOAST); }
        finally { setIsFeaturedLoading(false); }
    };

    // ═══════════════════════════ Normal edit / delete / images ═══════════════
    const handleOpenEditModal = (data) => {
        setEditedData({
            id: data._id, name: data?.name, sequenceNumber: data?.sequenceNumber, description: data?.description,
            isEventCategory: data?.isEventCategory, isComboCategory: data?.isComboCategory, status: data?.status, orderType: data?.orderType,
            foodType: toFoodArr(data?.foodType), isParentCategory: isParentCat(data), parentCategory: getParentId(data),
        });
        setEditedSelectedExOutlets(data?.excludedOutletDetails?.map((m) => ({ value: m?._id, label: m?.name })) || []);
        setOpenEditModal(true);
    };
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((p) => ({ ...p, [name]: name === "isComboCategory" ? value === "true" : value }));
    };
    const patchEdited = (patch) => setEditedData((p) => ({ ...p, ...patch }));

    const editIsParent = editedData?.isParentCategory !== false;
    const editMissing = [];
    if (!String(editedData?.name || '').trim()) editMissing.push('Name');
    if (!String(editedData?.sequenceNumber ?? '').trim()) editMissing.push('Sequence');
    if (editIsParent && !(editedData?.foodType || []).length) editMissing.push('Food type');
    if (editedData?.isParentCategory === false && !editedData?.parentCategory) editMissing.push('Parent category');
    if (!editedData?.status) editMissing.push('Status');
    if (!String(editedData?.description || '').trim()) editMissing.push('Description');
    const editInvalid = editMissing.length > 0 || isEditLoading;
    const editSubCount = subCountByParent[editedData?.id] || 0;

    const editCategory = async (e) => {
        e.preventDefault();
        if (editInvalid) return;
        setIsEditLoading(true);
        try {
            const isParent = editedData.isParentCategory === true;
            const newData = {
                ...editedData,
                isParentCategory: isParent,
                parentCategory: isParent ? null : editedData.parentCategory, // null clears a previous parent
                excludedOutlets: editedSelectedExOutlets?.map((ex) => ex?.value),
            };
            if (isParent) newData.foodType = editedData.foodType || []; // e.g. ["VEG", "VEG/VEGAN"]
            else delete newData.foodType; // sub categories inherit from parent
            const response = await axiosInstance.put("masters/category/update", newData, { headers: authHeaders() });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                getCategoryList(); setOpenEditModal(false);
            }
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
        finally { setIsEditLoading(false); }
    };

    const handleOpenDeleteModal = (data) => { setDeleteTarget(data); setOpenDeleteModal(true); };
    const deleteCategory = async (e) => {
        e.preventDefault(); setIsDeleteLoading(true);
        try {
            const response = await axiosInstance.delete(`masters/category/delete?id=${deleteTarget?._id}`, { headers: authHeaders() });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                getCategoryList(); setOpenDeleteModal(false);
            }
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
        finally { setIsDeleteLoading(false); }
    };

    const handleImageClick = (row) => { setSelectedImage(row); setShowImageModal(true); };
    const handleBannerImageClick = (row) => { setSelectedImage(row); setShowBannerImageModal(true); };
    const handleImageUploadModal = (data) => { setImage(data?.displayImage); setImageId(data?._id); setOpenImageUploadModal(true); setShowImageModal(false); };
    const handleBannerImageUpload = (data) => { setOpenBannerImageUploadModal(true); setBannerImage(data?.bannerImage); setImageId(data?._id); setShowBannerImageModal(false); };
    const handleEditBannerImage = () => {
        const file = imageInputRef?.current?.files[0];
        if (file) setBannerImage(file);
    };

    const submitImageUpdate = async (field, value, closeFn) => {
        setIsImageEditBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append(field, value); formData.append("id", imageId);
            const headers = { "Content-Type": "multipart/form-data", ...authHeaders() };
            const response = await axiosInstance.put("masters/category/update-images", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                getCategoryList(); closeFn(false);
            }
        } catch (error) { toast.error(getErrMsg(error), TOAST); }
        finally { setIsImageEditBtnLoading(false); }
    };
    const handleEditImage = (e) => { e.preventDefault(); submitImageUpdate("image", image, setOpenImageUploadModal); };
    const handleBannerEditImage = (e) => { e.preventDefault(); submitImageUpdate("bannerImage", bannerImage, setOpenBannerImageUploadModal); };

    // ═══════════════════════════ Featured edit / delete / images ═════════════
    const handleOpenFeaturedEditModal = (fc) => {
        setFeaturedEditData({
            id: fc?._id, name: fc?.name, status: fc?.status, description: fc?.description, sequenceNumber: fc?.sequenceNumber,
            validityStartDate: fc?.validityStartDate ? fc.validityStartDate.split('T')[0] : "",
            validityEndDate: fc?.validityEndDate ? fc.validityEndDate.split('T')[0] : "",
            orderType: fc?.orderType || "ALL",
            foodType: toFoodArr(fc?.foodType), isParentCategory: isParentCat(fc), parentCategory: getParentId(fc),
            excludedOutlets: (fc?.excludedOutletDetails?.map((o) => o._id) || fc?.excludedOutlets?.map((o) => (typeof o === 'object' ? o._id : o)) || []),
        });
        const rows = fc.products?.map((p) => ({
            product: p.product, sequenceNumber: p.sequenceNumber,
            excludedOutlets: p.excludedOutlets || [], includedOutlets: p.includedOutlets || [],
        })) || [];
        setFeaturedEditProducts(rows.length ? rows : [BLANK_ROW()]);
        setOpenFeaturedEditModal(true);
    };
    const handleFeaturedEditChange = (e) => { const { name, value } = e.target; setFeaturedEditData((p) => ({ ...p, [name]: value })); };
    const patchFeaturedEdit = (patch) => setFeaturedEditData((p) => ({ ...p, ...patch }));

    const featuredEditIsParent = featuredEditData.isParentCategory === true;
    const featuredEditMissing = [];
    if (!String(featuredEditData.name || '').trim()) featuredEditMissing.push('Name');
    if (!String(featuredEditData.sequenceNumber ?? '').trim()) featuredEditMissing.push('Sequence');
    if (featuredEditIsParent && !(featuredEditData.foodType || []).length) featuredEditMissing.push('Food type');
    if (!featuredEditIsParent && !featuredEditData.parentCategory) featuredEditMissing.push('Parent category');
    if (!featuredEditData.status) featuredEditMissing.push('Status');
    if (!featuredEditData.validityStartDate) featuredEditMissing.push('Start date');
    if (!featuredEditData.validityEndDate) featuredEditMissing.push('End date');
    if (!featuredEditIsParent && !featuredEditProducts.some((p) => p.product && p.product.trim() !== "")) featuredEditMissing.push('A product');
    const featuredEditInvalid = featuredEditMissing.length > 0 || isFeaturedEditLoading;
    const featuredEditSubCount = featuredSubCountByParent[featuredEditData.id] || 0;

    const updateFeaturedCategory = async (e) => {
        e.preventDefault();
        if (featuredEditInvalid) return;
        setIsFeaturedEditLoading(true);
        try {
            const validProducts = featuredEditIsParent ? [] : featuredEditProducts
                .filter((p) => p.product && p.product.trim() !== "")
                .map((p, i) => ({ ...p, sequenceNumber: p.sequenceNumber || (i + 1) }));
            const payload = {
                id: featuredEditData.id,
                name: featuredEditData.name,
                status: featuredEditData.status,
                description: featuredEditData.description,
                sequenceNumber: Number(featuredEditData.sequenceNumber),
                validityStartDate: featuredEditData.validityStartDate,
                validityEndDate: featuredEditData.validityEndDate,
                orderType: featuredEditData.orderType,
                excludedOutlets: featuredEditData.excludedOutlets || [],
                isParentCategory: featuredEditIsParent,
                parentCategory: featuredEditIsParent ? null : featuredEditData.parentCategory, // null clears a previous parent
                products: validProducts,
                ...(featuredEditIsParent ? { foodType: featuredEditData.foodType || [] } : {}), // sub categories send no foodType
            };
            const headers = { "Content-Type": "application/json", ...authHeaders() };
            const response = await axiosInstance.put("featured-category", payload, { headers });
            if (response?.data?.success === true || response?.data?.status === true) {
                toast.success(response?.data?.data?.message || "Updated successfully!", TOAST);
                setOpenFeaturedEditModal(false);
                getFeaturedCategoryList();
            }
        } catch (error) { toast.error(getErrMsg(error, "Update failed"), TOAST); }
        finally { setIsFeaturedEditLoading(false); }
    };

    const deleteFeaturedCategory = async (e) => {
        e.preventDefault();
        setIsFeaturedDeleteLoading(true);
        try {
            const response = await axiosInstance.delete("featured-category", { headers: authHeaders(), data: { _id: selectedFeatured?._id } });
            toast.success(response?.data?.data?.message || "Deleted successfully!", TOAST);
            setOpenFeaturedDeleteModal(false);
            setSelectedFeatured(null);
            getFeaturedCategoryList();
        } catch (error) { toast.error(getErrMsg(error, "Delete failed"), TOAST); }
        finally { setIsFeaturedDeleteLoading(false); }
    };

    const submitFeaturedImage = async (field, value, label, closeFn, clearFn) => {
        setIsFeaturedImgLoading(true);
        try {
            const formData = new FormData();
            formData.append("id", selectedFeatured?._id);
            formData.append(field, value);
            const headers = { "Content-Type": "multipart/form-data", ...authHeaders() };
            const response = await axiosInstance.put("featured-category/update-images", formData, { headers });
            if (response?.data?.success === true || response?.data?.status === true) {
                toast.success(response?.data?.data?.message || `${label} updated!`, TOAST);
                closeFn(false); clearFn(null);
                getFeaturedCategoryList();
            }
        } catch (error) { toast.error(getErrMsg(error, `${label} update failed`), TOAST); }
        finally { setIsFeaturedImgLoading(false); }
    };
    const updateFeaturedImage = (e) => { e.preventDefault(); submitFeaturedImage("image", featuredImage, "Image", setOpenFeaturedImgModal, setFeaturedImage); };
    const updateFeaturedBannerImage = (e) => { e.preventDefault(); submitFeaturedImage("bannerImage", featuredBannerImage, "Banner image", setOpenFeaturedBannerModal, setFeaturedBannerImage); };

    // ═══════════════════════════ Row action menus ════════════════════════════
    const categoryMenu = (cat, { allowAddSub }) => [
        can('update') && { label: 'Edit', icon: 'ri-edit-line', color: T.blue, onClick: () => handleOpenEditModal(cat) },
        allowAddSub && can('add') && { label: 'Add Sub Category', icon: 'ri-add-circle-line', onClick: () => openAdd({ type: 'normal', isParent: false, parentId: cat._id }) },
        { label: 'Change Image', icon: 'ri-image-edit-line', onClick: () => handleImageClick(cat) },
        { label: 'Change Banner', icon: 'ri-landscape-line', onClick: () => handleBannerImageClick(cat) },
        can('delete') && { divider: true },
        can('delete') && { label: 'Delete', icon: 'ri-delete-bin-line', color: T.red, onClick: () => handleOpenDeleteModal(cat) },
    ];
    const featuredMenu = (fc, { allowAddSub }) => [
        { label: 'Edit Details', icon: 'ri-edit-line', color: T.blue, onClick: () => handleOpenFeaturedEditModal(fc) },
        allowAddSub && can('add') && { label: 'Add Sub Category', icon: 'ri-add-circle-line', onClick: () => openAdd({ type: 'featured', isParent: false, parentId: fc._id }) },
        { label: 'Update Image', icon: 'ri-image-edit-line', onClick: () => { setSelectedFeatured(fc); setOpenFeaturedImgModal(true); } },
        { label: 'Update Banner', icon: 'ri-landscape-line', onClick: () => { setSelectedFeatured(fc); setOpenFeaturedBannerModal(true); } },
        { divider: true },
        { label: 'Delete', icon: 'ri-delete-bin-line', color: T.red, onClick: () => { setSelectedFeatured(fc); setOpenFeaturedDeleteModal(true); } },
    ];

    // ═══════════════════════════ Render pieces ═══════════════════════════════
    const PARENT_COLS = '76px minmax(220px,1fr) 190px 130px 56px';
    const SUB_COLS = '56px minmax(220px,1fr) 200px 110px 150px 120px 56px';
    const FEAT_COLS = '76px minmax(230px,1fr) 210px 150px 130px 56px';

    const tabs = [
        { key: 'parent', label: 'Parent Categories', icon: 'ri-layout-grid-line', count: parentTree.length },
        { key: 'sub', label: 'Sub Categories', icon: 'ri-list-check-2', count: allSubs.length },
        { key: 'featured', label: 'Featured Categories', icon: 'ri-star-line', count: featuredTree.length },
    ];

    const searchPlaceholder = activeTab === 'parent' ? 'Search parent categories…' : activeTab === 'sub' ? 'Search sub or parent categories…' : 'Search featured categories…';

    const renderParentTab = () => {
        const pageRows = paged(parentTree, parentPage);
        const start = (parentPage - 1) * rowsPerPage;
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '4px 0 12px', gap: '12px', flexWrap: 'wrap' }}>
                    <button type="button" style={{ ...ghostBtn, height: '32px' }} onClick={downloadCategoryReport} disabled={isDownloadLoading}>
                        {isDownloadLoading ? <><Spinner as="span" animation="border" size="sm" /> Downloading…</> : <><i className="ri-download-line" /> Export</>}
                    </button>
                    <span style={{ fontSize: '12px', color: T.textMuted }}>{showingText(parentTree.length, parentPage, 'parent categories')}</span>
                </div>
                {isListLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '40px', color: T.textFaint }}><Spinner animation="border" size="sm" /><span style={{ marginLeft: 8, fontSize: 13 }}>Loading…</span></div>
                ) : parentTree.length === 0 ? (
                    <EmptyState icon="ri-folder-3-line" text={activeFilterCount ? 'No parent categories match your filters' : 'No parent categories yet'}
                        action={!activeFilterCount && can('add') && <button type="button" style={primaryBtn} onClick={() => openAdd({ type: 'normal', isParent: true })}><i className="ri-add-line" /> Create Category</button>} />
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <div style={{ minWidth: 820 }}>
                            <GridHeader cols={PARENT_COLS} labels={['#', 'Parent Category', 'Sub Categories', 'Status', 'Actions']} />
                            {pageRows.map((row, i) => {
                                const cat = row.parent;
                                const open = isOpen(cat._id, row.autoOpen);
                                return (
                                    <div key={cat._id} style={{ ...rowCard, borderColor: open ? T.borderMid : T.border }}>
                                        <div style={rowGrid(PARENT_COLS)}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500', color: T.textPrimary }}>
                                                {start + i + 1}
                                                <ExpandToggle open={open} disabled={row.total === 0} onClick={() => toggleRow(cat._id, row.autoOpen)} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                                                <Thumb src={cat.displayImage} alt={cat.name} onClick={() => handleImageClick(cat)} size={52} />
                                                <div style={{ minWidth: 0 }}>
                                                    <div style={{ fontWeight: '600', fontSize: '13px', color: T.textPrimary, display: 'flex', alignItems: 'center', gap: '4px 10px', flexWrap: 'wrap' }}>
                                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cat.name}</span>
                                                        <FoodTags types={cat.foodType} />
                                                    </div>
                                                    <div style={{ fontSize: '11px', color: T.textFaint, marginTop: '2px' }}>({subLabel(row.total)})</div>
                                                </div>
                                            </div>
                                            <div>
                                                {row.total > 0 ? (
                                                    <button type="button" onClick={() => toggleRow(cat._id, row.autoOpen)} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: T.textPrimary, display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                        <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} style={{ color: T.textFaint }} />
                                                        {plural(row.total, 'Sub Category', 'Sub Categories')}
                                                    </button>
                                                ) : can('add') ? (
                                                    <button type="button" onClick={() => openAdd({ type: 'normal', isParent: false, parentId: cat._id })} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: T.blue }}>
                                                        + Add sub category
                                                    </button>
                                                ) : <span style={{ fontSize: '12px', color: T.textFaint }}>—</span>}
                                            </div>
                                            <div>
                                                <StatusPill status={cat.status} />
                                                {cat.orderType && cat.orderType !== 'ALL' && <div style={{ fontSize: '10px', fontWeight: '600', marginTop: '4px', color: T.purple }}>{cat.orderType}</div>}
                                            </div>
                                            <div style={{ textAlign: 'right' }}><KebabMenu id={`dd-${cat._id}`} items={categoryMenu(cat, { allowAddSub: true })} /></div>
                                        </div>
                                        {open && row.subs.length > 0 && (
                                            <div style={{ background: '#FAFBFE', borderTop: `1px solid ${T.border}` }}>
                                                {row.subs.map((s) => {
                                                    const items = s.productCount ?? s.itemsCount ?? s.productsCount;
                                                    return (
                                                        <div key={s._id} style={{ ...rowGrid(PARENT_COLS), borderBottom: `1px solid ${T.border}` }}>
                                                            <div style={{ paddingLeft: '30px', color: T.borderMid }}><i className="ri-corner-down-right-line" style={{ fontSize: '16px' }} /></div>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                                                                <Thumb src={s.displayImage} alt={s.name} onClick={() => handleImageClick(s)} size={36} />
                                                                <span style={{ fontWeight: '500', fontSize: '13px', color: T.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</span>
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: T.textFaint }}>{typeof items === 'number' ? plural(items, 'item', 'items') : ''}</div>
                                                            <div><StatusPill status={s.status} /></div>
                                                            <div style={{ textAlign: 'right' }}><KebabMenu id={`sdd-${s._id}`} items={categoryMenu(s, { allowAddSub: false })} /></div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                <Pager page={parentPage} totalPages={pagesOf(parentTree)} onChange={setParentPage} />
            </>
        );
    };

    const renderSubTab = () => {
        const pageRows = paged(flatSubs, subPage);
        const start = (subPage - 1) * rowsPerPage;
        const counts = { all: allSubs.length, normal: allSubs.filter((r) => r.kind === 'normal').length, featured: allSubs.filter((r) => r.kind === 'featured').length };
        const kinds = [{ key: 'all', label: 'All' }, { key: 'normal', label: 'Normal' }, { key: 'featured', label: 'Featured' }];
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '4px 0 12px', gap: '12px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                        <div style={{ display: 'inline-flex', background: T.bg, border: `1px solid ${T.border}`, borderRadius: '8px', padding: '2px' }}>
                            {kinds.map((k) => {
                                const on = subKind === k.key;
                                return (
                                    <button key={k.key} type="button" onClick={() => setSubKind(k.key)}
                                        style={{ border: 'none', height: '28px', padding: '0 12px', borderRadius: '6px', fontSize: '12px', fontWeight: on ? '600' : '500', fontFamily: 'inherit', cursor: 'pointer', background: on ? T.surface : 'transparent', color: on ? T.blue : T.textMuted, boxShadow: on ? '0 1px 2px rgba(15,29,69,.12)' : 'none' }}>
                                        {k.label} <span style={{ color: T.textFaint, fontWeight: 500 }}>{counts[k.key]}</span>
                                    </button>
                                );
                            })}
                        </div>
                        {can('add') && (
                            <button type="button" style={{ ...ghostBtn, height: '32px', color: T.blue, borderColor: T.blue }}
                                onClick={() => openAdd({ type: subKind === 'featured' ? 'featured' : 'normal', isParent: false })}>
                                <i className="ri-add-line" /> Add {subKind === 'featured' ? 'Featured ' : ''}Sub Category
                            </button>
                        )}
                    </div>
                    <span style={{ fontSize: '12px', color: T.textMuted }}>{showingText(flatSubs.length, subPage, 'sub categories')}</span>
                </div>
                {(isListLoading || isFeaturedListLoading) && flatSubs.length === 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '40px', color: T.textFaint }}><Spinner animation="border" size="sm" /></div>
                ) : flatSubs.length === 0 ? (
                    <EmptyState icon="ri-list-check-2" text={activeFilterCount ? 'No sub categories match your filters' : 'No sub categories yet'} />
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <div style={{ minWidth: 960 }}>
                            <GridHeader cols={SUB_COLS} labels={['#', 'Sub Category', 'Parent Category', 'Type', 'Food Type', 'Status', 'Actions']} />
                            {pageRows.map((r, i) => {
                                const s = r.sub;
                                const isFeat = r.kind === 'featured';
                                const items = s.productCount ?? s.itemsCount ?? s.productsCount;
                                return (
                                    <div key={`${r.kind}-${s._id}`} style={rowCard}>
                                        <div style={rowGrid(SUB_COLS)}>
                                            <div style={{ fontSize: '13px', fontWeight: '500' }}>{start + i + 1}</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                                                <Thumb src={s.displayImage} alt={s.name} size={44}
                                                    onClick={() => (isFeat ? (setSelectedFeatured(s), setOpenFeaturedImgModal(true)) : handleImageClick(s))} />
                                                <div style={{ minWidth: 0 }}>
                                                    <div style={{ fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</div>
                                                    {isFeat && s.validityStartDate && s.validityEndDate ? (
                                                        <div style={{ fontSize: '11px', color: T.textFaint, marginTop: '2px' }}>{formatDateDisplayUTC(s.validityStartDate)} – {formatDateDisplayUTC(s.validityEndDate)}</div>
                                                    ) : typeof items === 'number' ? (
                                                        <div style={{ fontSize: '11px', color: T.textFaint, marginTop: '2px' }}>{plural(items, 'item', 'items')}</div>
                                                    ) : null}
                                                    {isFeat && <ExclNote list={s.excludedOutletDetails} />}
                                                </div>
                                            </div>
                                            <div style={{ fontSize: '12px', color: T.textMuted, minWidth: 0 }}>
                                                {r.parent?.name
                                                    ? <span title={r.parent.name} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', maxWidth: '100%' }}><i className={isFeat ? 'ri-star-line' : 'ri-folder-3-line'} style={{ color: T.textFaint }} /><span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.parent.name}</span></span>
                                                    : <span style={{ color: T.red }}>No parent</span>}
                                            </div>
                                            <div>
                                                <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: '600', background: isFeat ? '#FFF7E6' : T.blueLight, color: isFeat ? '#B45309' : T.blue }}>
                                                    {isFeat ? 'Featured' : 'Normal'}
                                                </span>
                                            </div>
                                            <div><FoodTags types={r.parent?.foodType} /></div>
                                            <div><StatusPill status={s.status} /></div>
                                            <div style={{ textAlign: 'right' }}>
                                                <KebabMenu id={`subdd-${r.kind}-${s._id}`} items={isFeat ? featuredMenu(s, { allowAddSub: false }) : categoryMenu(s, { allowAddSub: false })} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                <Pager page={subPage} totalPages={pagesOf(flatSubs)} onChange={setSubPage} />
            </>
        );
    };

    const renderFeaturedTab = () => {
        const pageRows = paged(featuredTree, featuredPage);
        const start = (featuredPage - 1) * rowsPerPage;
        const now = new Date();
        const liveOf = (fc) => fc.status === 'ACTIVE' && new Date(fc.validityStartDate) <= now && new Date(fc.validityEndDate) >= now;
        const validity = (fc) => (
            <div style={{ fontSize: '12px', color: T.textMuted }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><i className="ri-calendar-line" style={{ color: T.textFaint }} />{formatDateDisplayUTC(fc.validityStartDate)}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '3px' }}><i className="ri-calendar-check-line" style={{ color: T.textFaint }} />{formatDateDisplayUTC(fc.validityEndDate)}</div>
                {liveOf(fc) && <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '4px', fontSize: '10px', fontWeight: '700', color: T.green, textTransform: 'uppercase', letterSpacing: '0.5px' }}><span style={{ width: 5, height: 5, borderRadius: '50%', background: '#22C55E' }} />Live</span>}
            </div>
        );
        const productSummary = (fc) => {
            const names = (fc.products || []).map((p) => p.productDetail?.name).filter(Boolean);
            if (!names.length) return <span style={{ fontSize: '12px', color: T.textFaint }}>No products</span>;
            return <span title={names.join(', ')} style={{ fontSize: '12px', color: T.textMuted }}>{names.slice(0, 2).join(', ')}{names.length > 2 ? ` +${names.length - 2} more` : ''}</span>;
        };
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '4px 0 12px', gap: '12px', flexWrap: 'wrap' }}>
                    <button type="button" style={{ ...ghostBtn, height: '32px' }} onClick={getFeaturedCategoryList} disabled={isFeaturedListLoading}>
                        {isFeaturedListLoading ? <><Spinner as="span" animation="border" size="sm" /> Refreshing…</> : <><i className="ri-refresh-line" /> Refresh</>}
                    </button>
                    <span style={{ fontSize: '12px', color: T.textMuted }}>{showingText(featuredTree.length, featuredPage, 'featured parent categories')}</span>
                </div>
                {isFeaturedListLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '40px', color: T.textFaint }}><Spinner animation="border" size="sm" /><span style={{ marginLeft: 8, fontSize: 13 }}>Loading…</span></div>
                ) : featuredTree.length === 0 ? (
                    <EmptyState icon="ri-star-line" text={activeFilterCount ? 'No featured categories match your filters' : 'No featured categories yet'}
                        action={!activeFilterCount && can('add') && <button type="button" style={primaryBtn} onClick={() => openAdd({ type: 'featured', isParent: true })}><i className="ri-add-line" /> Create Featured Category</button>} />
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <div style={{ minWidth: 900 }}>
                            <GridHeader cols={FEAT_COLS} labels={['#', 'Featured Category', 'Sub Categories', 'Validity', 'Status', 'Actions']} />
                            {pageRows.map((row, i) => {
                                const fc = row.parent;
                                const open = isOpen(fc._id, row.autoOpen);
                                return (
                                    <div key={fc._id} style={{ ...rowCard, borderColor: open ? T.borderMid : T.border }}>
                                        <div style={rowGrid(FEAT_COLS)}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}>
                                                {start + i + 1}
                                                <ExpandToggle open={open} disabled={row.total === 0} onClick={() => toggleRow(fc._id, row.autoOpen)} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                                                <Thumb src={fc.displayImage} alt={fc.name} onClick={() => { setSelectedFeatured(fc); setOpenFeaturedImgModal(true); }} size={52} />
                                                <div style={{ minWidth: 0 }}>
                                                    <div style={{ fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px 10px', flexWrap: 'wrap' }}>
                                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fc.name}</span>
                                                        <FoodTags types={fc.foodType} />
                                                    </div>
                                                    <div style={{ fontSize: '11px', color: T.textFaint, marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>({subLabel(row.total)}){fc.description ? ` · ${fc.description}` : ''}</div>
                                                    <ExclNote list={fc.excludedOutletDetails} />
                                                </div>
                                            </div>
                                            <div>
                                                {row.total > 0 ? (
                                                    <button type="button" onClick={() => toggleRow(fc._id, row.autoOpen)} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: T.textPrimary, display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                        <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} style={{ color: T.textFaint }} />
                                                        {plural(row.total, 'Sub Category', 'Sub Categories')}
                                                    </button>
                                                ) : can('add') ? (
                                                    <button type="button" onClick={() => openAdd({ type: 'featured', isParent: false, parentId: fc._id })} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: T.blue }}>+ Add sub category</button>
                                                ) : <span style={{ fontSize: '12px', color: T.textFaint }}>—</span>}
                                            </div>
                                            <div>{validity(fc)}</div>
                                            <div>
                                                <StatusPill status={fc.status} />
                                                {fc.orderType && fc.orderType !== 'ALL' && <div style={{ fontSize: '10px', fontWeight: '600', marginTop: '4px', color: T.purple }}>{fc.orderType}</div>}
                                            </div>
                                            <div style={{ textAlign: 'right' }}><KebabMenu id={`fdd-${fc._id}`} items={featuredMenu(fc, { allowAddSub: true })} /></div>
                                        </div>
                                        {open && row.subs.length > 0 && (
                                            <div style={{ background: '#FAFBFE', borderTop: `1px solid ${T.border}` }}>
                                                {row.subs.map((s) => (
                                                    <div key={s._id} style={{ ...rowGrid(FEAT_COLS), borderBottom: `1px solid ${T.border}` }}>
                                                        <div style={{ paddingLeft: '30px', color: T.borderMid }}><i className="ri-corner-down-right-line" style={{ fontSize: '16px' }} /></div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                                                            <Thumb src={s.displayImage} alt={s.name} onClick={() => { setSelectedFeatured(s); setOpenFeaturedImgModal(true); }} size={36} />
                                                            <div style={{ minWidth: 0 }}>
                                                                <div style={{ fontWeight: '500', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</div>
                                                                <ExclNote list={s.excludedOutletDetails} />
                                                            </div>
                                                        </div>
                                                        <div>{productSummary(s)}</div>
                                                        <div>{validity(s)}</div>
                                                        <div><StatusPill status={s.status} /></div>
                                                        <div style={{ textAlign: 'right' }}><KebabMenu id={`fsdd-${s._id}`} items={featuredMenu(s, { allowAddSub: false })} /></div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                <Pager page={featuredPage} totalPages={pagesOf(featuredTree)} onChange={setFeaturedPage} />
            </>
        );
    };

    // ═══════════════════════════ JSX ═════════════════════════════════════════
    const spinner = <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />;
    const manageFoodHandler = canManageFood ? () => setOpenFoodManager(true) : undefined;

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />

            <div className="main main-app p-3 p-lg-4" style={{ background: T.bg, minHeight: '100vh' }}>

                {/* ── Hero banner ── */}
                <div style={{ background: `linear-gradient(135deg, ${T.navy} 0%, ${T.navy2} 100%)`, borderRadius: '12px', padding: '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div style={{ width: 52, height: 52, borderRadius: '12px', background: T.blue, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0 }}>
                            <i className="ri-price-tag-3-line" />
                        </div>
                        <div>
                            <p style={{ margin: 0, fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', color: 'rgba(255,255,255,0.65)' }}>Menu</p>
                            <h5 style={{ margin: '2px 0 4px', fontSize: '20px', fontWeight: '600', color: '#fff' }}>Category Management</h5>
                            <p style={{ margin: 0, fontSize: '12px', color: 'rgba(255,255,255,0.75)' }}>Organize your menu with categories, subcategories and featured sections.</p>
                        </div>
                    </div>
                    {can('add') && (
                        // One create button — adds a featured category on the Featured tab, a parent category otherwise.
                        <button
                            type="button"
                            style={{ ...primaryBtn, background: '#2F6BFF', borderColor: '#2F6BFF' }}
                            onClick={() => openAdd(activeTab === 'featured' ? { type: 'featured', isParent: true } : { type: 'normal', isParent: true })}
                        >
                            <i className="ri-add-line" /> {activeTab === 'featured' ? 'Create Featured Category' : 'Create Category'}
                        </button>
                    )}
                </div>

                {/* ── Main card ── */}
                <div style={{ background: T.surface, borderRadius: '12px', border: `1px solid ${T.border}` }}>
                    {/* Tabs */}
                    <div style={{ display: 'flex', gap: '8px', padding: '0 16px', borderBottom: `1px solid ${T.border}`, overflowX: 'auto' }}>
                        {tabs.map((t) => {
                            const on = activeTab === t.key;
                            return (
                                <button type="button" key={t.key} onClick={() => setActiveTab(t.key)}
                                    style={{ height: '52px', padding: '0 16px', border: 'none', borderBottom: `2px solid ${on ? T.blue : 'transparent'}`, background: 'transparent', color: on ? T.blue : T.textMuted, fontSize: '13px', fontWeight: on ? '600' : '500', cursor: 'pointer', fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                                    <i className={t.icon} style={{ fontSize: '16px' }} />{t.label}
                                    <span style={{ minWidth: 20, padding: '1px 6px', borderRadius: '999px', fontSize: '11px', fontWeight: '600', background: on ? T.blueLight : T.bg, color: on ? T.blue : T.textFaint }}>{t.count}</span>
                                </button>
                            );
                        })}
                    </div>

                    <div style={{ padding: '16px 20px 20px' }}>
                        {/* Filter bar */}
                        {can('get') && (
                            <>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                                    <div style={{ position: 'relative', flex: '1 1 260px', minWidth: '220px' }}>
                                        <i className="ri-search-line" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: T.textFaint, fontSize: '15px' }} />
                                        <input type="text" style={{ ...inputStyle, height: '40px', paddingLeft: '36px', background: T.bg }} value={filters.search}
                                            onChange={(e) => setFilters((f) => ({ ...f, search: e.target.value }))} placeholder={searchPlaceholder} />
                                    </div>
                                    <select style={{ ...inputStyle, height: '40px', width: '150px', background: T.bg }} value={filters.status} onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))}>
                                        <option value="all">All Status</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                    </select>
                                    <div style={{ flex: '1 1 220px', minWidth: '200px', maxWidth: '340px' }}>
                                        <Select
                                            isMulti
                                            components={animatedComponents}
                                            options={foodTypeOptions}
                                            value={foodTypeOptions.filter((o) => filters.foodType.includes(o.value))}
                                            onChange={(sel) => setFilters((f) => ({ ...f, foodType: (sel || []).map((s) => s.value) }))}
                                            styles={filterSelectStyles}
                                            placeholder="All Types"
                                            closeMenuOnSelect={false}
                                            menuPortalTarget={document.body}
                                        />
                                    </div>
                                    {manageFoodHandler && (
                                        <button type="button" style={{ ...ghostBtn, height: '40px', background: T.bg }} onClick={manageFoodHandler} title="Add, rename or delete food types">
                                            <i className="ri-settings-3-line" /> Food Types
                                        </button>
                                    )}
                                    <button type="button" style={{ ...ghostBtn, height: '40px', background: T.bg }} onClick={() => setFilters((f) => ({ ...f, search: f.search.trim() }))}>
                                        <i className="ri-filter-3-line" /> Filter{activeFilterCount > 0 && <span style={{ background: T.blue, color: '#fff', borderRadius: '999px', fontSize: '10px', padding: '1px 6px' }}>{activeFilterCount}</span>}
                                    </button>
                                    <button type="button" style={{ ...ghostBtn, height: '40px', background: T.bg }} onClick={() => setFilters(EMPTY_FILTERS)} disabled={activeFilterCount === 0}>
                                        <i className="ri-refresh-line" /> Clear
                                    </button>
                                </div>

                                {activeTab === 'parent' && renderParentTab()}
                                {activeTab === 'sub' && renderSubTab()}
                                {activeTab === 'featured' && renderFeaturedTab()}
                            </>
                        )}
                    </div>
                </div>

                {/* ═══════════════ FOOD TYPE MANAGER ═══════════════ */}
                <FoodTypeManager
                    show={openFoodManager} onHide={() => setOpenFoodManager(false)} items={foodTypes}
                    onAdd={addFoodType} onUpdate={updateFoodType} onDelete={deleteFoodType}
                    canAdd={can('add')} canEdit={can('update')} canDelete={can('delete')}
                />

                {/* ═══════════════ ADD MODAL ═══════════════ */}
                <Modal show={openAddModal} onHide={handleCloseAddModal} size="lg" centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                            <span style={{ fontSize: '15px', fontWeight: '600', color: T.textPrimary }}>
                                {addCategoryType === 'normal' ? 'Add New Category' : 'Add Featured Category'}
                            </span>
                            <div style={{ display: 'inline-flex', border: `1px solid ${T.borderMid}`, borderRadius: '6px', overflow: 'hidden', width: 'fit-content' }}>
                                {[{ key: 'normal', label: 'Normal Category' }, { key: 'featured', label: 'Featured Category' }].map(({ key, label }) => (
                                    <button type="button" key={key} onClick={() => setAddCategoryType(key)}
                                        style={{ height: '30px', padding: '0 16px', border: 'none', background: addCategoryType === key ? T.blue : T.surface, color: addCategoryType === key ? '#fff' : T.textMuted, fontSize: '12px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit', borderRight: key === 'normal' ? `1px solid ${T.borderMid}` : 'none' }}>
                                        {label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </Modal.Header>

                    {/* ── Normal form ── */}
                    {addCategoryType === 'normal' && (
                        <Form onSubmit={addCategory} noValidate>
                            <Modal.Body style={modalBodyStyle}>
                                <HierarchyFields data={inputData} onPatch={patchInput} parentOptions={categoryParentOptions} kind="category" foodTypes={foodTypes} onManageFood={manageFoodHandler} />
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '14px' }}>
                                    <Field label="Category Name" required>
                                        <input autoFocus style={inputStyle} name="name" value={inputData.name} type="text" placeholder="e.g. Hot Classics" onChange={handleChange} />
                                    </Field>
                                    <Field label="Outlet Type" required>
                                        <select style={inputStyle} name="isEventCategory" value={inputData.isEventCategory} onChange={handleChange}>
                                            <option value="">Select type</option>
                                            <option value="false">Regular outlet</option>
                                            <option value="true">Event outlet</option>
                                        </select>
                                    </Field>
                                </div>
                                <SequencePicker list={categoryList} value={inputData.sequenceNumber} onChange={(v) => patchInput({ sequenceNumber: v })} />
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '14px' }}>
                                    <Field label="Order Type" required>
                                        <select style={inputStyle} name="orderType" value={inputData.orderType} onChange={handleChange}>
                                            <option value="ALL">All</option>
                                            <option value="DELIVERY">Delivery</option>
                                            <option value="PICKUP">Pick-up</option>
                                        </select>
                                    </Field>
                                    <Field label="Excluded Outlets">
                                        <Select isMulti components={animatedComponents} value={selectedExcludedOutlets} onChange={(s) => setSelectedExcludedOutlets(s || [])} options={outletData} styles={selectStyles} placeholder="Select outlets to exclude…" closeMenuOnSelect={false} menuPortalTarget={document.body} />
                                    </Field>
                                </div>
                                <Field label="Description" required>
                                    <textarea style={{ ...inputStyle, height: '72px', padding: '8px 10px', resize: 'vertical' }} name="description" value={inputData.description} placeholder="Brief description of this category" onChange={handleChange} />
                                </Field>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                                    <Field label="Banner Image (1000×200 px)" required hint="Recommended size: exactly 1000×200 px">
                                        <FileInputField inputKey={normalBannerKey} file={bannerImage} id="categoryBannerInput" onChange={handleBannerImageChange}
                                            onClear={() => { setBannerImage(null); setNormalBannerKey((k) => k + 1); }} />
                                    </Field>
                                    <Field label="Category Image" required hint="jpg or png">
                                        <FileInputField inputKey={normalImgKey} file={image} id="categoryImageInput" onChange={handleImageChange}
                                            onClear={() => { setImage(null); setNormalImgKey((k) => k + 1); }} />
                                    </Field>
                                </div>
                            </Modal.Body>
                            <Modal.Footer style={modalFooterStyle}>
                                <MissingNote items={normalMissing} />
                                <button type="button" style={ghostBtn} onClick={handleCloseAddModal}>Cancel</button>
                                <button type="submit" style={{ ...primaryBtn, opacity: normalInvalid ? 0.5 : 1, cursor: normalInvalid ? 'not-allowed' : 'pointer' }} disabled={normalInvalid}>
                                    {isLoading ? spinner : (inputData.isParentCategory ? 'Add Parent Category' : 'Add Sub Category')}
                                </button>
                            </Modal.Footer>
                        </Form>
                    )}

                    {/* ── Featured form ── */}
                    {addCategoryType === 'featured' && (
                        <Form onSubmit={addFeaturedCategory} noValidate>
                            <Modal.Body style={modalBodyStyle}>
                                <HierarchyFields data={featuredData} onPatch={patchFeatured} parentOptions={featuredParentOptions} kind="featured category" foodTypes={foodTypes} onManageFood={manageFoodHandler} />
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '14px' }}>
                                    <Field label="Collection Name" required>
                                        <input autoFocus style={inputStyle} name="name" value={featuredData.name} type="text" placeholder="e.g. Summer Collection" onChange={handleFeaturedChange} />
                                    </Field>
                                    <Field label="Order Type" required>
                                        <select style={inputStyle} name="orderType" value={featuredData.orderType} onChange={handleFeaturedChange}>
                                            <option value="ALL">All</option>
                                            <option value="DELIVERY">Delivery</option>
                                            <option value="PICKUP">Pick-up</option>
                                        </select>
                                    </Field>
                                </div>
                                <SequencePicker list={featuredCategoryList} value={featuredData.sequenceNumber} onChange={(v) => patchFeatured({ sequenceNumber: v })} />
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                                    <Field label="Validity Start Date" required>
                                        <DatePicker
                                            selected={featuredData.validityStartDate ? new Date(`${featuredData.validityStartDate}T00:00:00`) : null}
                                            onChange={(date) => setFeaturedData((p) => {
                                                const start = date ? formatDateLocal(date) : "";
                                                // drop an end date that is now before the new start
                                                const endBad = start && p.validityEndDate && p.validityEndDate < start;
                                                return { ...p, validityStartDate: start, validityEndDate: endBad ? "" : p.validityEndDate };
                                            })}
                                            dateFormat="yyyy-MM-dd" placeholderText="Select start date" minDate={new Date()} isClearable
                                            customInput={<input style={inputStyle} readOnly />} wrapperClassName="w-100" popperPlacement="bottom-start"
                                        />
                                    </Field>
                                    <Field label="Validity End Date" required>
                                        <DatePicker
                                            selected={featuredData.validityEndDate ? new Date(`${featuredData.validityEndDate}T00:00:00`) : null}
                                            onChange={(date) => patchFeatured({ validityEndDate: date ? formatDateLocal(date) : "" })}
                                            dateFormat="yyyy-MM-dd" placeholderText="Select end date"
                                            minDate={featuredData.validityStartDate ? new Date(`${featuredData.validityStartDate}T00:00:00`) : new Date()} isClearable
                                            customInput={<input style={inputStyle} readOnly />} wrapperClassName="w-100" popperPlacement="bottom-start"
                                        />
                                    </Field>
                                </div>
                                <Field label="Description" required>
                                    <textarea style={{ ...inputStyle, height: '66px', padding: '8px 10px', resize: 'vertical' }} name="description" value={featuredData.description} placeholder="e.g. Featured products for summer season" onChange={handleFeaturedChange} />
                                </Field>
                                <ExcludedOutletsField value={featuredData.excludedOutlets} onChange={(v) => patchFeatured({ excludedOutlets: v })} outletData={outletData} />
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                                    <Field label="Banner Image (1000×200 px)" required hint="Exactly 1000×200 px. jpg, png, webp or avif.">
                                        <FileInputField inputKey={featuredBannerInputKey} file={featuredAddBannerImage} id="featuredBannerImageInput" accept="image/png,image/jpeg,image/webp,image/avif"
                                            onChange={handleFeaturedBannerImageChange} onClear={() => { setFeaturedAddBannerImage(null); setFeaturedBannerInputKey((k) => k + 1); }} />
                                    </Field>
                                    <Field label="Category Image" required hint="jpg, png, webp or avif.">
                                        <FileInputField inputKey={featuredImgInputKey} file={featuredAddImage} id="featuredCategoryImageInput" accept="image/png,image/jpeg,image/webp,image/avif"
                                            onChange={handleFeaturedImageChange} onClear={() => { setFeaturedAddImage(null); setFeaturedImgInputKey((k) => k + 1); }} />
                                    </Field>
                                </div>
                                <ProductRowsEditor rows={featuredProducts} setRows={setFeaturedProducts} productOptions={productOptions} outletData={outletData} disabled={featuredData.isParentCategory} />
                            </Modal.Body>
                            <Modal.Footer style={modalFooterStyle}>
                                <MissingNote items={featuredMissing} />
                                <button type="button" style={ghostBtn} onClick={handleCloseAddModal}>Cancel</button>
                                <button type="submit" style={{ ...primaryBtn, opacity: isFeaturedFormInvalid ? 0.5 : 1, cursor: isFeaturedFormInvalid ? 'not-allowed' : 'pointer' }} disabled={isFeaturedFormInvalid}>
                                    {isFeaturedLoading ? spinner : <><i className="ri-star-line" /> {featuredData.isParentCategory ? 'Create Featured Parent' : 'Create Featured Sub'}</>}
                                </button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Modal>

                {/* ═══════════════ EDIT (NORMAL) ═══════════════ */}
                <Modal show={openEditModal} onHide={() => setOpenEditModal(false)} size="lg" centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Update Category</Modal.Title></Modal.Header>
                    <Form onSubmit={editCategory} noValidate>
                        <Modal.Body style={modalBodyStyle}>
                            <HierarchyFields
                                data={editedData} onPatch={patchEdited} kind="category"
                                parentOptions={parentOptionsFor(categoryList, editedData?.id)}
                                lockSub={editSubCount > 0}
                                lockHint={`Has ${plural(editSubCount, 'sub category', 'sub categories')} — move or delete them before converting.`}
                                foodTypes={foodTypes} onManageFood={manageFoodHandler}
                            />
                            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '14px' }}>
                                <Field label="Category Name" required>
                                    <input style={inputStyle} name="name" value={editedData?.name || ''} type="text" placeholder="Category name" onChange={handleEditChange} />
                                </Field>
                                <Field label="Outlet Type" required>
                                    <select style={inputStyle} name="isEventCategory" value={editedData?.isEventCategory ?? ''} onChange={handleEditChange}>
                                        <option value="">Select</option>
                                        <option value="false">Regular outlet</option>
                                        <option value="true">Event outlet</option>
                                    </select>
                                </Field>
                                <Field label="Status" required>
                                    <select style={inputStyle} name="status" value={editedData?.status || ''} onChange={handleEditChange}>
                                        <option value="">Select status</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                    </select>
                                </Field>
                            </div>
                            <SequencePicker list={categoryList} excludeId={editedData?.id} value={editedData?.sequenceNumber} onChange={(v) => patchEdited({ sequenceNumber: v })} />
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: '14px' }}>
                                <Field label="Order Type" required>
                                    <select style={inputStyle} name="orderType" value={editedData.orderType || ""} onChange={handleEditChange}>
                                        <option value="" disabled>Select</option>
                                        <option value="ALL">All</option>
                                        <option value="DELIVERY">Delivery</option>
                                        <option value="PICKUP">Pick-up</option>
                                    </select>
                                </Field>
                                <Field label="Combo Category" required>
                                    <select style={inputStyle} name="isComboCategory" value={editedData?.isComboCategory ?? ''} onChange={handleEditChange}>
                                        <option value="">Select</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </Field>
                                <Field label="Excluded Outlets">
                                    <Select isMulti components={animatedComponents} value={editedSelectedExOutlets} onChange={(s) => setEditedSelectedExOutlets(s || [])} options={outletData} styles={selectStyles} placeholder="Select outlets to exclude…" closeMenuOnSelect={false} menuPortalTarget={document.body} />
                                </Field>
                            </div>
                            <Field label="Description" required>
                                <textarea style={{ ...inputStyle, height: '72px', padding: '8px 10px', resize: 'vertical' }} name="description" value={editedData.description || ''} placeholder="Brief description" onChange={handleEditChange} />
                            </Field>
                        </Modal.Body>
                        <Modal.Footer style={modalFooterStyle}>
                            <MissingNote items={editMissing} />
                            <button type="button" style={ghostBtn} onClick={() => setOpenEditModal(false)}>Cancel</button>
                            <button type="submit" style={{ ...primaryBtn, opacity: editInvalid ? 0.5 : 1, cursor: editInvalid ? 'not-allowed' : 'pointer' }} disabled={editInvalid}>
                                {isEditLoading ? spinner : 'Save Changes'}
                            </button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* ═══════════════ DELETE (NORMAL) ═══════════════ */}
                <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Delete Category</Modal.Title></Modal.Header>
                    <Modal.Body style={{ padding: '20px', fontSize: '14px', color: T.textMuted }}>
                        Delete <strong style={{ color: T.textPrimary }}>{deleteTarget?.name}</strong>? This action cannot be undone.
                        {(subCountByParent[deleteTarget?._id] || 0) > 0 && (
                            <div style={{ marginTop: '12px', padding: '10px 12px', background: T.amberLight, color: T.amber, borderRadius: '6px', fontSize: '13px', display: 'flex', gap: '8px' }}>
                                <i className="ri-error-warning-line" />
                                This parent has {plural(subCountByParent[deleteTarget._id], 'sub category', 'sub categories')}. Make sure they are moved or removed first.
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={modalFooterStyle}>
                        <button type="button" style={ghostBtn} onClick={() => setOpenDeleteModal(false)}>Cancel</button>
                        <button type="button" style={dangerBtn} onClick={deleteCategory}>{isDeleteLoading ? spinner : 'Delete'}</button>
                    </Modal.Footer>
                </Modal>

                {/* ═══════════════ IMAGE / BANNER PREVIEW (NORMAL) ═══════════════ */}
                <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Category Image</Modal.Title></Modal.Header>
                    <Modal.Body style={{ padding: '20px', textAlign: 'center' }}>
                        {selectedImage?.displayImage ? (
                            <>
                                <img src={selectedImage.displayImage} alt="preview" style={{ width: '50%', height: 'auto', borderRadius: '12px', border: `1px solid ${T.border}` }} />
                                {can('update') && (
                                    <div style={{ marginTop: '16px' }}>
                                        <button type="button" style={ghostBtn} onClick={() => handleImageUploadModal({ displayImage: selectedImage.displayImage, _id: selectedImage._id })}><i className="ri-image-edit-line" /> Change Image</button>
                                    </div>
                                )}
                            </>
                        ) : <p style={{ color: T.textFaint }}>No image uploaded.</p>}
                    </Modal.Body>
                </Modal>

                <Modal show={showBannerImageModal} onHide={() => setShowBannerImageModal(false)} centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Banner Image</Modal.Title></Modal.Header>
                    <Modal.Body style={{ padding: '20px' }}>
                        {selectedImage?.bannerImage ? (
                            <>
                                <img src={selectedImage.bannerImage} alt="banner preview" style={{ width: '100%', height: 'auto', borderRadius: '6px', border: `1px solid ${T.border}` }} />
                                {can('update') && (
                                    <div style={{ marginTop: '14px' }}>
                                        <button type="button" style={ghostBtn} onClick={() => handleBannerImageUpload({ bannerImage: selectedImage.bannerImage, _id: selectedImage._id })}><i className="ri-image-edit-line" /> Change Banner</button>
                                    </div>
                                )}
                            </>
                        ) : <p style={{ color: T.textFaint }}>No banner image uploaded.</p>}
                    </Modal.Body>
                </Modal>

                {openBannerImageUploadModal && (
                    <Modal show onHide={() => setOpenBannerImageUploadModal(false)} centered backdrop="static">
                        <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Update Banner Image</Modal.Title></Modal.Header>
                        <Modal.Body style={{ padding: '20px' }}>
                            <Field label="Choose File" hint="Recommended size: exactly 1000×200 px">
                                <input style={{ ...inputStyle, height: 'auto', padding: '5px 8px' }} type="file" accept="image/*" onChange={handleEditBannerImage} ref={imageInputRef} />
                            </Field>
                        </Modal.Body>
                        <Modal.Footer style={modalFooterStyle}>
                            <button type="button" style={{ ...primaryBtn, opacity: !(bannerImage instanceof File) ? 0.5 : 1, cursor: !(bannerImage instanceof File) ? 'not-allowed' : 'pointer' }} onClick={handleBannerEditImage} disabled={!(bannerImage instanceof File)}>
                                {isImageEditBtnLoading ? spinner : 'Save Changes'}
                            </button>
                        </Modal.Footer>
                    </Modal>
                )}

                {openImageUploadModal && (
                    <Modal show onHide={() => setOpenImageUploadModal(false)} centered backdrop="static">
                        <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Update Category Image</Modal.Title></Modal.Header>
                        <Modal.Body style={{ padding: '20px' }}>
                            <Field label="Choose File" hint="jpg or png">
                                <input style={{ ...inputStyle, height: 'auto', padding: '5px 8px' }} type="file" accept="image/*" onChange={handleImageChange} />
                            </Field>
                        </Modal.Body>
                        <Modal.Footer style={modalFooterStyle}>
                            <button type="button" style={{ ...primaryBtn, opacity: !(image instanceof File) ? 0.5 : 1, cursor: !(image instanceof File) ? 'not-allowed' : 'pointer' }} onClick={handleEditImage} disabled={!(image instanceof File)}>
                                {isImageEditBtnLoading ? spinner : 'Save Changes'}
                            </button>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* ═══════════════ FEATURED — EDIT ═══════════════ */}
                <Modal show={openFeaturedEditModal} onHide={() => setOpenFeaturedEditModal(false)} size="lg" centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Update Featured Category</Modal.Title></Modal.Header>
                    <Form onSubmit={updateFeaturedCategory} noValidate>
                        <Modal.Body style={modalBodyStyle}>
                            <HierarchyFields
                                data={featuredEditData} onPatch={patchFeaturedEdit} kind="featured category"
                                parentOptions={parentOptionsFor(featuredCategoryList, featuredEditData.id)}
                                lockSub={featuredEditSubCount > 0}
                                lockHint={`Has ${plural(featuredEditSubCount, 'sub category', 'sub categories')} — move or delete them before converting.`}
                                foodTypes={foodTypes} onManageFood={manageFoodHandler}
                            />
                            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '14px' }}>
                                <Field label="Collection Name" required>
                                    <input style={inputStyle} name="name" value={featuredEditData.name || ''} type="text" placeholder="e.g. Summer Collection" onChange={handleFeaturedEditChange} />
                                </Field>
                                <Field label="Status" required>
                                    <select style={inputStyle} name="status" value={featuredEditData.status || ''} onChange={handleFeaturedEditChange}>
                                        <option value="">Select Status</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                    </select>
                                </Field>
                                <Field label="Order Type" required>
                                    <select style={inputStyle} name="orderType" value={featuredEditData.orderType || "ALL"} onChange={handleFeaturedEditChange}>
                                        <option value="ALL">All</option>
                                        <option value="DELIVERY">Delivery</option>
                                        <option value="PICKUP">Pick-up</option>
                                    </select>
                                </Field>
                            </div>
                            <SequencePicker list={featuredCategoryList} excludeId={featuredEditData.id} value={featuredEditData.sequenceNumber} onChange={(v) => patchFeaturedEdit({ sequenceNumber: v })} />
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                                <Field label="Validity Start Date" required>
                                    <DatePicker
                                        selected={featuredEditData.validityStartDate ? new Date(`${featuredEditData.validityStartDate}T00:00:00`) : null}
                                        onChange={(date) => setFeaturedEditData((p) => {
                                            const start = date ? formatDateLocal(date) : "";
                                            const endBad = start && p.validityEndDate && p.validityEndDate < start;
                                            return { ...p, validityStartDate: start, validityEndDate: endBad ? "" : p.validityEndDate };
                                        })}
                                        dateFormat="yyyy-MM-dd" placeholderText="Select start date" isClearable
                                        customInput={<input style={inputStyle} readOnly />} wrapperClassName="w-100" popperPlacement="bottom-start"
                                    />
                                </Field>
                                <Field label="Validity End Date" required>
                                    <DatePicker
                                        selected={featuredEditData.validityEndDate ? new Date(`${featuredEditData.validityEndDate}T00:00:00`) : null}
                                        onChange={(date) => patchFeaturedEdit({ validityEndDate: date ? formatDateLocal(date) : "" })}
                                        dateFormat="yyyy-MM-dd" placeholderText="Select end date"
                                        minDate={featuredEditData.validityStartDate ? new Date(`${featuredEditData.validityStartDate}T00:00:00`) : new Date()} isClearable
                                        customInput={<input style={inputStyle} readOnly />} wrapperClassName="w-100" popperPlacement="bottom-start"
                                    />
                                </Field>
                            </div>
                            <Field label="Description" required>
                                <textarea style={{ ...inputStyle, height: '66px', padding: '8px 10px', resize: 'vertical' }} name="description" value={featuredEditData.description || ''} placeholder="Brief description" onChange={handleFeaturedEditChange} />
                            </Field>
                            <ExcludedOutletsField value={featuredEditData.excludedOutlets} onChange={(v) => patchFeaturedEdit({ excludedOutlets: v })} outletData={outletData} />
                            <ProductRowsEditor rows={featuredEditProducts} setRows={setFeaturedEditProducts} productOptions={productOptions} outletData={outletData} disabled={featuredEditIsParent} />
                        </Modal.Body>
                        <Modal.Footer style={modalFooterStyle}>
                            <MissingNote items={featuredEditMissing} />
                            <button type="button" style={ghostBtn} onClick={() => setOpenFeaturedEditModal(false)}>Cancel</button>
                            <button type="submit" style={{ ...primaryBtn, opacity: featuredEditInvalid ? 0.5 : 1, cursor: featuredEditInvalid ? 'not-allowed' : 'pointer' }} disabled={featuredEditInvalid}>
                                {isFeaturedEditLoading ? spinner : 'Save Changes'}
                            </button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* ═══════════════ FEATURED — DELETE ═══════════════ */}
                <Modal show={openFeaturedDeleteModal} onHide={() => setOpenFeaturedDeleteModal(false)} centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Delete Featured Category</Modal.Title></Modal.Header>
                    <Modal.Body style={{ padding: '20px', fontSize: '14px', color: T.textMuted }}>
                        Are you sure you want to delete <strong style={{ color: T.textPrimary }}>{selectedFeatured?.name}</strong>? This action cannot be undone.
                        {(featuredSubCountByParent[selectedFeatured?._id] || 0) > 0 && (
                            <div style={{ marginTop: '12px', padding: '10px 12px', background: T.amberLight, color: T.amber, borderRadius: '6px', fontSize: '13px', display: 'flex', gap: '8px' }}>
                                <i className="ri-error-warning-line" />
                                This parent has {plural(featuredSubCountByParent[selectedFeatured._id], 'sub category', 'sub categories')}. Make sure they are moved or removed first.
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={modalFooterStyle}>
                        <button type="button" style={ghostBtn} onClick={() => setOpenFeaturedDeleteModal(false)}>Cancel</button>
                        <button type="button" style={dangerBtn} onClick={deleteFeaturedCategory}>{isFeaturedDeleteLoading ? spinner : 'Delete'}</button>
                    </Modal.Footer>
                </Modal>

                {/* ═══════════════ FEATURED — IMAGE ═══════════════ */}
                <Modal show={openFeaturedImgModal} onHide={() => { setOpenFeaturedImgModal(false); setFeaturedImage(null); }} centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Update Category Image</Modal.Title></Modal.Header>
                    <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        {selectedFeatured?.displayImage && (
                            <img src={selectedFeatured.displayImage} alt="current" style={{ width: '80px', height: '80px', borderRadius: '12px', objectFit: 'cover', border: `1px solid ${T.border}`, alignSelf: 'center' }} />
                        )}
                        <Field label="Choose New Image" hint="jpg, png, webp or avif.">
                            <input style={{ ...inputStyle, height: 'auto', padding: '5px 8px' }} type="file" accept="image/png,image/jpeg,image/webp,image/avif" onChange={(e) => setFeaturedImage(e.target.files[0])} />
                        </Field>
                    </Modal.Body>
                    <Modal.Footer style={modalFooterStyle}>
                        <button type="button" style={ghostBtn} onClick={() => { setOpenFeaturedImgModal(false); setFeaturedImage(null); }}>Cancel</button>
                        <button type="button" style={{ ...primaryBtn, opacity: !featuredImage ? 0.5 : 1, cursor: !featuredImage ? 'not-allowed' : 'pointer' }} onClick={updateFeaturedImage} disabled={!featuredImage}>
                            {isFeaturedImgLoading ? spinner : 'Save Changes'}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* ═══════════════ FEATURED — BANNER ═══════════════ */}
                <Modal show={openFeaturedBannerModal} onHide={() => { setOpenFeaturedBannerModal(false); setFeaturedBannerImage(null); }} centered backdrop="static">
                    <Modal.Header closeButton style={modalHeaderStyle}><Modal.Title style={modalTitleStyle}>Update Banner Image</Modal.Title></Modal.Header>
                    <Modal.Body style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        {selectedFeatured?.bannerImage && (
                            <img src={selectedFeatured.bannerImage} alt="current banner" style={{ width: '100%', height: '60px', objectFit: 'cover', borderRadius: '6px', border: `1px solid ${T.border}` }} />
                        )}
                        <Field label="Choose New Banner (1000×200 px)" hint="Exactly 1000×200 px. jpg, png, webp or avif.">
                            <input style={{ ...inputStyle, height: 'auto', padding: '5px 8px' }} type="file" accept="image/png,image/jpeg,image/webp,image/avif" onChange={(e) => setFeaturedBannerImage(e.target.files[0])} />
                        </Field>
                    </Modal.Body>
                    <Modal.Footer style={modalFooterStyle}>
                        <button type="button" style={ghostBtn} onClick={() => { setOpenFeaturedBannerModal(false); setFeaturedBannerImage(null); }}>Cancel</button>
                        <button type="button" style={{ ...primaryBtn, opacity: !featuredBannerImage ? 0.5 : 1, cursor: !featuredBannerImage ? 'not-allowed' : 'pointer' }} onClick={updateFeaturedBannerImage} disabled={!featuredBannerImage}>
                            {isFeaturedImgLoading ? spinner : 'Save Changes'}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default Category;